// src/config/pricing.js
//
// switchSocketImg / applianceImg / cctvImg / doorbellSecurityImg / fanImg /
// inverterUpsImg / lightImg / mcbFuseImg / stabilizerImg / submeterImg /
// switchboardMainImg / wiringMainImg — real photos for the full
// electrical-services catalog ("Switch & Socket" / "Appliance" / "CCTV" /
// "Doorbell Security" / "Fan" / "Inverter UPS" / "Light" / "MCB / Fuse" /
// "Stabilizer" / "Submeter & Water Sensor" / "Switchboard" / "Wiring"),
// from src/components/images/stage_01/.
import switchSocketImg from "../components/images/stage_01/switch and socket.png";
import applianceImg from "../components/images/stage_01/Home_Appliance.png";
import cctvImg from "../components/images/stage_01/cctv_main.png";
import doorbellSecurityImg from "../components/images/stage_01/doorbell_security_main.png";
import fanImg from "../components/images/stage_01/fan_main.png";
import inverterUpsImg from "../components/images/stage_01/inverter_upsc_main.png";
import lightImg from "../components/images/stage_01/fan_main_1.png";
import mcbFuseImg from "../components/images/stage_01/mcb_fuse_main.png";
import stabilizerImg from "../components/images/stage_01/stablizer_main.png";
import submeterImg from "../components/images/stage_01/submeter_main.png";
import switchboardMainImg from "../components/images/stage_01/switchboard_main.png";
import wiringMainImg from "../components/images/stage_01/wiring_main.png";
import applianceChimneyImg from "../components/images/stage_01/chimney.png";
import applianceGeyserImg from "../components/images/stage_01/geyser.png";
import applianceWashingMachineImg from "../components/images/stage_01/washing_machine.png";
import applianceAcImg from "../components/images/stage_01/ac.png";
import applianceDishwasherImg from "../components/images/stage_01/Dishwasher_Interior.png";
import applianceRefrigeratorImg from "../components/images/stage_01/Refrigerator.png";
import applianceTvImg from "../components/images/stage_01/tv.png";
import applianceSoundbarImg from "../components/images/stage_01/Soundbar.png";
import applianceSpeakerImg from "../components/images/stage_01/speaker.png";
import applianceOvenImg from "../components/images/stage_01/oven.png";
import applianceComputerImg from "../components/images/stage_01/computer.png";
import applianceWaterPurifierImg from "../components/images/stage_01/Water_Purifier.png";
import applianceNotSureImg from "../components/images/stage_01/Electrican_labour.png";
import doorbellSmartImg from "../components/images/stage_01/smart_doorbell.png";
import doorbellVideoImg from "../components/images/stage_01/video_doorbell.png";
import doorbellRegularImg from "../components/images/stage_01/Regular_Doorbell.png";
import doorbellDoorPhoneImg from "../components/images/stage_01/Video_Door_Phone.png";
import doorbellCameraImg from "../components/images/stage_01/Dome_Security_Camera.png";
import fanCeilingImg from "../components/images/stage_01/ceiling_main.png";
import fanWallImg from "../components/images/stage_01/Wall_Fan.png";
import fanExhaustImg from "../components/images/stage_01/Exhaust_Fan_wall.png";
import fanHeavyDutyImg from "../components/images/stage_01/Heavy_Exhaust_Fan.png";
import fanBldcImg from "../components/images/stage_01/BLDC_wireless_Fan.png";
import inverterUpsBatteryImg from "../components/images/stage_01/Battery.png";
import inverterUpsBatteryWaterImg from "../components/images/stage_01/Water_Bottle.png";
import inverterUpsInverterImg from "../components/images/stage_01/Regular_UPS.png";
import inverterUpsUpsImg from "../components/images/stage_01/UPS.png";
import inverterUpsSystemImg from "../components/images/stage_01/UPS_System.png";
import lightLedImg from "../components/images/stage_01/LED_Bulb.png";
import lightCeilingImg from "../components/images/stage_01/LED_Ceiling.png";
import lightDownlightImg from "../components/images/stage_01/LED_Downlight.png";
import lightDecorativeImg from "../components/images/stage_01/Pendant_Light.png";
import lightLuxuryImg from "../components/images/stage_01/luxuary_light.png";
import lightWallImg from "../components/images/stage_01/Wall_light.png";
import switchboard2Img from "../components/images/stage_01/2_Switchboard.png";
import switchboard4Img from "../components/images/stage_01/4_Switchboard.png";
import switchboard6Img from "../components/images/stage_01/6_Switchboard.png";
import switchboard8Img from "../components/images/stage_01/8_Switchboard.png";
import switchboard12Img from "../components/images/stage_01/12_Switchboard.png";
import switchboard16Img from "../components/images/stage_01/16_Switchboard.png";
import submeterElectricImg from "../components/images/stage_01/Electronic_Water_Submeter.png";
import submeterWaterSensorImg from "../components/images/stage_01/Water_Load_Sensor.png";
import submeterBoxImg from "../components/images/stage_01/Sensor_Box.png";
import mcbMainImg from "../components/images/stage_01/Single-Pole_Circuit_Breaker.png";
import mcbBoxImg from "../components/images/stage_01/Electrical_Breaker.png";
import mcbFuseImg2 from "../components/images/stage_01/Fuse.png";
//
// Single source of truth for every price/duration/fee used across the app.
// Mirrors the pattern in src/config/serviceImages.js: components import a
// named export from here instead of hardcoding numbers inline, so a price
// only ever needs to change in one place.
//
// Sections are named after the file/page they belong to. Each section
// preserves that file's own id/key scheme and exact current values — this
// is a relocation, not a repricing. Where two sections happen to cover a
// similar-sounding task (e.g. PaintingService's flat "wall-putty" job price
// vs PRICE_LIST's per-sq-ft "wall-putty" rate) they were ALREADY separate,
// unrelated numbers before this file existed; they're kept separate here
// too rather than silently merged.

// ─────────────────────────────────────────────────────────────────────────
// GLOBAL CHECKOUT / PAYMENT SETTINGS (previously top-level in config.js)
// ─────────────────────────────────────────────────────────────────────────

// Base fare < threshold  → only "Pay Now" shown (must pay at checkout)
// Base fare ≥ threshold  → user can choose "Pay Now" or "Pay After Work"
export const PARTIAL_PAYMENT_THRESHOLD = 1000; // ₹

// Billing formula (SummaryPage and the special-service wizards read this):
//   taxable  = subtotal − (subtotal × DISCOUNT_PERCENT / 100)
//   gst      = taxable × GST_PERCENT / 100
//   total    = taxable + gst + PLATFORM_FEE
export const CHECKOUT_CHARGES = {
  DISCOUNT_PERCENT: 5,   // promotional discount on base fare (%)
  GST_PERCENT:      18,  // GST applied on discounted amount (%)
  PLATFORM_FEE:     20,  // fixed platform/convenience fee per booking (₹)
};

// Partner tip — optional, added on top of the bill before confirmation.
export const PARTNER_TIP = {
  MIN_AMOUNT: 10,             // ₹ — smallest tip allowed if the user adds one
  PRESETS:    [10, 20, 50, 100],
};

// Cancellation charge — % of order total, based on status when cancelled.
// Live values override these from MongoDB via GET /api/order/config/
// Status reference: 0=New (before accept), 1=Accepted, 2=Work Started
export const CANCELLATION_CHARGES = {
  before_accept: { percent: 5,  label: "Before partner accepts"              },
  after_accept:  { percent: 10, label: "After partner accepts, before work"  },
  after_start:   { percent: 15, label: "After work has started"              },
};

// Instant Booking cancellation charges — separate, steeper tiers since a
// partner is already dispatched/en route the moment they accept an instant
// job. Live values override these from MongoDB via GET /api/order/config/instant/
export const INSTANT_CANCELLATION_CHARGES = {
  before_accept: { percent: 0,  label: "Before partner accepts"              },
  after_accept:  { percent: 60, label: "After partner accepts, before arrival" },
  after_start:   { percent: 95, label: "After partner arrived or started work" },
};

// Applied when a service value is NOT listed in PRICE_LIST — the auto
// Mysore-city discount fallback used by getServicePrice() in config.js.
export const MYSORE_DISCOUNT_RULE = { below1000: 50, above1000: 100 };

// Fallback price for any service with no other price source at all.
export const DEFAULT_SERVICE_PRICE = 499;

// ─────────────────────────────────────────────────────────────────────────
// PRICE_LIST — per-sub-service, per-city pricing table (granular tasks:
// mopping, tap-repair, planting, etc.). Read by getServicePrice()/cityPrice()
// as an optional override on top of a component's own base price.
// ─────────────────────────────────────────────────────────────────────────
export const PRICE_LIST = {

  // ── HOME SERVICES ────────────────────────────────────────────────────

  // House Keeping (per room)
  sweeping:                    { base: 1500, mysuru: 1400, bengaluru: 1800 },
  mopping:                     { base: 1500, mysuru: 1400, bengaluru: 1800 },
  dusting:                     { base: 1500, mysuru: 1400, bengaluru: 1800 },
  "bathroom-cleaning-support": { base: 1500, mysuru: 1400, bengaluru: 1800 },
  "kitchen-cleaning-support":  { base: 1500, mysuru: 1400, bengaluru: 1800 },

  // Bathroom Cleaning
  "one-time-deep-clean-1-bathroom": { base:  500, mysuru:  450, bengaluru:  600 },
  "one-time-deep-clean-2-bathroom": { base:  900, mysuru:  850, bengaluru: 1100 },
  "exhaust-fan-cleaning":           { base:  100, mysuru:   50, bengaluru:  130 },
  "wash-basin-cleaning":            { base:  100, mysuru:   50, bengaluru:  130 },
  "mirror-cleaning":                { base:  100, mysuru:   50, bengaluru:  130 },

  // Kitchen Room Cleaning
  "tiles-and-slab-cleaning":    { base: 100, mysuru:  50, bengaluru: 150 },
  "cabinets-trolleys-cleaning": { base: 100, mysuru:  50, bengaluru: 150 },
  "fridge-cleaning":            { base: 100, mysuru:  50, bengaluru: 150 },
  "microwave-cleaning":         { base: 200, mysuru: 150, bengaluru: 250 },
  "gas-stove-cleaning":         { base: 200, mysuru: 150, bengaluru: 250 },
  "other-appliances-cleaning":  { base: 200, mysuru: 150, bengaluru: 250 },
  "ground-mopping":             { base: 100, mysuru:  50, bengaluru: 150 },
  "sink-cleaning":              { base: 200, mysuru: 150, bengaluru: 250 },

  // Cooking
  "breakfast-preparation": { base: 400, mysuru: 350, bengaluru: 500 },
  "lunch-preparation":     { base: 500, mysuru: 450, bengaluru: 650 },
  "dinner-preparation":    { base: 500, mysuru: 450, bengaluru: 650 },
  "veg-cooking":           { base: 600, mysuru: 550, bengaluru: 750 },
  "non-veg-cooking":       { base: 750, mysuru: 700, bengaluru: 950 },

  // Sump and Tank Cleaner
  "underground-sump-cleaning": { base: 1500, mysuru: 1400, bengaluru: 1800 },
  "overhead-tank-cleaning":    { base: 1200, mysuru: 1100, bengaluru: 1500 },
  "plastic-tank-cleaning":     { base: 1000, mysuru:  900, bengaluru: 1300 },
  "cement-tank-cleaning":      { base: 1800, mysuru: 1700, bengaluru: 2200 },
  "water-pipeline-cleaning":   { base: 2000, mysuru: 1900, bengaluru: 2500 },
  "full-sump-tank-cleaning":   { base: 2500, mysuru: 2400, bengaluru: 3000 },

  // Painting Service (flat types by BHK)
  "1bhk": { base: 10000, mysuru:  9900, bengaluru: 12000 },
  "2bhk": { base: 30000, mysuru: 29900, bengaluru: 35000 },
  "4bhk": { base: 50000, mysuru: 49900, bengaluru: 60000 },

  // ── TECHNICAL SERVICES ───────────────────────────────────────────────

  // AC Repair
  "foam-jet-ac-service": { base: 500, mysuru: 450, bengaluru: 650 },
  "general-ac-service":  { base: 500, mysuru: 450, bengaluru: 650 },
  "gas-refill-checkup":  { base: 100, mysuru:  50, bengaluru: 150 },
  "ac-installation":     { base: 100, mysuru:  50, bengaluru: 150 },
  "ac-uninstallation":   { base: 100, mysuru:  50, bengaluru: 150 },

  // Electrical Services
  "fan-repair":                 { base: 500, mysuru: 450, bengaluru: 650 },
  socket_5a:                    { base:  49, mysuru:  49, bengaluru:  69 },
  socket_15a:                   { base:  99, mysuru:  49, bengaluru: 129 },
  "regular-ceiling-fan-repair": { base: 500, mysuru: 450, bengaluru: 649 },
  "exhaust-fan-installation":   { base: 100, mysuru:  50, bengaluru: 149 },
  "fancy-light-installation":   { base: 100, mysuru:  50, bengaluru: 149 },
  "switch-board-repair":        { base: 150, mysuru: 100, bengaluru: 199 },

  // Plumber Services
  "tap-repair":              { base:  199, mysuru:  149, bengaluru:  249 },
  "pipe-leakage-fix":        { base:  349, mysuru:  299, bengaluru:  449 },
  "wash-basin-installation": { base:  599, mysuru:  549, bengaluru:  749 },
  "toilet-repair":           { base:  499, mysuru:  449, bengaluru:  649 },
  "water-tank-cleaning":     { base:  899, mysuru:  849, bengaluru: 1099 },
  "drainage-block-fix":      { base:  399, mysuru:  349, bengaluru:  499 },

  // ── CARE SERVICES ────────────────────────────────────────────────────
  "bedside-care":          { base: 800, mysuru: 750, bengaluru: 1000 },
  "feeding-support":       { base: 500, mysuru: 450, bengaluru:  650 },
  "medication-support":    { base: 450, mysuru: 400, bengaluru:  599 },
  "diaper-changing":       { base: 400, mysuru: 350, bengaluru:  499 },
  "mobility-support":      { base: 600, mysuru: 550, bengaluru:  799 },
  "basic-hygiene-support": { base: 550, mysuru: 500, bengaluru:  699 },

  // ── OUTDOOR SERVICES ─────────────────────────────────────────────────

  // Gardening
  planting:        { base: 150, mysuru: 100, bengaluru: 200 },
  watering:        { base: 100, mysuru:  50, bengaluru: 150 },
  "grass-cutting": { base: 200, mysuru: 150, bengaluru: 280 },
  "weed-removal":  { base: 180, mysuru: 130, bengaluru: 250 },

  // Packers & Movers (outdoor category)
  "pickup-8ft":         { base:  300, mysuru:  250, bengaluru:  450 },
  "truck-1-7-ton":      { base:  380, mysuru:  330, bengaluru:  550 },
  "mini-truck":         { base:  550, mysuru:  500, bengaluru:  750 },
  "large-truck":        { base:  900, mysuru:  850, bengaluru: 1300 },
  "full-home-shifting": { base: 3500, mysuru: 3400, bengaluru: 4999 },

  // Painter (per sq ft)
  "interior-painting": { base: 18, mysuru: 15, bengaluru: 24 },
  "exterior-painting": { base: 25, mysuru: 22, bengaluru: 35 },
  "texture-painting":  { base: 40, mysuru: 37, bengaluru: 55 },
  "wall-putty":        { base:  8, mysuru:  6, bengaluru: 11 },
  "primer-coating":    { base:  5, mysuru:  4, bengaluru:  7 },

  // ── TRANSPORT SERVICES ───────────────────────────────────────────────

  // Car Driver
  only_driver:     { base:  499, mysuru:  449, bengaluru:  649 },
  driver_with_car: { base: 1499, mysuru: 1399, bengaluru: 1899 },

  // Packers and Movers (transport category)
  "house-shifting":  { base: 2499, mysuru: 2399, bengaluru: 3499 },
  "office-shifting": { base: 3999, mysuru: 3899, bengaluru: 5499 },

  // ── UNIFORM PRICING (same across all cities) ─────────────────────────
  // Drinking Water and Insurance services — add city keys only if pricing diverges.
};

// ─────────────────────────────────────────────────────────────────────────
// SPECIAL SERVICES — wizard pricing (Deep Cleaning / Home & Utility
// Cleaning / Rapid Home Cleaning). Admin-editable: change a number here and
// the relevant wizard picks it up on next load.
// ─────────────────────────────────────────────────────────────────────────
export const SPECIAL_SERVICES_PRICING = {
  "deep-cleaning": {
    label: "Deep Home Cleaning",
    sizes: [
      { value: "1bhk", label: "1 BHK",  areaLabel: "600-800 sq.ft",     timeLabel: "4-5 hrs",  standardPrice: 3499 },
      { value: "2bhk", label: "2 BHK",  areaLabel: "1,000-1,400 sq.ft", timeLabel: "5-6 hrs",  standardPrice: 4499 },
      { value: "3bhk", label: "3 BHK",  areaLabel: "1,500-2,000 sq.ft", timeLabel: "6-7 hrs",  standardPrice: 5499 },
      { value: "4bhk", label: "4 BHK",  areaLabel: "2,200-3,000 sq.ft", timeLabel: "7-8 hrs",  standardPrice: 6499 },
      { value: "5bhk", label: "5+ BHK", areaLabel: "3,000-5,000 sq.ft", timeLabel: "8-10 hrs", standardPrice: 7499 },
    ],
    plans: [
      {
        id: "standard", name: "Standard", duration: "4-6 hours", team: "2-3 professionals", surcharge: 0,
        desc: "For regular/thorough surface cleaning.",
        features: ["Floor Cleaning", "Kitchen Cleaning", "Bathroom Cleaning", "Window Cleaning", "Dusting & Wiping"],
      },
      {
        id: "premium", name: "Premium", duration: "6-8 hours", team: "3-4 professionals", surcharge: 2000, badge: "Most Popular",
        desc: "Includes Standard services plus deeper cleaning such as inside cabinets, inside fridge/oven, behind furniture, tough-stain removal and detailed cleaning.",
        features: ["Everything in Standard", "Inside Cabinets Cleaning", "Inside Fridge & Oven Cleaning", "Behind Furniture Cleaning", "Tough Stain Removal"],
      },
    ],
    bookingWindowDays: 7,
  },

  // Kitchen & Utensil Cleaning — no home-size step; the customer picks
  // Standard or Premium directly and that plan's flat `price` applies (not
  // a size-based table like Deep Cleaning). PLACEHOLDER PRICES — no real
  // figures were given; update directly here once supplied.
  "home-utility-cleaning": {
    label: "Kitchen & Utensil Cleaning",
    plans: [
      {
        id: "standard", name: "Standard", price: 999, duration: "2-3 hours", team: "1-2 professionals",
        desc: "Customer prepares and removes items; ClickNido cleans the kitchen, provides basic utensil cleaning, and performs wet-wipe cabinet/drawer cleaning.",
        features: ["Kitchen Platform & Countertop Cleaning", "Basic Utensil Cleaning (15-20 pieces)", "Wet-Wipe Cabinet & Drawer Cleaning", "Refrigerator — Exterior Only"],
      },
      {
        id: "premium", name: "Premium", price: 1799, duration: "5-7 hours", team: "2-3 professionals", badge: "Most Popular",
        desc: "ClickNido handles Remove → Clean → Wash → Dry → Organize → Put Back, including deep utensil cleaning, storage cleaning and appliance interiors.",
        features: ["Everything in Standard", "Remove, Clean, Wash, Dry & Organize", "Deep Utensil & Vessel Washing", "Storage Area & Container Cleaning", "Refrigerator — Inside + Outside"],
      },
    ],
    bookingWindowDays: 6,
  },

  // Rapid Home Cleaning — no property-details step; the customer picks
  // Pre-Fest/Party or Post-Fest/Party, then a visit duration (4hr/6hr) on
  // the Schedule step — price is the combination of both, via
  // `pricesByDuration` (keyed by RapidCleaningPage.js's DURATION_OPTIONS
  // ids: "4hr"/"6hr"). The Select Service step shows the cheaper (4hr)
  // price as a "From ₹X" preview before duration is chosen.
  "rapid-cleaning": {
    label: "Rapid Home Cleaning",
    serviceTypes: [
      {
        id: "pre-festival", name: "Pre-Fest / Party Cleaning", duration: "2-4 hrs", team: "2 Cleaners",
        desc: "Get your home festival-ready", blurb: "Basic cleaning & preparation",
        features: ["Sweeping & Mopping Floors", "Living Room Arrangement", "Dining Area Setup Assistance", "Basic Kitchen Counter Cleaning", "Event Area Preparation"],
        pricesByDuration: { "4hr": 400, "6hr": 800 },
      },
      {
        id: "post-festival", name: "Post-Fest / Party Cleaning", duration: "2-5 hrs", team: "2 Cleaners",
        desc: "Get your home back to normal", blurb: "Thorough cleaning after celebrations",
        features: ["Garbage Collection & Basic Bagging", "Food / Drink Spill Cleanup", "Kitchen Counter Cleanup", "Floor Sweeping & Mopping", "Post-Event Area Arrangement"],
        pricesByDuration: { "4hr": 600, "6hr": 1000 },
      },
    ],
    bookingWindowDays: 6,
  },

  // Balcony & Terrace Cleaning — Step 1 is a "category" pick (Standard vs
  // Premium) plus a "how big is the space" pick; price comes from the
  // matching size tier's `price` inside that category's own list.
  // Admin-editable: change a number here, or add a new tier as
  // another entry in `sizes.standard` / `sizes.premium`.
  "balcony-terrace-cleaning": {
    label: "Balcony, Terrace & Parking Area Cleaning",
    categories: [
      { value: "standard", label: "Standard" },
      { value: "premium",  label: "Premium" },
    ],
    sizes: {
      standard: [
        { value: "100-500",   label: "100 - 500 sq.ft",   price:  799 },
        { value: "500-1000",  label: "500 - 1000 sq.ft",  price: 1299 },
        { value: "1000-1500", label: "1000 - 1500 sq.ft", price: 1799 },
        { value: "1500-2000", label: "1500 - 2000 sq.ft", price: 2299 },
        { value: "2000+",     label: "2000+ sq.ft",       price: 2799 },
      ],
      // Placeholder — same as `standard` until real Premium pricing is
      // supplied; edit these numbers directly, no code change needed.
      premium: [
        { value: "100-500",   label: "100 - 500 sq.ft",   price:  799 },
        { value: "500-1000",  label: "500 - 1000 sq.ft",  price: 1299 },
        { value: "1000-1500", label: "1000 - 1500 sq.ft", price: 1799 },
        { value: "1500-2000", label: "1500 - 2000 sq.ft", price: 2299 },
        { value: "2000+",     label: "2000+ sq.ft",       price: 2799 },
      ],
    },
    bookingWindowDays: 6,
  },

  // Bedroom & Wardrobe Cleaning — same category(Standard/Premium) + size
  // price-matrix pattern as Balcony & Terrace Cleaning above, sized by
  // bedroom count instead of sq.ft. Admin-editable: change a number here,
  // or add a new tier as another entry in `sizes.standard` / `sizes.premium`.
  "bedroom-wardrobe-cleaning": {
    label: "Bedroom & Wardrobe Cleaning",
    categories: [
      { value: "standard", label: "Standard" },
      { value: "premium",  label: "Premium" },
    ],
    // Merged from the original 4 single-bedroom-count tiers (1/2/3/4+) into
    // 2 bedroom-range tiers, each with its own fixed visit duration (see
    // DURATION_BY_AREA_RANGE in BedroomWardrobeCleaningPage.js: 1-3bhk is a
    // 4-hour visit, 4-6bhk is 6 hours). 1-3bhk's price (₹999) is the
    // average of the 3 merged tiers' old prices (599+999+1399); 4-6bhk
    // keeps the old "4+ Bedrooms" tier's price (₹1799) unchanged.
    sizes: {
      standard: [
        { value: "1-3bhk", label: "1-3 Bedrooms + Wardrobe", price:  999 },
        { value: "4-6bhk", label: "4-6 Bedrooms + Wardrobe", price: 1799 },
      ],
      // Placeholder — same as `standard` until real Premium pricing is
      // supplied; edit these numbers directly, no code change needed.
      premium: [
        { value: "1-3bhk", label: "1-3 Bedrooms + Wardrobe", price:  999 },
        { value: "4-6bhk", label: "4-6 Bedrooms + Wardrobe", price: 1799 },
      ],
    },
    bookingWindowDays: 6,
  },

  // Move-In & Move-Out Cleaning — same category+size price-matrix shape as
  // Balcony/Bedroom above, but the "category" here is the service itself
  // (Move-In vs Move-Out) rather than a Standard/Premium tier, since these
  // are two different services sharing one page rather than two quality
  // levels of the same service. PLACEHOLDER PRICES — no real figures were
  // given; update directly here once supplied, no code change needed.
  "move-in-move-out-cleaning": {
    label: "Move-In & Move-Out Cleaning Service",
    categories: [
      { value: "move-in",  label: "Move-In Cleaning" },
      { value: "move-out", label: "Move-Out Cleaning" },
    ],
    sizes: {
      "move-in": [
        { value: "1bhk", label: "1 BHK",  price: 1999 },
        { value: "2bhk", label: "2 BHK",  price: 2999 },
        { value: "3bhk", label: "3 BHK",  price: 3999 },
        { value: "4bhk", label: "4 BHK",  price: 4999 },
        { value: "5bhk", label: "5+ BHK", price: 5999 },
      ],
      "move-out": [
        { value: "1bhk", label: "1 BHK",  price: 1799 },
        { value: "2bhk", label: "2 BHK",  price: 2699 },
        { value: "3bhk", label: "3 BHK",  price: 3599 },
        { value: "4bhk", label: "4 BHK",  price: 4499 },
        { value: "5bhk", label: "5+ BHK", price: 5399 },
      ],
    },
    bookingWindowDays: 6,
  },
};

// Add-on prices for the three special-service wizards (id + name + price
// only — icons/units are UI concerns and stay in the component).
export const DEEP_CLEANING_ADDONS = [
  { id: "sofa_shampoo", name: "Sofa Shampooing",   price: 299 },
  { id: "mattress",     name: "Mattress Cleaning", price: 399 },
  { id: "curtains",     name: "Curtains Cleaning", price: 150 },
];
export const DEEP_CLEANING_MORE_ADDONS = [
  { id: "chimney", name: "Kitchen Chimney Cleaning", price: 249 },
  { id: "balcony", name: "Balcony Deep Clean",        price: 199 },
];

// Deep Cleaning — Step 3 "What's Included" content, split by the plan
// (Standard vs Premium) chosen in Step 2. Admin-editable: edit any list
// here — the page just renders whichever plan is currently selected.
export const DEEP_CLEANING_SCOPE = {
  standard: {
    title: "Standard – Deep Home Cleaning",
    included: [
      "Living Room Floor Sweeping & Mopping",
      "Bedroom Floor Sweeping & Mopping",
      "Kitchen Floor Cleaning & Mopping",
      "Bathroom Floor Cleaning",
      "Dusting of Accessible Furniture",
      "Table, Chair & Basic Furniture Cleaning",
      "Door & Door-Handle Cleaning",
      "Window, Sill & Frame Cleaning",
      "Mirror Cleaning",
      "Fan & Light Exterior Dusting",
      "Switchboard Exterior Wiping",
      "Wall & Tile Surface Wiping",
      "Kitchen Platform & Countertop Cleaning",
      "Sink & Faucet Cleaning",
      "Stove / Cooktop Exterior Cleaning",
      "Cabinet & Drawer Exterior Cleaning",
      "Wardrobe Exterior Cleaning",
      "Basic Bathroom Cleaning",
      "Balcony / Entrance Basic Cleaning",
      "Final Sweeping, Mopping & Basic Sanitization",
    ],
    excluded: [
      "Full Removal of Items from Cabinets / Drawers",
      "Deep Cabinet Interior Cleaning",
      "Full Wardrobe Emptying & Deep Organization",
      "Deep Storage Area Cleaning",
      "Storage Box / Container Cleaning",
      "Heavy Grease Removal",
      "Heavy / Tough Stain Restoration",
      "Deep Grout Cleaning",
      "Chimney Deep Cleaning",
      "Refrigerator Interior Cleaning",
      "Microwave / Oven Interior Cleaning",
      "Dishwasher Interior Cleaning",
      "Mattress Shampooing",
      "Sofa Shampooing / Deep Upholstery Cleaning",
      "Carpet Deep Cleaning",
      "Heavy Furniture Shifting",
      "Appliance Repair / Servicing",
      "Plumbing / Electrical Work",
      "Pest Control",
      "Mold Restoration",
      "Paint / Cement Stain Removal",
      "Marble / Granite Polishing",
      "Water Tank Cleaning",
      "Construction or Hazardous Waste Removal",
    ],
    customerNotes: [
      "Home Preparation: Keep all areas to be cleaned accessible before the team arrives.",
      "Personal Items: Customers should keep personal belongings, documents and valuables safely stored.",
      "Cabinets & Wardrobes: Customer must remove items if interior cabinet or wardrobe cleaning is required beyond the included scope.",
      "Fragile Items: Inform the team about fragile, valuable or sensitive items before cleaning.",
      "Valuables: Remove or securely store cash, jewellery, electronics, documents and other valuables.",
      "Existing Damage: Inform the team about broken, cracked or previously damaged furniture, fittings or surfaces.",
      "Furniture: Heavy furniture that cannot be safely moved may not be cleaned underneath or behind.",
      "Unsafe Areas: Unsafe, unstable, inaccessible or high-risk areas may be excluded.",
      "Hazardous Materials: Do not leave hazardous chemicals, sharp objects or unsafe materials in cleaning areas.",
      "Customer Availability: Customer should remain available for important instructions or decisions during service.",
      "Technical Work: Electrical, plumbing, appliance repair and other technical work are not part of Deep Home Cleaning.",
    ],
  },
  premium: {
    title: "Premium – Deep Home Cleaning",
    included: [
      "Everything included in Standard, plus:",
      "Deep Floor Scrubbing",
      "Deep Cleaning of Corners & Edges",
      "Detailed Furniture Cleaning",
      "Deep Door, Frame & Handle Cleaning",
      "Detailed Window, Sill & Frame Cleaning",
      "Fan & Light Detailed Cleaning",
      "Detailed Switchboard Exterior Cleaning",
      "Deep Wall & Tile Cleaning",
      "Full Kitchen Deep Cleaning",
      "Deep Cabinet & Drawer Interior Cleaning",
      "Storage Area Deep Cleaning",
      "Storage Box / Container Cleaning",
      "Refrigerator — Inside + Outside",
      "Microwave / Oven — Inside + Outside",
      "Dishwasher — Inside + Outside",
      "Chimney Filter & Accessible Interior Cleaning",
      "Full Wardrobe Interior Cleaning",
      "Basic Clothes Arrangement & Organization",
      "Deep Bathroom Cleaning",
      "Hard Water & Soap-Scum Cleaning",
      "Balcony & Entrance Deep Cleaning",
      "Accessible Areas Behind / Under Furniture & Appliances",
      "Complete Home Sanitization",
      "Deodorizing of Service Areas",
      "Final Deep-Clean Inspection",
    ],
    excluded: [
      "Chimney Motor Dismantling / Repair",
      "Appliance Repair / Servicing",
      "Water Purifier Servicing",
      "Gas Leak Detection",
      "Gas Pipeline Disconnection",
      "Plumbing Repairs",
      "Electrical Repairs",
      "Cabinet / Wardrobe Repair",
      "Tile Replacement",
      "Grout Replacement",
      "Pest Control Treatment",
      "Mold Restoration",
      "Mattress Shampooing",
      "Heavy Furniture Dismantling",
      "Permanent Damage Restoration",
      "Paint / Cement Restoration",
      "Marble / Granite Polishing",
      "Water Tank Cleaning",
      "Deep Drain Cleaning",
      "Sewage Line Cleaning",
      "Construction Waste Removal",
      "Hazardous Waste Disposal",
    ],
    customerNotes: [
      "Home Access: Ensure all rooms and required cleaning areas are accessible before the team arrives.",
      "Item Handling: ClickNido professionals can handle included household items as part of the Premium cleaning scope.",
      "Fragile & Valuable Items: Clearly identify fragile, valuable or sensitive items before work begins.",
      "Personal Valuables: Remove or securely store cash, jewellery, documents, electronics and other valuables.",
      "Existing Damage: Previously broken, cracked, loose or damaged items must be identified before service.",
      "Heavy Items: Furniture or appliances will only be moved where it is safe and reasonably accessible.",
      "Appliances: Appliances must be safe to clean and disconnected where required before internal cleaning.",
      "Hazardous Materials: Hazardous chemicals, unsafe materials and restricted items must be removed from service areas.",
      "Unsafe Areas: High-risk, unstable, very high or inaccessible areas may be excluded for safety.",
      "Customer Availability: Customer should remain reachable for important instructions, approvals or decisions.",
      "Cleaning Limitations: Permanent stains, damage, corrosion, mold restoration and material deterioration may not be fully removable.",
      "Technical Work: Electrical, plumbing, appliance repair, gas work and other technical services are excluded.",
    ],
  },
  finalDifference: [
    "Standard: Routine deep cleaning of accessible home surfaces, floors, furniture, kitchen, bathroom, windows and common areas.",
    "Premium: Standard + deeper cleaning, interiors, storage areas, appliances, wardrobe organization, detailed bathroom/kitchen cleaning and sanitization.",
    "Important: Deep cleaning removes dirt, dust, grease and common surface buildup where reasonably removable; it does not guarantee restoration of permanent stains, damaged surfaces, corrosion, mold or material deterioration.",
  ],
};

export const BALCONY_TERRACE_CLEANING_ADDONS = [
  { id: "window_cleaning",          name: "Window Cleaning",           price: 299 },
  { id: "sofa_cleaning",            name: "Sofa Cleaning",             price: 399 },
  { id: "outdoor_furniture_cleaning", name: "Outdoor Furniture Cleaning", price: 349 },
  { id: "potted_plant_cleaning",    name: "Potted Plant Cleaning",     price: 199 },
];

export const BEDROOM_WARDROBE_CLEANING_ADDONS = [
  { id: "mattress_cleaning",    name: "Mattress Cleaning",            price: 399 },
  { id: "curtains_cleaning",    name: "Curtains Cleaning",            price: 150 },
  { id: "wardrobe_organizing",  name: "Wardrobe Interior Organizing", price: 299 },
  { id: "under_bed_cleaning",   name: "Under-bed Deep Cleaning",      price: 199 },
];

// Balcony & Terrace Cleaning — Step 3 "What's Included" content, split by
// the category (Standard vs Premium) the customer picked in Step 1.
// Admin-editable: edit any list here — the page just renders whichever
// category is currently selected.
export const BALCONY_TERRACE_CLEANING_SCOPE = {
  standard: {
    title: "Standard – Balcony & Terrace Cleaning",
    included: [
      "Balcony Floor Sweeping & Mopping",
      "Terrace Floor Sweeping & Basic Cleaning",
      "Removal of Loose Dust, Dirt & Dry Debris",
      "Accessible Corner & Edge Cleaning",
      "Balcony Railing / Grill Dusting & Wiping",
      "Balcony Door & Accessible Frame Cleaning",
      "Terrace Door & Accessible Frame Cleaning",
      "Basic Drain Cover Cleaning",
      "Basic Removal of Cobwebs",
      "Accessible Window Sill Cleaning",
      "Pot Plant Cleaning – Basic Cleaning of Accessible Pots and Surrounding Areas",
      "Basic Sanitization of Balcony / Terrace Areas",
      "Final Sweeping & Cleaning Inspection",
    ],
    excluded: [
      "Parking Area Cleaning",
      "Heavy Dirt / Mud Buildup Removal",
      "Cement / Paint / Construction Stain Removal",
      "Deep Grout Cleaning",
      "Permanent Stain Restoration",
      "Drain Blockage Removal",
      "Drain / Sewage Line Cleaning",
      "Water Tank Cleaning",
      "Heavy Furniture or Equipment Shifting",
      "Pest Control",
      "Mold Restoration",
      "Waterproofing / Leakage Repair",
      "Tile / Flooring Repair or Replacement",
      "Electrical / Plumbing Repairs",
      "Plant Pruning, Trimming or Cutting",
      "Soil Replacement / Repotting",
      "Fertilizer / Pesticide Application",
      "Gardening / Landscaping Work",
      "Construction Waste Removal",
      "Hazardous Waste Disposal",
    ],
    customerNotes: [
      "Area Access: Keep the balcony and terrace accessible before the team arrives.",
      "Personal Items: Remove or securely store personal belongings, footwear, furniture, equipment and valuables.",
      "Vehicles: Parking Area Cleaning is not included in Standard. Customers should not expect parking-area sweeping, mopping or deep cleaning.",
      "Fragile Items: Inform the team about fragile or sensitive items located in the cleaning area.",
      "Existing Damage: Inform the team about cracked tiles, damaged flooring, loose railings, broken grills or other existing damage.",
      "Heavy Items: Heavy furniture, equipment or objects that cannot be safely moved may not be cleaned underneath or behind.",
      "Pot Plants: Keep pots and plant areas accessible for cleaning.",
      "Plant Safety: ClickNido will clean accessible pots and surrounding areas but does not perform gardening, pruning, repotting or plant treatment.",
      "Drain Safety: Only accessible surface-level drain cleaning is included. Blocked drains and sewage-line cleaning are excluded.",
      "Hazardous Materials: Remove chemicals, fuel, sharp objects and other hazardous materials from the service area.",
      "Unsafe Areas: Unsafe, unstable, very high or inaccessible areas may be excluded for safety.",
      "Customer Availability: Customer should remain available for important instructions or decisions.",
    ],
  },
  premium: {
    title: "Premium – Balcony, Terrace & Parking Area Cleaning",
    included: [
      "Everything included in Standard, plus:",
      "Parking Area Sweeping & Deep Cleaning",
      "Deep Balcony Floor Scrubbing",
      "Deep Terrace Floor Scrubbing",
      "Detailed Corner, Edge & Hard-to-Reach Accessible Area Cleaning",
      "Detailed Balcony Railing / Grill Cleaning",
      "Detailed Balcony Door, Frame & Track Cleaning",
      "Detailed Terrace Door & Frame Cleaning",
      "Accessible Wall Surface Deep Cleaning",
      "Detailed Drain Cover Cleaning",
      "Accessible Drain Area Surface Cleaning",
      "Deep Cobweb Removal",
      "Detailed Window Sill & Accessible Frame Cleaning",
      "Pot Plant Cleaning – Detailed Cleaning of Accessible Pots, Leaves & Surrounding Areas",
      "Pot Stand / Plant Shelf Cleaning",
      "Deep Sanitization of Balcony / Terrace Areas",
      "Parking Area Corner & Boundary Cleaning",
      "Accessible Areas Behind / Under Movable Items",
      "Detailed Final Cleaning & Inspection",
    ],
    excluded: [
      "Drain Blockage Removal",
      "Deep Drain / Sewage Line Cleaning",
      "Water Tank Cleaning",
      "Waterproofing Work",
      "Leakage Detection / Repair",
      "Tile / Flooring Repair or Replacement",
      "Cement / Concrete Repair",
      "Permanent Stain Restoration",
      "Heavy Oil / Grease Restoration",
      "Paint / Cement / Construction Stain Restoration",
      "Pest Control Treatment",
      "Mold Restoration",
      "Heavy Furniture / Equipment Dismantling",
      "Vehicle Washing / Detailing",
      "Electrical Repairs",
      "Plumbing Repairs",
      "Construction Waste Removal",
      "Hazardous Waste Disposal",
      "Plant Pruning, Trimming or Cutting",
      "Soil Replacement / Repotting",
      "Plant Relocation",
      "Fertilizer / Pesticide Application",
      "Plant Disease Treatment",
      "Gardening / Landscaping Work",
    ],
    customerNotes: [
      "Area Access: Ensure the balcony, terrace and parking area are fully accessible before the team arrives.",
      "Vehicle Removal: All vehicles should be moved from the parking area before the cleaning team starts.",
      "Item Handling: Movable household items may be handled only where they can be moved safely.",
      "Fragile & Valuable Items: Clearly identify fragile, valuable or sensitive items before cleaning.",
      "Existing Damage: Previously cracked, broken, loose or damaged surfaces and fittings must be identified before service.",
      "Heavy Items: Heavy furniture, equipment or objects will only be moved where safe and reasonably accessible.",
      "Pot Plants: Keep all pots, plant stands and surrounding areas accessible.",
      "Plant Safety: ClickNido will clean accessible pots, leaves and surrounding plant areas; pruning, repotting, soil replacement and plant treatment are excluded.",
      "Drain Safety: Accessible surface-level cleaning is included, but blockage removal and sewage/drain-line cleaning are excluded.",
      "Hazardous Materials: Remove hazardous chemicals, fuel, sharp objects and unsafe materials before service.",
      "Unsafe Areas: High-risk, unstable, very high or inaccessible areas may be excluded for safety.",
      "Customer Availability: Customer should remain reachable for instructions, approvals or decisions.",
      "Cleaning Limitations: Permanent stains, corrosion, damaged surfaces and deeply embedded deposits may not be fully removable.",
      "Technical Work: Waterproofing, plumbing, electrical, drainage repair and other technical work are excluded.",
    ],
  },
  finalDifference: [
    "Standard: Balcony + Terrace Cleaning.",
    "Premium: Balcony + Terrace + Parking Area Cleaning + deeper cleaning.",
    "Pot Plant Cleaning: Included in both plans at the level specified above. Gardening, pruning, repotting, soil replacement and plant treatment are excluded.",
  ],
};

// Bedroom & Wardrobe Cleaning — Step 3 "What's Included" content, split by
// category (Standard vs Premium), same shape as BALCONY_TERRACE_CLEANING_SCOPE
// above. Admin-editable: edit any list here — the page just renders whichever
// category is currently selected. `customerNotes` is the same "Customer
// Responsibility & Safety" note for both plans (duplicated into each so the
// page's per-category lookup stays simple).
const BEDROOM_WARDROBE_CUSTOMER_NOTES = [
  "Pre-existing Damage: ClickNido is not responsible for previously broken, cracked, damaged or defective items.",
  "Valuables: Customers must remove or securely store valuables, cash, jewellery, documents, electronics and fragile items before service.",
  "Customer Supervision: Customer supervision is required in sensitive, fragile, high-value or restricted work areas.",
  "Safety: Unsafe, unstable, inaccessible or high-risk work areas may be excluded from service.",
];

export const BEDROOM_WARDROBE_CLEANING_SCOPE = {
  standard: {
    title: "Standard – Bedroom & Wardrobe Cleaning",
    included: [
      "Bedroom Floor Cleaning",
      "Bedroom Furniture Cleaning",
      "Mirror, Window & Frame Cleaning",
      "Fan, Light & Switchboard Cleaning",
      "Wardrobe Exterior Cleaning",
      "Basic Wardrobe Interior Care",
      "Basic Clothes Arrangement & Folding",
      "Door, Handles & Skirting Cleaning",
    ],
    excluded: [
      "Attached Bathroom Cleaning",
      "Balcony Cleaning",
      "Full Wardrobe Emptying & Deep Organization",
      "Heavy / Tough Stain Removal",
      "Mattress Shampooing",
      "Heavy Furniture Shifting or Dismantling",
      "Pest Control & Mold Restoration",
      "Paint / Cement Stain Removal",
      "Repair or Restoration Work",
    ],
    customerNotes: BEDROOM_WARDROBE_CUSTOMER_NOTES,
  },
  premium: {
    title: "Premium – Bedroom & Wardrobe Cleaning",
    included: [
      "Everything included in Standard, plus:",
      "Deep Bedroom Floor & Corner Cleaning",
      "Detailed Furniture Cleaning",
      "Full Wardrobe Interior Cleaning",
      "Advanced Clothes Arrangement, Folding & Storage Organization",
      "Tough Stain Spot Cleaning",
      "Attached Bathroom Deep Cleaning",
      "Hard Water & Soap-Scum Cleaning",
      "Balcony Deep Cleaning + Pot Plant Cleaning",
      "Sanitization & Deodorizing",
    ],
    excluded: [
      "Pest Control",
      "Mold Restoration",
      "Paint / Cement Stain Removal",
      "Heavy Furniture Dismantling",
      "Mattress Shampooing",
      "Permanent Damage Restoration",
      "Repair / Maintenance Work",
    ],
    customerNotes: BEDROOM_WARDROBE_CUSTOMER_NOTES,
  },
  finalDifference: [
    "Standard: Routine Bedroom & Wardrobe Cleaning.",
    "Premium: Deep Bedroom, Wardrobe, Attached Bathroom & Balcony Cleaning + Organization + Sanitization.",
  ],
};

// Move-In & Move-Out Cleaning — Step 2 add-ons, split by which of the two
// services the customer picked in Step 1 (not a flat shared list like
// Balcony/Bedroom's ADDONS, since Move-In and Move-Out need genuinely
// different add-on catalogues — e.g. "Unpacking Assistance" only makes
// sense for Move-In, "Packing Materials" only for Move-Out).
// Admin-editable: edit any entry's price/name, or add a new one to either
// list — the page renders whichever list matches the selected service.
export const MOVE_IN_MOVE_OUT_ADDONS = {
  "move-in": [
    // Moving Support
    { id: "unpacking_assistance", name: "Unpacking Assistance",     price: 499 },
    { id: "home_arrangement",     name: "Home Arrangement",         price: 399 },
    { id: "kitchen_arrangement",  name: "Kitchen Arrangement",      price: 349 },
    { id: "wardrobe_arrangement", name: "Wardrobe Arrangement",     price: 299 },
    { id: "furniture_arrangement",name: "Furniture Assistance",     price: 349 },
    // Additional Work
    { id: "furniture_polishing",  name: "Furniture Polishing",      price: 599 },
    { id: "marble_polishing",     name: "Marble / Granite Polishing", price: 899 },
    { id: "curtain_installation", name: "Curtain Installation",     price: 249 },
    { id: "shelf_mirror_install", name: "Shelf / Mirror Installation", price: 349 },
    { id: "furniture_assembly",   name: "Basic Furniture Assembly", price: 499 },
    { id: "fixture_installation", name: "Minor Fixture Installation", price: 349 },
    { id: "appliance_positioning",name: "Appliance Positioning",    price: 299 },
  ],
  "move-out": [
    // Moving Support
    { id: "packing_assistance",   name: "Packing Assistance",       price: 499 },
    { id: "furniture_disassembly",name: "Furniture Disassembly",    price: 449 },
    { id: "furniture_packing",    name: "Furniture Assistance",     price: 399 },
    { id: "packing_material_removal", name: "Packing Material Removal", price: 249 },
    { id: "waste_removal",        name: "Waste Removal",            price: 349 },
    // Additional Work
    { id: "furniture_polishing",  name: "Furniture Polishing",      price: 599 },
    { id: "marble_polishing",     name: "Marble / Granite Polishing", price: 899 },
  ],
};

// Same checklist applies whether the customer is moving in or moving out —
// the "Service Purpose" notes below are what actually distinguish the two
// contexts, not the task list itself. Sourced from the client's own
// "Premium" content; admin-editable here.
const MOVE_IN_MOVE_OUT_INCLUDED = [
  "Full Home Floor Deep Cleaning",
  "Living Room Deep Cleaning",
  "Bedroom Deep Cleaning",
  "Kitchen Deep Cleaning",
  "Bathroom Deep Cleaning",
  "Balcony & Terrace Cleaning",
  "Window, Glass, Sill & Frame Cleaning",
  "Door, Door Frame & Handle Cleaning",
  "Fan & Light Exterior Cleaning",
  "Switchboard Exterior Cleaning",
  "Wall & Tile Surface Deep Cleaning",
  "Kitchen Platform & Countertop Deep Cleaning",
  "Sink & Faucet Cleaning",
  "Stove / Cooktop Cleaning",
  "Cabinet & Drawer Interior & Exterior Cleaning",
  "Wardrobe Interior & Exterior Cleaning",
  "Accessible Furniture Cleaning",
  "Refrigerator — Inside & Outside Cleaning",
  "Microwave / Oven — Inside & Outside Cleaning",
  "Accessible Appliance Exterior Cleaning",
  "Chimney Filter & Accessible Interior Cleaning",
  "Deep Floor Scrubbing",
  "Corner, Edge & Accessible Hard-to-Reach Area Cleaning",
  "Basic Pot Plant / Pot Area Cleaning",
  "Cobweb Removal",
  "Complete Home Sanitization",
  "Deodorizing of Service Areas",
  "Final Move-In / Move-Out Cleaning Inspection",
];

const MOVE_IN_MOVE_OUT_EXCLUDED = [
  "Appliance Repair / Servicing",
  "Electrical Repairs",
  "Plumbing Repairs",
  "Gas Pipeline Work",
  "Gas Leak Detection",
  "Chimney Motor Dismantling / Repair",
  "Water Purifier Servicing",
  "Pest Control Treatment",
  "Mold Restoration",
  "Water Tank Cleaning",
  "Deep Drain / Sewage Line Cleaning",
  "Waterproofing / Leakage Repair",
  "Tile / Flooring Replacement",
  "Grout Replacement",
  "Cabinet / Wardrobe Repair",
  "Heavy Furniture Dismantling",
  "Permanent Damage Restoration",
  "Marble / Granite Polishing",
  "Paint / Cement / Construction Stain Restoration",
  "Construction Waste Removal",
  "Hazardous Waste Disposal",
  "Vehicle Washing / Detailing",
  "Plant Pruning / Trimming / Cutting",
  "Soil Replacement / Repotting",
  "Fertilizer / Pesticide Application",
  "Gardening / Landscaping Work",
];

const MOVE_IN_MOVE_OUT_CUSTOMER_NOTES = [
  "Empty Property: For the best result, the property should preferably be vacant or mostly free of movable personal belongings before service.",
  "Access: Customer must provide access to all rooms, cupboards, wardrobes, kitchen areas, bathrooms, balcony/terrace and other areas included in the booking.",
  "Personal Belongings: Remove or securely store cash, jewellery, documents, electronics and other valuables before the team arrives.",
  "Existing Damage: Inform the team about pre-existing cracks, broken fittings, damaged surfaces, loose fixtures or other existing damage.",
  "Furniture & Heavy Items: Heavy furniture or appliances will only be moved where it is safe and reasonably accessible.",
  "Appliances: Appliances must be safe to clean and disconnected where required before internal cleaning.",
  "Kitchen & Storage: Remove food, hazardous materials and unsafe items from areas requiring cleaning.",
  "Fragile Items: Clearly identify fragile, valuable or sensitive items before cleaning.",
  "Pot Plants: Keep accessible pots and plant areas available for cleaning. Plant care, pruning, repotting and treatment are not included.",
  "Cleaning Limitations: Permanent stains, corrosion, damaged surfaces, mold and material deterioration may not be completely removable.",
  "Unsafe Areas: Very high, unstable, inaccessible or hazardous areas may be excluded for safety.",
  "Waste: Construction debris, hazardous waste and large-scale unwanted-item disposal are not included.",
  "Customer Availability: Customer or an authorized representative should remain reachable during the service for important instructions or decisions.",
  "Technical Work: Electrical, plumbing, gas, appliance repair and other technical work are not included.",
  "Important: Move-In & Move-Out Cleaning is a cleaning service, not a repair, restoration, pest-control, gardening or waste-disposal service.",
];

// Move-In & Move-Out Cleaning — Step 3 "What's Included" content, split by
// which of the two services the customer picked in Step 1. Admin-editable:
// edit any list here — the page just renders whichever service is selected.
export const MOVE_IN_MOVE_OUT_CLEANING_SCOPE = {
  "move-in": {
    title: "Move-In Cleaning — Start Fresh in a Clean Home",
    included: MOVE_IN_MOVE_OUT_INCLUDED,
    excluded: MOVE_IN_MOVE_OUT_EXCLUDED,
    customerNotes: [
      ...MOVE_IN_MOVE_OUT_CUSTOMER_NOTES,
      "Service Purpose: Prepare the property for occupancy by providing comprehensive cleaning and sanitization of accessible areas.",
    ],
  },
  "move-out": {
    title: "Move-Out Cleaning — Leave Your Home Clean & Ready for Handover",
    included: MOVE_IN_MOVE_OUT_INCLUDED,
    excluded: MOVE_IN_MOVE_OUT_EXCLUDED,
    customerNotes: [
      ...MOVE_IN_MOVE_OUT_CUSTOMER_NOTES,
      "Service Purpose: Clean the property after the customer vacates it, covering accessible rooms, kitchen, bathrooms, storage areas and common surfaces.",
    ],
  },
};

export const HOME_UTILITY_CLEANING_ADDONS = [
  { id: "fridge",     name: "Fridge Deep Cleaning",  price: 249 },
  { id: "chimney",    name: "Chimney Deep Cleaning", price: 299 },
  { id: "water_tank", name: "Water Tank Cleaning",   price: 399 },
];
export const HOME_UTILITY_CLEANING_MORE_ADDONS = [
  { id: "balcony",  name: "Balcony Deep Clean",      price: 199 },
  { id: "cabinets", name: "Inside Cabinet Cleaning", price: 249 },
];

// Kitchen & Utensil Cleaning — Step "What's Included" content, split by the
// plan (Standard vs Premium) chosen in Step 1. Admin-editable: edit any
// list here — the page just renders whichever plan is currently selected.
export const KITCHEN_UTILITY_CLEANING_SCOPE = {
  standard: {
    title: "Standard – Kitchen & Utensil Cleaning",
    included: [
      "Kitchen Platform & Countertop Cleaning",
      "Sink & Faucet Cleaning",
      "Stove / Cooktop Cleaning",
      "Chimney & Exhaust — Exterior Cleaning",
      "Cabinet & Drawer — Exterior + Interior Wet Wipe",
      "Refrigerator — Exterior Cleaning",
      "Microwave — Exterior Cleaning",
      "Oven — Exterior Cleaning",
      "Other Appliance — Exterior Cleaning",
      "Basic Utensil Cleaning — 15-20 pieces",
      "Kitchen Floor Cleaning & Mopping",
      "Wall & Tile Surface Cleaning",
      "Window, Sill & Ventilation Cleaning",
      "Cabinet & Drawer Handle Cleaning",
      "Basic Sanitization",
      "Final Kitchen Cleaning & Inspection",
    ],
    excluded: [
      "Team Removal of Cabinet / Drawer Items",
      "Deep Cabinet / Drawer Interior Cleaning",
      "Full Utensil Cleaning from Cabinets / Drawers",
      "Heavy / Burnt Utensil Cleaning",
      "Utensil Polishing",
      "Refrigerator Interior Cleaning",
      "Microwave Interior Cleaning",
      "Oven Interior Cleaning",
      "Dishwasher Interior Cleaning",
      "Deep Chimney Filter Cleaning",
      "Heavy Grease Buildup Removal",
      "Heavy Stain Restoration",
      "Deep Storage Area Cleaning",
      "Storage Box / Container Cleaning",
      "Kitchen Organization",
      "Behind-Appliance Deep Cleaning",
      "Deep Grout Cleaning",
      "Appliance Repair / Servicing",
      "Plumbing / Electrical Work",
      "Pest Control",
    ],
    customerNotes: [
      "Cabinet & Drawer Preparation: Customer must remove all items from cabinets and drawers before the team arrives.",
      "Items After Cleaning: Customer is responsible for putting the removed items back after cleaning.",
      "Kitchen Access: Keep the kitchen accessible and ready for service.",
      "Fragile & Valuable Items: Inform the team about fragile, valuable or sensitive items before cleaning.",
      "Personal Valuables: Remove or securely store cash, jewellery, documents and other personal valuables.",
      "Existing Damage: Inform the team about broken, cracked or previously damaged items before service.",
      "Utensil Condition: Utensils with severe burns, damage or unsafe conditions may be excluded from cleaning.",
      "Hazardous Materials: Do not keep hazardous, chemical or unsafe materials in areas being cleaned.",
      "Customer Availability: Customer should remain available for important instructions or decisions during service.",
      "Service Duration: Standard approximately 2-3 hours / 1-2 professionals.",
      "Refrigerator: Standard exterior only.",
      "Technical Work: Electrical, plumbing, appliance repair or other technical work is not included in Kitchen & Utensil Cleaning.",
    ],
  },
  premium: {
    title: "Premium – Kitchen & Utensil Cleaning",
    included: [
      "Everything included in Standard, plus:",
      "Full Cabinet & Drawer Deep Cleaning",
      "Team Removal & Safe Handling of Stored Items",
      "Deep Cleaning of Shelves, Corners, Edges & Interiors",
      "Storage Area Deep Cleaning",
      "Storage Box & Container Cleaning",
      "All Utensils & Vessels Deep Washing",
      "Utensil Scrubbing, Rinsing, Drying & Organization",
      "Refrigerator — Inside + Outside",
      "Microwave — Inside + Outside",
      "Oven — Inside + Outside",
      "Dishwasher — Inside + Outside",
      "Accessible Small Appliance Cleaning",
      "Chimney Filter & Accessible Interior Cleaning",
      "Heavy Grease Cleaning",
      "Deep Floor Scrubbing",
      "Deep Wall & Tile Cleaning",
      "Accessible Area Behind / Under Appliances",
      "Complete Kitchen Sanitization",
      "Kitchen Storage Organization",
      "Items Organized & Put Back",
      "Final Quality Inspection",
    ],
    excluded: [
      "Chimney Motor Dismantling",
      "Chimney Repair",
      "Appliance Repair / Servicing",
      "Water Purifier Servicing",
      "Gas Leak Detection",
      "Gas Pipeline Disconnection",
      "Plumbing Repairs",
      "Electrical Repairs",
      "Cabinet Repair",
      "Tile Replacement",
      "Grout Replacement",
      "Pest Control Treatment",
      "Water Tank Cleaning",
      "Construction Waste Removal",
      "Hazardous Waste Disposal",
      "Marble / Granite Polishing",
      "Deep Drain Cleaning",
      "Sewage Line Cleaning",
    ],
    customerNotes: [
      "Item Handling: ClickNido professionals will remove items from cabinets and drawers, clean them and safely handle them during the service.",
      "Organization & Put-Back: ClickNido professionals will organize the cleaned items and put them back after cleaning.",
      "Kitchen Access: Keep the kitchen accessible and ready for service.",
      "Fragile & Valuable Items: Inform the team about fragile, valuable or sensitive items before cleaning.",
      "Personal Valuables: Remove or securely store cash, jewellery, documents and other personal valuables.",
      "Existing Damage: Inform the team about broken, cracked or previously damaged items before service.",
      "Utensil Condition: Utensils with severe burns, damage or unsafe conditions may be excluded from cleaning.",
      "Hazardous Materials: Do not keep hazardous, chemical or unsafe materials in areas being cleaned.",
      "Customer Availability: Customer should remain available for important instructions or decisions during service.",
      "Service Duration: Premium approximately 5-7 hours / 2-3 professionals.",
      "Refrigerator: Premium inside + outside.",
      "Technical Work: Electrical, plumbing, appliance repair or other technical services are excluded.",
    ],
  },
};

export const RAPID_CLEANING_ADDONS = [
  { id: "sofa_shampoo",    name: "Sofa Shampooing",               unit: "Seat", price: 4929 },
  { id: "chimney_deep",    name: "Chimney Deep Cleaning",         unit: "",     price: 799 },
  { id: "heavy_utensil",   name: "Heavy Utensil Cleaning",        unit: "",     price: 399 },
  { id: "fridge_interior", name: "Refrigerator Interior Cleaning",unit: "",     price: 599 },
];

// Rapid Home Cleaning — "What's Included" content, split by the service
// type (Pre-Fest/Party vs Post-Fest/Party) chosen in Step 1. Admin-editable:
// edit any list here — the page just renders whichever type is selected.
export const RAPID_CLEANING_SCOPE = {
  "pre-festival": {
    title: "Pre-Fest / Party — Rapid Home Cleaning",
    included: [
      "Sweeping & Mopping Floors",
      "Dusting Visible Surfaces",
      "Sofa, Table & Furniture Wiping",
      "Living Room Arrangement",
      "Entrance / Balcony Quick Cleaning",
      "Dining Area Setup Assistance",
      "Bathroom Quick Refresh",
      "Basic Kitchen Counter Cleaning",
      "Basic Kitchen Area Arrangement",
      "Light Decoration Arrangement Support",
      "Garbage Collection & Basic Bagging",
      "Event Area Preparation",
      "Basic Table & Chair Arrangement",
      "Basic Food Serving/Serving Area Preparation",
      "Basic Visible Stain Cleanup",
      "Utensil Cleaning",
      "Food Preparation",
    ],
    excluded: [
      "Deep Stain Removal",
      "Heavy Furniture Shifting",
      "Full Event Decoration",
      "Deep Kitchen Cleaning",
      "Deep Appliance Cleaning",
      "Ceiling / Wall Deep Cleaning",
      "Carpet / Sofa Shampooing",
      "Heavy Grease Removal",
      "Appliance Repair / Servicing",
      "Electrical Decoration / Wiring Work",
      "Plumbing / Electrical Repairs",
      "Pest Control",
      "Construction / Hazardous Waste Disposal",
      "Heavy-Duty Cleaning",
      "Permanent Stain Restoration",
    ],
    customerNotes: [
      "Home Access: Customer must provide access to all areas included in the booking before the team arrives.",
      "Personal Belongings: Keep cash, jewellery, documents, electronics and other valuables safely stored.",
      "Event Items: Keep decorations, serving items, food items and other event materials ready for arrangement.",
      "Furniture: Heavy furniture will not be shifted unless it can be moved safely and easily.",
      "Fragile Items: Inform the team about fragile, valuable or sensitive items before service.",
      "Decoration Support: Basic decoration arrangement support is included; professional decoration, installation or dismantling is not included.",
      "Electrical Safety: Staff will not perform electrical wiring, connections, repairs or modification of decorative electrical systems.",
      "Kitchen & Food: Food preparation, cooking and grocery shopping are not included unless separately booked.",
      "Bathroom: Service covers a quick refresh, not deep bathroom cleaning or restoration.",
      "Waste: Normal household/event preparation waste can be collected and bagged; construction, hazardous or specialized waste is excluded.",
      "Stains: Basic visible stain/spill cleanup is included; permanent or heavy stains may remain.",
      "Pot Plants: Basic cleaning around accessible pots may be provided; pruning, repotting and plant treatment are excluded.",
      "Unsafe Areas: High, unstable, inaccessible or hazardous areas may be excluded for safety.",
      "Customer Availability: Customer or an authorized representative should remain reachable for important instructions.",
    ],
  },
  "post-festival": {
    title: "Post-Fest / Party — Rapid Home Cleaning",
    included: [
      "Garbage Collection & Basic Bagging",
      "Normal Event Waste Segregation Support",
      "Floor Sweeping & Mopping",
      "Food / Drink Spill Cleanup",
      "Table & Furniture Wiping",
      "Kitchen Counter Cleanup",
      "Bathroom Quick Cleaning",
      "Dusting Visible Mess",
      "Basic Stain Cleanup",
      "Dining Area Cleanup",
      "Living Room Quick Arrangement",
      "Entrance / Balcony Quick Cleaning",
      "Basic Table & Chair Arrangement",
      "Basic Sanitization of Service Areas",
      "Post-Event Area Arrangement",
      "Normal Food/Event Waste Collection",
    ],
    excluded: [
      "Hazardous Waste Disposal",
      "Construction Waste Removal",
      "Heavy Furniture Shifting",
      "Deep Stain Removal / Restoration",
      "Carpet / Sofa Shampooing",
      "Deep Appliance Cleaning",
      "Deep Kitchen Cleaning",
      "Heavy Grease Removal",
      "Deep Ceiling / Wall Cleaning",
      "Appliance Repair / Servicing",
      "Plumbing / Electrical Repairs",
      "Pest Control",
      "Sewage / Deep Drain Cleaning",
      "Permanent Surface Damage Restoration",
      "Gardening / Plant Treatment",
      "Hazardous Chemical or Biohazard Cleanup",
    ],
    customerNotes: [
      "Area Access: Customer must provide access to all areas requiring post-event cleaning.",
      "Valuables: Secure cash, jewellery, documents, electronics and other valuables before the team arrives.",
      "Event Waste: Customer should identify normal event waste and items approved for disposal.",
      "Waste Segregation: Basic segregation and bagging of normal household/event waste is included.",
      "Hazardous Waste: Chemicals, sharps, biohazardous materials and other hazardous waste must not be included with normal service waste.",
      "Food Waste: Customer should identify leftover food or food items that may be discarded.",
      "Broken Items: Inform the team about broken glass, damaged decorations or sharp objects before cleaning.",
      "Spills: Normal food and drink spills can be cleaned; permanent stains or surface damage may not be removable.",
      "Furniture: Heavy furniture or equipment will not be shifted where unsafe or difficult to move.",
      "Decoration: Basic post-event arrangement is included; professional decoration dismantling or technical removal is excluded.",
      "Electrical Decorations: Staff will not disconnect, repair or modify electrical wiring or decorative electrical installations.",
      "Kitchen: Basic counter cleanup is included; deep kitchen cleaning and heavy grease removal are excluded.",
      "Appliances: Basic visible cleaning is covered where specified; deep internal appliance cleaning is excluded.",
      "Plants: Basic cleaning around accessible plant areas may be provided; pruning, repotting, soil replacement and treatment are excluded.",
      "Cleaning Limitations: Heavy stains, permanent damage, corrosion and material deterioration may not be completely removable.",
      "Unsafe Areas: Hazardous, unstable, very high or inaccessible areas may be excluded.",
      "Customer Availability: Customer or an authorized representative should remain reachable for disposal or arrangement decisions.",
    ],
  },
  finalDifference: [
    "Pre-Fest / Party: Clean → Arrange → Prepare → Help Ready the Home.",
    "Post-Fest / Party: Collect Normal Waste → Clean Spills → Wipe → Arrange → Freshen the Home.",
    "Important: Rapid Home Cleaning is intended for quick cleaning and basic event assistance. It is not a deep-cleaning, professional decoration, repair, restoration, pest-control or hazardous-waste service.",
  ],
};

// Note: the "post a requirement" flow's gardening pricing (planting/
// watering/grass-cutting/weed-removal) lives in SERVICE_CONFIG_CATALOG
// below (outdoor-services → gardening-service → requirementFields.
// serviceNeeds) — it was moved there wholesale from config.js, so it
// isn't duplicated here.

// ─────────────────────────────────────────────────────────────────────────
// SERVICE LISTING PAGES — the "starting price" + duration shown on each
// category's card grid (src/components/services/*.js). Keyed by that
// page's own local id.
// ─────────────────────────────────────────────────────────────────────────

export const SPECIAL_SERVICES_LISTING = {
  1: { price: 1999, duration: "2-5 Hrs" }, // Rapid Home Cleaning
  2: { price: 1499, duration: "4-6 Hrs" }, // Deep Cleaning
  4: { price: 1299, duration: "4-5 Hrs" }, // Move-in / Move-out Cleaning
  5: { price:  899, duration: "2-3 Hrs" }, // Kitchen & Utensil Cleaning
  6: { price:  799, duration: "2-4 Hrs" }, // Balcony, Terrace & Parking Area Cleaning
  7: { price:  599, duration: "2-4 Hrs" }, // Bedroom & Wardrobe Cleaning
};

export const CARETAKER_SERVICES = {
  "cs-1": { price: 499,  duration: "4 Hrs"  }, // Baby Care
  "cs-2": { price: 699,  duration: "6 Hrs"  }, // Elder Caretaker
  "cs-3": { price: 799,  duration: "8 Hrs"  }, // Patient Care
  "cs-9": { price: 1099, duration: "12 Hrs" }, // Medical / Home Nursing
};

// Note: Corporate Services pricing (CORPORATE_SERVICES / CORPORATE_SERVICE_DETAIL)
// was removed — the corporate-services page is now a "Coming Soon" placeholder
// with no service cards or sub-service picker.

export const HOME_SERVICES = {
  // hs-1/hs-6/hs-9/hs-10 were converted from per-room pricing to
  // duration-sold Instant (Quick Services Access parity) — price is now
  // the per-30-min-block rate, same contract as hs-11 below. Price is a
  // placeholder (₹0) until the real per-30-min rate is set here.
  "hs-1": { price: 0, duration: "30 min – 4 Hrs" }, // Kitchen Cleaning
  "hs-2": { price: 0, duration: "30 min – 4 Hrs" }, // Bathroom Cleaning
  "hs-4": { price: 0, duration: "30 min – 4 Hrs" }, // Balcony Cleaning
  "hs-9": { price: 0, duration: "30 min – 4 Hrs" }, // Window and Glass Cleaning
  "hs-10": { price: 0, duration: "30 min – 4 Hrs" }, // Packing & Unpacking
  // Instant CN Pro (was "Instant Special") — bundled Kitchen + Bathroom +
  // Living Room + Glass + Balcony cleaning, sold by duration (30-min
  // blocks, up to 4 Hrs) instead of per-room. `price` here is the
  // per-30-min-block rate — admin-editable from the Dashboard's
  // Enable/Disable table, same as every other hs-*.
  "hs-11": { price: 199, duration: "30 min – 4 Hrs" }, // Instant CN Pro
  // Instant CN Plus — same bundled scope as CN Pro, verified/company
  // professional instead of a partner. Placeholder ₹0 until priced.
  "hs-cn-plus": { price: 0, duration: "30 min – 4 Hrs" }, // Instant CN Plus

  // Quick Services Access parity — duration-sold Instant services with no
  // existing room-based category. All placeholder ₹0/30-min until real
  // pricing is set here (per-service, same as every other hs-* above).
  "hs-rangoli":                 { price: 0, duration: "30 min – 4 Hrs" }, // Rangoli Art
  "hs-fish-tank":                { price: 0, duration: "30 min – 4 Hrs" }, // Fish Tank Cleaning
  "hs-showcase":                 { price: 0, duration: "30 min – 4 Hrs" }, // Showcase Cleaning
  "hs-chimney":                  { price: 0, duration: "30 min – 4 Hrs" }, // Chimney Cleaning
  "hs-microwave-oven":           { price: 0, duration: "30 min – 4 Hrs" }, // Microwave & Oven Cleaning
  "hs-kitchen-cabinet":          { price: 0, duration: "30 min – 4 Hrs" }, // Kitchen Cabinet Cleaning
  "hs-wardrobe":                 { price: 0, duration: "30 min – 4 Hrs" }, // Wardrobe Arrangement
  "hs-bedroom-arrangement":      { price: 0, duration: "30 min – 4 Hrs" }, // Bedroom Arrangement
  "hs-outside-spaces":           { price: 0, duration: "30 min – 4 Hrs" }, // Outside Spaces Cleaning
  "hs-fan-switchboard-ceiling":  { price: 0, duration: "30 min – 4 Hrs" }, // Fan & Ceiling Cleaning
  "hs-furniture":                { price: 0, duration: "30 min – 4 Hrs" }, // Furniture Cleaning
  "hs-dusting-wiping":           { price: 0, duration: "30 min – 4 Hrs" }, // Dusting & Wiping
  "hs-sweeping-mopping":         { price: 0, duration: "30 min – 4 Hrs" }, // Sweeping & Mopping
  "hs-food-prep":                { price: 0, duration: "30 min – 4 Hrs" }, // Food Preparation
  "hs-utensil":                  { price: 0, duration: "30 min – 4 Hrs" }, // Utensil Cleaning
  "hs-fridge":                   { price: 0, duration: "30 min – 4 Hrs" }, // Fridge Cleaning
  "hs-steps-grills-parking":     { price: 0, duration: "30 min – 4 Hrs" }, // Steps & Parking Space Cleaning
};

export const OUTDOOR_SERVICES = {
  "os-1": { price: 299, duration: "2-3 Hrs" }, // Gardening Service
  "os-6": { price: 199, duration: "1 Hr"    }, // Car Wash at Home
};

export const TECHNICAL_SERVICES = {
  "tech-1": { price: 249, duration: "1-2 Hrs" }, // Plumbing Service
  "tech-2": { price: 299, duration: "1-2 Hrs" }, // Electrical Service
  "tech-3": { price: 399, duration: "2-3 Hrs" }, // AC Service
  "tech-4": { price: 349, duration: "2-3 Hrs" }, // Carpenter Service
  "tech-5": { price: 499, duration: "3-4 Hrs" }, // Painting Service
  "tech-9": { price: 449, duration: "2-3 Hrs" }, // Pest Control
};

export const TRANSPORT_SERVICES = {
  1: { price: 1499, duration: "4-6 Hrs" }, // Packers & Movers
};

// ─────────────────────────────────────────────────────────────────────────
// SUB-SERVICE DETAIL PAGES (src/components/workerspage/**) — keyed by the
// page's own local item id.
// ─────────────────────────────────────────────────────────────────────────

// Kitchen Room Cleaning — one base package (Utensils/Stove/Slab/Chimney,
// always included) plus toggle add-ons, in 30-min blocks up to a 4-hour cap.
// NOTE: rough placeholder prices — update with real values.
export const KITCHEN_ROOM_CLEANING_BASE = {
  price: 749, // price for the first 30-min block
  perBlockPrice: 199, // price per additional 30-min block
};

export const KITCHEN_ROOM_CLEANING_ADDONS = {
  "krc-addon-sweep-mop": 149, // Sweeping & Mopping
  "krc-addon-dust-wipe": 199, // Dusting & Wiping
  "krc-addon-food-prep": 199, // Food Preparation
  "krc-addon-cabinet": 199, // Kitchen Cabinet Cleaning
  "krc-addon-fridge": 249, // Refrigerator Cleaning
  "krc-addon-microwave": 199, // Microwave/Oven Cleaning
  "krc-addon-window-fan-switch": 199, // Window, Fan & Switchboard Cleaning
};

// Bathroom Cleaning — same instant-booking shape as Kitchen Room Cleaning:
// one base package (Toilet & Commode / Wash Basin / Mirror / Exhaust Fan,
// always included) plus toggle add-ons, in 30-min blocks up to a 4-hour cap.
// NOTE: rough placeholder prices — update with real values.
export const BATHROOM_ROOM_CLEANING_BASE = {
  price: 399, // price for the first 30-min block
  perBlockPrice: 149, // price per additional 30-min block
};

export const BATHROOM_ROOM_CLEANING_ADDONS = {
  "brc-addon-sweep-mop": 149, // Sweeping & Mopping
  "brc-addon-dust-wipe": 149, // Dusting & Wiping
  "brc-addon-balcony": 199, // Balcony Cleaning
  "brc-addon-window-fan-switch": 199, // Window, Fan & Switchboard Cleaning
};

// Balcony Cleaning — same instant-booking shape as Kitchen/Bathroom/Bedroom
// Room Cleaning: one base package (Floor Sweeping & Mopping / Railing & Grill
// Cleaning / Cobweb Removal / Window & Glass Cleaning, always included) plus
// toggle add-ons, in 30-min blocks up to a 4-hour cap.
// NOTE: rough placeholder prices — update with real values.
export const BALCONY_CLEANING_BASE = {
  price: 299, // price for the first 30-min block
  perBlockPrice: 119, // price per additional 30-min block
};

export const BALCONY_CLEANING_ADDONS = {
  "blc-addon-furniture": 199, // Furniture Cleaning
  "blc-addon-display-cabinet": 199, // Display Cabinet Cleaning
  "blc-addon-bed-arrangement": 149, // Bed Arrangement
  "blc-addon-dust-wipe": 149, // Dusting & Wiping
};

// Sofa & Cushion Cleaning — same instant-booking shape as the other Home
// Service pages: one base package (Sofa Deep Vacuuming / Stain Removal /
// Cushion Cover Cleaning / Armrest & Back Panel Cleaning, always included)
// plus toggle add-ons, in 30-min blocks up to a 4-hour cap.
// NOTE: rough placeholder prices — update with real values.
export const SOFA_CUSHION_CLEANING_BASE = {
  price: 299, // price for the first 30-min block
  perBlockPrice: 129, // price per additional 30-min block
};

export const SOFA_CUSHION_CLEANING_ADDONS = {
  "sc-addon-living-room": 249, // Living Room Cleaning
  "sc-addon-display-cabinet": 199, // Display Cabinet Cleaning
  "sc-addon-bed-arrangement": 149, // Bed Arrangement
  "sc-addon-fan-ceiling": 149, // Fan & Ceiling Cleaning
  "sc-addon-window-fan-switch": 199, // Window, Fan & Switchboard Cleaning
};

// Floor Mopping — same instant-booking shape as the other Home Service
// pages: one base package (Dry Sweep / Wet Mopping / Sanitization / Corner
// & Edge Cleaning, always included) plus toggle add-ons, in 30-min blocks
// up to a 4-hour cap.
// NOTE: rough placeholder prices — update with real values.
export const FLOOR_MOPPING_BASE = {
  price: 199, // price for the first 30-min block
  perBlockPrice: 79, // price per additional 30-min block
};

export const FLOOR_MOPPING_ADDONS = {
  "fm-addon-furniture": 199, // Furniture Cleaning
  "fm-addon-display-cabinet": 199, // Display Cabinet Cleaning
  "fm-addon-balcony": 199, // Balcony Cleaning
  "fm-addon-bed-arrangement": 149, // Bed Arrangement
  "fm-addon-dust-wipe": 149, // Dusting & Wiping
};

// Window & Glass Cleaning — same instant-booking shape as the other Home
// Service pages: one base package (Glass Pane Cleaning / Frame & Track
// Cleaning / Mesh & Grille Cleaning / Sill Cleaning, always included) plus
// toggle add-ons, in 30-min blocks up to a 4-hour cap.
// NOTE: rough placeholder prices — update with real values.
export const WINDOW_GLASS_CLEANING_BASE = {
  price: 249, // price for the first 30-min block
  perBlockPrice: 99, // price per additional 30-min block
};

export const WINDOW_GLASS_CLEANING_ADDONS = {
  "wg-addon-laundry": 149, // Laundry
  "wg-addon-bed-arrangement": 149, // Bed Arrangement
  "wg-addon-living-room": 249, // Living Room Cleaning
};

// Packing & Unpacking — same instant-booking shape as the other Home
// Service pages: one base package (Packing of Belongings / Unpacking &
// Placement / Box Labeling & Organisation / Fragile Item Handling, always
// included) plus toggle add-ons, in 30-min blocks up to a 4-hour cap.
// NOTE: rough placeholder prices — update with real values.
export const PACKING_UNPACKING_BASE = {
  price: 299, // price for the first 30-min block
  perBlockPrice: 129, // price per additional 30-min block
};

export const PACKING_UNPACKING_ADDONS = {
  "pu-addon-wardrobe": 199, // Wardrobe Arrangement
  "pu-addon-laundry": 149, // Laundry
  "pu-addon-ironing": 149, // Ironing
  "pu-addon-bed-arrangement": 149, // Bed Arrangement
};

// Gardening.js's own booking-flow fallback list (distinct from the
// "post a requirement" pricing in SERVICE_CONFIG_CATALOG's
// gardening-service section).
export const GARDENING_FALLBACK_SERVICES = {
  "garden-cleaning":   499,
  "grass-cutting":     399,
  "plant-maintenance": 299,
};

export const PAINTING_SERVICE = {
  "interior-painting": 2499,
  "exterior-painting": 3499,
  "wall-putty":         1999,
  "touchup-painting":    999,
};

// ─────────────────────────────────────────────────────────────────────────
// MEMBERSHIP / SUBSCRIPTION PLANS — src/components/membership/membershipPlansData.js
// ─────────────────────────────────────────────────────────────────────────
export const MEMBERSHIP_PLAN_PRICES = {
  "weekly-care":      299,
  "monthly-care":      2000,
  // PLACEHOLDER PRICE — no ₹ figure was given for the Mid-Month Plan
  // (14 visits / 18 days) rewrite; update once the real price is supplied.
  "premium-family":    2999,
  "silver-package":    599,
  "golden-package":    1499,
  "platinum-package":  3999,
};

// How many members can share the same (plan, start date, preferred visit
// slot) combination — reflects how many partner teams are available to
// cover that recurring slot. Once a slot's seats are used up, nobody else
// can book it — same atomic-reservation "schedule concept" used for
// regular service bookings.
//
// Reference values only — the numbers actually ENFORCED live in MongoDB
// (digi_labour.config_seat_availability), read live by the backend on
// every availability check (no redeploy needed). The frontend never
// needs a rebuild either — it just displays whatever the API returns.
// To change seat capacity: edit the constants at the top of
// K2Karmika-AppBackend/seat_sync/sync_seat_availability.py and re-run it
// (also update the numbers here so this file stays accurate as a
// reference) — see that script's docstring for the daily-cron setup.
export const WEEKLY_SEAT_AVAILABILITY   = 1;  // "weekly-care" plan — 1 member per slot
export const MONTHLY_SEAT_AVAILABILITY  = 5;  // "monthly-care" plan
export const ANNUALLY_SEAT_AVAILABILITY = 1;  // "premium-family" (Mid-Month Plan) — 1 member per slot
export const SILVER_SEAT_AVAILABILITY   = 1;  // "silver-package" plan — 1 member per slot
export const GOLDEN_SEAT_AVAILABILITY   = 1;  // "golden-package" plan — 1 member per slot
export const PLATINUM_SEAT_AVAILABILITY = 1;  // "platinum-package" plan — 1 member per slot
export const MEMBERSHIP_SLOT_SEATS      = 5;  // every other plan

// ─────────────────────────────────────────────────────────────────────────
// BRONZE PACKAGE (renamed from "Silver Package" — plan id/route/collection
// stay "silver-package"/subscription_silver, only the customer-facing name
// changed) — src/components/membership/SilverPackageCheckout.js.
// Its own duration-tiered flow (duration choice instead of a single fixed
// price) — 2 partner slots per time instead of 1, and each tier unlocks a
// free product-kit perk instead of a paid add-on.
// ─────────────────────────────────────────────────────────────────────────
export const SILVER_PACKAGE_DURATIONS = [
  // PLACEHOLDER PRICE — no 1-month price was given alongside the other
  // Bronze plan details; set to a rough pro-rata estimate off the 3-month
  // tier until the real figure is supplied.
  { months: 1,  label: "1 Month",   price: 6999,  freeGift: "1 × 250 ml Dishwasher Cleaner" },
  { months: 3,  label: "3 Months",  price: 19999, freeGift: "2 × 250 ml Dishwasher Cleaner + 1 × 250 ml Toilet Cleaner" },
  { months: 6,  label: "6 Months",  price: 38999, freeGift: "3 × 250 ml Dishwasher Cleaner + 1 × 500 ml Toilet Cleaner" },
  { months: 12, label: "12 Months", price: 74999, freeGift: "2 Kits during 12 months — each kit: 4 × 250 ml Dishwasher Cleaner + 1 × 250 ml Toilet Cleaner + 1 × 500 ml Toilet Cleaner" },
];

// 26 visits/month, each capped at 2 hours 15 minutes (see
// BRONZE_PACKAGE_CUSTOMER_NOTES in membershipPlansData.js for the exact
// visit-duration/expiry wording shown to the customer).
export const SILVER_PACKAGE_SERVICES_PER_MONTH = 26;

// ─────────────────────────────────────────────────────────────────────────
// GOLD PACKAGE (renamed from "Silver Plus Package" — plan id/route/backend
// collections stay "silver-plus-package"/subscription_silver_plus, only the
// customer-facing name changed). src/components/membership/
// SilverPlusPackageCheckout.js.
//
// No longer the double-visit (morning+evening) model Silver Plus used to
// be — Gold is single-visit, 26/month, 3 hours each (same cadence as
// Platinum — see PLATINUM_PACKAGE_DURATIONS above), plus a free "Rapid
// Post-Party / Post-Fest" service perk on 6+ month tiers (same shape as
// Platinum's `festivalServices` free-festival-cleaning perk, just
// relabelled — the purchase_membership() "silver-plus-package" branch on
// the backend still writes this count to the same `festival_services`
// field on each day-doc, nothing new to wire up there).
// ─────────────────────────────────────────────────────────────────────────
export const SILVER_PLUS_PACKAGE_DURATIONS = [
  // PLACEHOLDER PRICES — no ₹ figures were given alongside the other Gold
  // plan details; kept at the old Silver Plus tiers (double-visit pricing)
  // until real Gold figures are supplied. 1-month is a rough pro-rata
  // estimate off the 3-month tier.
  { months: 1,  label: "1 Month",   price: 13999,  freeGift: "1 × 500 ml Dishwasher Cleaner + 1 × 250 ml Toilet Cleaner",                                                             festivalServices: 0 },
  { months: 3,  label: "3 Months",  price: 39998,  freeGift: "1 × 250 ml Dishwasher Cleaner + 1 × 500 ml Dishwasher Cleaner + 1 × 500 ml Toilet Cleaner",                             festivalServices: 0 },
  { months: 6,  label: "6 Months",  price: 77998,  freeGift: "2 × 500 ml Dishwasher Cleaner + 1 × 500 ml Toilet Cleaner + 1 × 250 ml Bathroom Cleaner",                               festivalServices: 2 },
  { months: 12, label: "12 Months", price: 149998, freeGift: "3 Kits, one every 4 months — each kit: 3 × 500 ml Dishwasher Cleaner + 3 × 500 ml Toilet Cleaner + 3 × 250 ml Bathroom Cleaner", festivalServices: 4 },
];

// 26 visits/month, single visit per day (3 hours each) — see
// SILVER_PLUS_PACKAGE_SERVICE_HOURS below.
export const SILVER_PLUS_PACKAGE_SERVICES_PER_MONTH = 26;
export const SILVER_PLUS_PACKAGE_SERVICE_HOURS = 3;

// ─────────────────────────────────────────────────────────────────────────
// GOLDEN PACKAGE — src/components/membership/GoldenPackageCheckout.js
// Same shape as Silver (duration choice + a free product-kit perk per
// tier) but 4 tiers instead of 3, and a bigger kit at each milestone.
// ─────────────────────────────────────────────────────────────────────────
// `kitSpec` + `worth` drive the highlighted "Free Product Kit" card on the
// checkout page (worth = the kit's equivalent retail value, for the "you're
// getting a deal" framing — display only, no effect on what's charged).
export const GOLDEN_PACKAGE_DURATIONS = [
  { months: 1,  label: "1 Month",   price: 1499,  freeGift: "Free 100ml 3-Product Kit", kitSpec: "100ml × 3 Products", worth: 399  },
  { months: 3,  label: "3 Months",  price: 4299,  freeGift: "Free 200ml 3-Product Kit", kitSpec: "200ml × 3 Products", worth: 799  },
  { months: 6,  label: "6 Months",  price: 8299,  freeGift: "Free 350ml 3-Product Kit", kitSpec: "350ml × 3 Products", worth: 1199 },
  { months: 12, label: "12 Months", price: 15999, freeGift: "Free 750ml 3-Product Kit", kitSpec: "750ml × 3 Products", worth: 1999 },
];

// Same for every duration tier.
export const GOLDEN_PACKAGE_SERVICES_PER_MONTH = 12;

// ─────────────────────────────────────────────────────────────────────────
// PLATINUM — src/components/membership/PlatinumPackageCheckout.js (display
// name shortened from "Platinum Package" to "Platinum"; id/route/backend
// collections stay "platinum-package"/subscription_platinum).
// Paid tiers (3/6/12 months) unlock free Rapid Pre/Post-Party /
// Pre/Post-Fest deep-cleaning visits (`festivalServices`, up to
// PLATINUM_PACKAGE_FESTIVAL_SERVICE_HOURS each) on top of the regular
// plan. 3/6/12-month prices are a bulk-discount curve off the
// ₹11,709/30-day rate (~5%/8%/12% off linear scaling), confirmed with the
// business owner — no new price figures were given alongside the rest of
// the Platinum details, so these are unchanged.
// ─────────────────────────────────────────────────────────────────────────
export const PLATINUM_PACKAGE_DURATIONS = [
  { months: 1,  label: "30 Days",   price: 11709,  freeGift: "2 × 250 ml Dishwasher Cleaner + 2 × 250 ml Toilet Cleaner",                                                                   festivalServices: 0 },
  { months: 3,  label: "3 Months",  price: 33499,  freeGift: "2 × 250 ml Dishwasher Cleaner + 1 × 500 ml Dishwasher Cleaner + 1 × 250 ml Bathroom Cleaner + 2 × 250 ml Toilet Cleaner",     festivalServices: 1 },
  { months: 6,  label: "6 Months",  price: 64999,  freeGift: "4 × 250 ml Dishwasher Cleaner + 3 × 250 ml Toilet Cleaner + 2 × 250 ml Bathroom Cleaner",                                     festivalServices: 3 },
  { months: 12, label: "12 Months", price: 123999, freeGift: "4 Kits, one every 3 months — each kit: 4 × 500 ml Dishwasher Cleaner + 4 × 500 ml Toilet Cleaner + 4 × 250 ml Bathroom Cleaner", festivalServices: 5 },
];

// Same for every duration tier.
export const PLATINUM_PACKAGE_SERVICES_PER_MONTH = 26;
export const PLATINUM_PACKAGE_SERVICE_HOURS = 3;          // hours per regular visit
export const PLATINUM_PACKAGE_FESTIVAL_SERVICE_HOURS = 2; // hours per free festival-cleaning perk visit

// ─────────────────────────────────────────────────────────────────────────
// SILVER (renamed from "Platinum Plus Package" — plan id/route/backend
// collections stay "platinum-plus-package"/subscription_platinum_plus).
// src/components/membership/PlatinumPlusPackageCheckout.js.
// No longer the double-visit (morning+evening) model Platinum Plus used to
// be — single visit/day, 26/month, 2 hrs 30 min each (see
// PLATINUM_PLUS_PACKAGE_SERVICE_HOURS below). No free Rapid/Festival perk
// on this plan — festivalServices is 0 on every tier. Prices unchanged
// (no new figures were given alongside the rest of the Silver details).
// ─────────────────────────────────────────────────────────────────────────
export const PLATINUM_PLUS_PACKAGE_DURATIONS = [
  { months: 1,  label: "1 Month",   price: 23418,  freeGift: "1 × 250 ml Dishwasher Cleaner + 1 × 250 ml Toilet Cleaner",                           festivalServices: 0 },
  { months: 3,  label: "3 Months",  price: 66998,  freeGift: "2 × 250 ml Dishwasher Cleaner + 2 × 250 ml Toilet Cleaner",                           festivalServices: 0 },
  { months: 6,  label: "6 Months",  price: 129998, freeGift: "3 × 250 ml Dishwasher Cleaner + 3 × 250 ml Toilet Cleaner",                           festivalServices: 0 },
  { months: 12, label: "12 Months", price: 247998, freeGift: "2 Kits during 12 months — each kit: 4 × 250 ml Dishwasher Cleaner + 4 × 250 ml Toilet Cleaner", festivalServices: 0 },
];

// 26 visits/month, single visit per day (2 hrs 30 min each).
export const PLATINUM_PLUS_PACKAGE_SERVICES_PER_MONTH = 26;
export const PLATINUM_PLUS_PACKAGE_SERVICE_HOURS = 2.5;

// ─────────────────────────────────────────────────────────────────────────
// HOME PAGE — src/components/home/HomePageContent.js
// ─────────────────────────────────────────────────────────────────────────

// "Starting at ₹___" teaser cards — value is the raw number; the page
// prepends "Starting at ₹" at render time.
export const HOME_PAGE_POPULAR_SERVICES = {
  "Complete House Cleaning":  499,
  "Rapid Cleaning":           699,
  "Caretaker":                349,
  "Gardening":                499,
  "vehicle Wash @Doorstep":   399,
  "Medical Caretaker":        399,
  "Packers & Movers":         399,
};

// "Instant Booking" mini preview grid
export const HOME_PAGE_INSTANT_BOOKING_PREVIEW = {
  "Kitchen Cleaning":  199,
  "Bathroom Cleaning": 199,
  "Sofa Cleaning":     299,
  "AC Cleaning":       499,
};

// ─────────────────────────────────────────────────────────────────────────
// SHOPPING PAGE — src/components/services/ShoppingPage.js product catalog.
// Keyed by product id; { price, mrp } only — name/category/rating/etc.
// stay in the component since they're catalog content, not pricing.
// ─────────────────────────────────────────────────────────────────────────
export const SHOPPING_PRODUCTS = {
  "shop-001": { price: 149, mrp: 199 },
  "shop-002": { price: 119, mrp: 160 },
  "shop-003": { price: 189, mrp: 249 },
  "shop-004": { price: 109, mrp: 145 },
  "shop-005": { price: 169, mrp: 220 },
  "shop-006": { price:  99, mrp: 135 },
  "shop-007": { price: 299, mrp: 380 },
  "shop-008": { price:  79, mrp:  99 },
  "shop-009": { price: 179, mrp: 229 },
  "shop-010": { price: 129, mrp: 169 },
  "shop-011": { price: 219, mrp: 279 },
  "shop-012": { price: 349, mrp: 449 },
  "shop-013": { price: 199, mrp: 249 },
  "shop-014": { price: 149, mrp: 189 },
  "shop-015": { price: 139, mrp: 179 },
  "shop-016": { price:  89, mrp: 115 },
  "shop-017": { price:  69, mrp:  89 },
  "shop-018": { price: 129, mrp: 169 },
  "shop-019": { price: 149, mrp: 199 },
  "shop-020": { price:  99, mrp: 129 },
  "shop-021": { price: 119, mrp: 149 },
};

// ─────────────────────────────────────────────────────────────────────────
// HELPERS
// ─────────────────────────────────────────────────────────────────────────

// Generic lookup with a safe fallback — mirrors getServiceImage()'s shape.
export function getPricing(section, key, fallback) {
  const entry = section?.[key];
  return entry !== undefined ? entry : fallback;
}

// ─────────────────────────────────────────────────────────────────────────
// SERVICE_CONFIG CATALOG — "post a requirement" pricing for Care/Home/
// Technical/Outdoor services (config.js's SERVICE_CONFIG; feeds forms like
// Gardening.js, BabyCaretaker.js, PlumberService.js, etc.). Moved here
// verbatim from config.js — same keys, same values, insurance-services
// stays in config.js since it has no price fields.
// ─────────────────────────────────────────────────────────────────────────
export const SERVICE_CONFIG_CATALOG = {
	"care-services": {
	  label: "Care Services",
	  services: {
		"baby-caretaker": {
		  label: "Baby Caretaker",
		  types: [
			{ value: "changing-diapers", label: "Changing Diapers"},
			{ value: "cleaning-utensils-of-baby", label: "Cleaning Utensils of Baby"},
			{ value: "feeding", label: "Feeding"},
			{ value: "preparing-baby-for-sleep", label: "Preparing Baby for Sleep" },
			{ value: "taking-baby-for-walk", label: "Taking Baby for Walk"},
			{ value: "baby-complete-care-taking-from-8am-6pm", label: "Baby Complete Care Taking From 8am-6pm" },
		  ],
		},
		"elder-caretaker": {
		  label: "Elder Caretaker",
		  types: [
			{ value: "bathing-assistance", label: "Bathing Assistance" },
			{ value: "feeding-assistance", label: "Feeding Assistance"},
			{ value: "medicine-reminder", label: "Medicine Reminder"},
			{ value: "walking-support", label: "Walking Support"},
			{ value: "companionship", label: "Companionship"},
			{ value: "bedside-care", label: "Bedside Care" },
		  ],
		},
		"patient-caretaker": {
		  label: "Patient Caretaker",
		  types: [
			{ value: "bedside-care", label: "Bedside Care", price: 800, unit: "shift", limit: 2 },
			{ value: "feeding-support", label: "Feeding Support", price: 500, unit: "task", limit: 4 },
			{ value: "medication-support", label: "Medication Support", price: 450, unit: "schedule", limit: 5 },
			{ value: "diaper-changing", label: "Diaper Changing", price: 400, unit: "task", limit: 5 },
			{ value: "mobility-support", label: "Mobility Support", price: 600, unit: "session", limit: 4 },
			{ value: "basic-hygiene-support", label: "Basic Hygiene Support", price: 550, unit: "task", limit: 4 },
		  ],
		},
	  },
	},

	"home-services": {
	  label: "Home Services",
	  services: {
		"house-keeping": {
		  label: "House Keeping",
		  types: [
			{
			  value: "sweeping",
			  label: "Sweeping",
			  price: 1500,
			  unit: "room",
			  limit: 3,
			  image: "/img/services/housekeeping/sweeping.jpg",
			  includes: ["Floor sweeping", "Dust collection", "Basic corner cleaning"],
			  excludes: ["Deep stain removal", "Furniture shifting", "Waste disposal outside premises"],
			},
			{
			  value: "mopping",
			  label: "Mopping",
			  price: 1500,
			  unit: "room",
			  limit: 3,
			  image: "/img/services/housekeeping/mopping.jpg",
			  includes: ["Wet floor cleaning", "Surface wipe", "Basic hygiene finish"],
			  excludes: ["Chemical polishing", "Marble restoration", "Water damage treatment"],
			},
			{
			  value: "dusting",
			  label: "Dusting",
			  price: 1500,
			  unit: "room",
			  limit: 3,
			  image: "/img/services/housekeeping/dusting.jpg",
			  includes: ["Furniture dusting", "Shelf cleaning", "Visible cobweb removal"],
			  excludes: ["High-rise glass cleaning", "Electronics dismantling", "Wall repainting"],
			},
			{
			  value: "bathroom-cleaning-support",
			  label: "Bathroom Cleaning Support",
			  price: 1500,
			  unit: "bathroom",
			  limit: 3,
			  image: "/img/services/bathroom/mirror_cleaning.jpg",
			  includes: ["Basic bathroom wash", "Floor and wall wipe", "Fittings cleaning"],
			  excludes: ["Plumbing work", "Tile replacement", "Permanent stain treatment"],
			},
			{
			  value: "kitchen-cleaning-support",
			  label: "Kitchen Cleaning Support",
			  price: 1500,
			  unit: "kitchen",
			  limit: 3,
			  image: "/img/services/kitchen/kitchen_cleaning.jpg",
			  includes: ["Counter cleaning", "Visible grease cleaning", "Basic surface wipe"],
			  excludes: ["Appliance repair", "Cabinet carpentry", "Pest control"],
			},
		  ],
		},

		"bathroom-cleaning": {
		  label: "Bathroom Cleaning",
		  types: [
			{
			  value: "one-time-deep-clean-1-bathroom",
			  label: "One Time Deep Clean (1 Bathroom)",
			  price: 500,
			  unit: "unit",
			  limit: 2,
			  image: "/img/services/bathroom/bathroom_cleaning.png",
			  includes: [
				"Deep floor and tile cleaning",
				"Toilet seat and wall cleaning",
				"Tap and fittings cleaning",
			  ],
			  excludes: [
				"Painting work",
				"Plumbing repair",
				"Permanent stain removal",
			  ],
			},
			{
			  value: "one-time-deep-clean-2-bathroom",
			  label: "One Time Deep Clean (2 Bathrooms)",
			  price: 900,
			  unit: "unit",
			  limit: 2,
			  image: "/img/services/bathroom/bathroom_cleaning.png",
			  includes: [
				"Deep floor and tile cleaning",
				"Toilet seat and wall cleaning",
				"Tap and fittings cleaning",
			  ],
			  excludes: [
				"Painting work",
				"Plumbing repair",
				"Permanent stain removal",
			  ],
			},
			{
			  value: "exhaust-fan-cleaning",
			  label: "Exhaust Fan Cleaning",
			  price: 100,
			  unit: "unit",
			  limit: 5,
			  image: "/img/services/bathroom/exhust_fan_cleaning.jpg",
			  includes: ["Outer dust cleaning", "Visible dirt removal"],
			  excludes: ["Internal motor repair", "Wiring replacement"],
			},
			{
			  value: "wash-basin-cleaning",
			  label: "Wash Basin Cleaning",
			  price: 100,
			  unit: "unit",
			  limit: 5,
			  image: "/img/services/bathroom/bathroom_cleaning.png",
			  includes: ["Surface cleaning and stain removal", "Tap and drain cleaning"],
			  excludes: ["Crack repair", "Pipe replacement"],
			},
			{
			  value: "mirror-cleaning",
			  label: "Mirror Cleaning",
			  price: 100,
			  unit: "unit",
			  limit: 5,
			  image: "/img/services/bathroom/mirror_cleaning.jpg",
			  includes: ["Mirror stain cleaning", "Surface shine finish"],
			  excludes: ["Glass replacement", "Frame repair"],
			},
		  ],
		},

		"painting-service": {
		  label: "Painting Service",
		  description:
			"Post your house painting requirement and get the final quotation after site visit.",
		  flatTypes: [
			{ value: "1bhk", label: "1 BHK", price: 10000, unit: "house", limit: 1 },
			{ value: "2bhk", label: "2 BHK", price: 30000, unit: "house", limit: 1 },
			{ value: "4bhk", label: "4 BHK", price: 50000, unit: "house", limit: 1 },
		  ],
		},

		"kitchen-room-cleaning": {
		  label: "Kitchen Room Cleaning",
		  types: [
			{
			  value: "tiles-and-slab-cleaning",
			  label: "Tiles and Slab Cleaning",
			  price: 100,
			  unit: "task",
			  limit: 5,
			  image: "/img/services/kitchen/tiles_slab_cleaning.jpg",
			  includes: ["Kitchen slab cleaning", "Wall tile wipe", "Grease removal support"],
			  excludes: ["Tile replacement", "Crack repair", "Plumbing modifications"],
			},
			{
			  value: "cabinets-trolleys-cleaning",
			  label: "Cabinets / Trolleys Cleaning",
			  price: 100,
			  unit: "task",
			  limit: 5,
			  image: "/img/services/kitchen/cabinets_cleaning.jpg",
			  includes: ["Outer surface cleaning", "Dust removal", "Shelf wipe"],
			  excludes: ["Hinge repair", "Wood polish", "Cabinet replacement"],
			},
			{
			  value: "fridge-cleaning",
			  label: "Fridge Cleaning",
			  price: 100,
			  unit: "task",
			  limit: 2,
			  image: "/img/services/kitchen/fridge_cleaning.jpg",
			  includes: ["Interior wipe", "Tray cleaning", "Visible stain removal"],
			  excludes: ["Cooling repair", "Gas refill", "Electrical service"],
			},
			{
			  value: "microwave-cleaning",
			  label: "Microwave Cleaning",
			  price: 200,
			  unit: "task",
			  limit: 2,
			  image: "/img/services/kitchen/microwave_cleaning.jpg",
			  includes: ["Interior cleaning", "Door wipe", "Odour reduction cleaning"],
			  excludes: ["Electrical repair", "Heating issue repair", "Spare replacement"],
			},
			{
			  value: "gas-stove-cleaning",
			  label: "Gas Stove Cleaning",
			  price: 200,
			  unit: "task",
			  limit: 3,
			  image: "/img/services/kitchen/gas_stove_cleaning.jpg",
			  includes: ["Burner cleaning", "Top surface cleaning", "Oil stain removal"],
			  excludes: ["Gas leakage fix", "Pipe replacement", "Ignition repair"],
			},
			{
			  value: "other-appliances-cleaning",
			  label: "Other Appliances Cleaning",
			  price: 200,
			  unit: "task",
			  limit: 5,
			  image: "/img/services/kitchen/appliance_cleaning.jpg",
			  includes: ["Outer cleaning", "Surface dust removal", "Visible stain wipe"],
			  excludes: ["Internal technical repair", "Motor repair", "Rewiring"],
			},
			{
			  value: "ground-mopping",
			  label: "Ground Mopping",
			  price: 100,
			  unit: "task",
			  limit: 5,
			  image: "/img/services/kitchen/floor_mopping.jpg",
			  includes: ["Floor wash", "Corner wipe", "Basic hygiene finish"],
			  excludes: ["Deep marble polishing", "Tile repair", "Waterproofing work"],
			},
			{
			  value: "sink-cleaning",
			  label: "Sink Cleaning",
			  price: 200,
			  unit: "task",
			  limit: 3,
			  image: "/img/services/kitchen/sink_cleaning.jpg",
			  includes: ["Sink scrub cleaning", "Drain area cleaning", "Tap wipe"],
			  excludes: ["Pipe blockage repair", "Tap replacement", "Leak fixing"],
			},
		  ],
		},

		cooking: {
		  label: "Cooking",
		  types: [
			{
			  value: "breakfast-preparation",
			  label: "Breakfast Preparation",
			  price: 400,
			  unit: "meal",
			  limit: 3,
			  image: "/img/services/cooking/breakfast.jpg",
			  includes: ["Basic breakfast preparation", "Kitchen usage support", "Serving-ready cooking"],
			  excludes: ["Grocery purchase", "Utensil deep cleaning", "Bulk catering"],
			},
			{
			  value: "lunch-preparation",
			  label: "Lunch Preparation",
			  price: 500,
			  unit: "meal",
			  limit: 3,
			  image: "/img/services/cooking/lunch.jpg",
			  includes: ["Fresh lunch cooking", "Basic meal preparation", "Home-style cooking"],
			  excludes: ["Event catering", "Special diet consultation", "Grocery supply"],
			},
			{
			  value: "dinner-preparation",
			  label: "Dinner Preparation",
			  price: 500,
			  unit: "meal",
			  limit: 3,
			  image: "/img/services/cooking/dinner.jpg",
			  includes: ["Dinner cooking", "Basic kitchen preparation", "Serving-ready support"],
			  excludes: ["Party catering", "Kitchen deep cleaning", "Ingredient shopping"],
			},
			{
			  value: "veg-cooking",
			  label: "Veg Cooking",
			  price: 600,
			  unit: "meal",
			  limit: 3,
			  image: "/img/services/cooking/veg.jpg",
			  includes: ["Vegetarian meal preparation", "Basic menu cooking", "Home-style food support"],
			  excludes: ["Dietician planning", "Bulk order cooking", "Ingredients purchase"],
			},
			{
			  value: "non-veg-cooking",
			  label: "Non-Veg Cooking",
			  price: 750,
			  unit: "meal",
			  limit: 3,
			  image: "/img/services/cooking/nonveg.jpg",
			  includes: ["Non-veg dish preparation", "Home-style meal cooking", "Basic kitchen support"],
			  excludes: ["Bulk catering", "Special restaurant-style plating", "Meat purchase"],
			},
		  ],
		},
		"sump-and-tank-cleaner": {
		  label: "Sump and Tank Cleaner",
		  description:
			"Book sump and tank cleaning services for residential or commercial properties.",
		  cleaningTypes: [
			{
			  value: "underground-sump-cleaning",
			  label: "Underground Sump Cleaning",
			  price: 1500,
			  unit: "job",
			  limit: 5,
			  image: "/img/services/tank/underground_sump.jpg",
			  includes: ["Sump cleaning", "Sludge removal", "Basic wash support"],
			  excludes: ["Structural repair", "Motor repair", "Pipeline replacement"],
			},
			{
			  value: "overhead-tank-cleaning",
			  label: "Overhead Tank Cleaning",
			  price: 1200,
			  unit: "job",
			  limit: 5,
			  image: "/img/services/tank/overhead_tank.jpg",
			  includes: ["Tank wash cleaning", "Sediment removal", "Basic hygiene cleaning"],
			  excludes: ["Crack repair", "Tank replacement", "Pipe modification"],
			},
			{
			  value: "plastic-tank-cleaning",
			  label: "Plastic Tank Cleaning",
			  price: 1000,
			  unit: "job",
			  limit: 5,
			  image: "/img/services/tank/plastic_tank.jpg",
			  includes: ["Plastic tank interior cleaning", "Basic sediment removal", "Wash support"],
			  excludes: ["Tank repair", "Pipe replacement", "New fitting installation"],
			},
			{
			  value: "cement-tank-cleaning",
			  label: "Cement Tank Cleaning",
			  price: 1800,
			  unit: "job",
			  limit: 5,
			  image: "/img/services/tank/cement_tank.jpg",
			  includes: ["Cement tank cleaning", "Inner wash support", "Basic sludge removal"],
			  excludes: ["Civil repair", "Waterproofing", "Reconstruction work"],
			},
			{
			  value: "water-pipeline-cleaning",
			  label: "Water Pipeline Cleaning",
			  price: 2000,
			  unit: "job",
			  limit: 3,
			  image: "/img/services/tank/pipeline_cleaning.jpg",
			  includes: ["Basic pipeline cleaning support", "Flow cleaning process", "Service inspection"],
			  excludes: ["Pipeline replacement", "Wall breaking", "Pump repair"],
			},
			{
			  value: "full-sump-tank-cleaning",
			  label: "Full Sump + Tank Cleaning",
			  price: 2500,
			  unit: "job",
			  limit: 3,
			  image: "/img/services/tank/full_cleaning.jpg",
			  includes: ["Combined sump and tank cleaning", "Wash support", "Sediment removal"],
			  excludes: ["Repair work", "New fittings", "Civil modifications"],
			},
		  ],
		},
	  },
	},

	technical: {
	  label: "Technical Services",
	  services: {
		"ac-repair": {
		  label: "AC Repair",
		  types: [
			{
			  value: "foam-jet-ac-service",
			  label: "Foam-Jet AC Service (1 AC)",
			  price: 500,
			  unit: "unit",
			  limit: 2,
			  image: "/img/services/ac/foam_jet_service.jpg",
			  includes: [
				"Indoor unit foam-jet cleaning",
				"Dust and dirt removal",
				"Basic cooling check",
			  ],
			  excludes: [
				"Gas refill",
				"Spare parts replacement",
				"PCB or compressor repair",
			  ],
			},
			{
			  value: "general-ac-service",
			  label: "General AC Service",
			  price: 500,
			  unit: "unit",
			  limit: 5,
			  image: "/img/services/ac/general_service.jpg",
			  includes: [
				"Basic AC inspection",
				"Filter cleaning",
				"General performance check",
			  ],
			  excludes: [
				"Gas charging",
				"Major electrical repair",
				"Copper pipe replacement",
			  ],
			},
			{
			  value: "gas-refill-checkup",
			  label: "Gas Refill & Checkup",
			  price: 100,
			  unit: "unit",
			  limit: 5,
			  image: [
				"/img/services/ac/gas_refill_1.jpg",
				"/img/services/ac/gas_refill_2.jpg",
			  ],
			  includes: [
				"Gas pressure check",
				"Basic leakage inspection",
				"Refill support visit",
			  ],
			  excludes: [
				"Compressor replacement",
				"Pipe welding",
				"Full AC dismantling",
			  ],
			},
			{
			  value: "ac-installation",
			  label: "AC Installation",
			  price: 100,
			  unit: "unit",
			  limit: 5,
			  image: "/img/services/ac/installation.jpg",
			  includes: [
				"Indoor and outdoor unit mounting support",
				"Basic installation work",
				"Testing after installation",
			  ],
			  excludes: [
				"Extra copper pipe",
				"Core cutting",
				"Stand fabrication",
			  ],
			},
			{
			  value: "ac-uninstallation",
			  label: "AC Uninstallation",
			  price: 100,
			  unit: "unit",
			  limit: 5,
			  image: "/img/services/ac/uninstallation.jpg",
			  includes: [
				"Safe AC removal",
				"Basic dismantling",
				"Unit disconnection support",
			  ],
			  excludes: [
				"Wall repair",
				"Reinstallation at new place",
				"Transport support",
			  ],
			},
		  ],
		},

		"electrical-services": {
		  label: "Electrical Services",
		  types: [
			// Placeholder catalog — top-level categories only, for the
			// /schedule-booking/technical service grid. Each is priced 0 with
			// no subServices/includes/excludes until real per-category detail
			// (sub-services, pricing, what's included) is provided individually.
			{
				value: "switch-socket",
				label: "Switch & Socket",
				price: 0,
				unit: "unit",
				limit: 10,
				image: switchSocketImg,
				// Has its own dedicated multi-step booking page — see SwitchSocketBookingPage.js.
				detailRoute: "/schedule-booking/technical/switch-socket",
				includes: [
					"Switch and socket installation and replacement",
					"Electrician consultation for anything you're not sure about",
					"Rating/load guidance for higher-capacity points",
					"Basic testing after work",
				],
				excludes: [
					"New wiring or circuit modification beyond the point (needs separate approval)",
					"False ceiling or civil work",
					"MCB/panel-level work",
				],
				// ── Pricing model (per the "latest calculation document") ──────────
				// This service intentionally does NOT use the site-wide city-price/
				// Mysuru-discount system (cityPrice()/getServicePrice()) — the
				// uploaded pricing doc gives flat, non-city-specific base prices and
				// its own formula, verified exact against the doc's own worked
				// example (2× Heavy/16A → Final Payable ₹265.00):
				//   Additional Piece = Base Price × 0.81
				//   Service Amount   = Base Price + (Quantity-1) × Additional Piece   (summed across every item in the booking)
				//   Final Payable    = Service Amount × 1.12  (6% Platform Fee + 6% GST, rounded once at the end — rounding
				//                                               Platform Fee/GST separately first gives ₹265.01, not the doc's ₹265.00)
				// Consultation work type pays ONLY the flat consultationFee below
				// instead of a Service Amount — the two are never stacked (see the
				// supplied spec's separate "Price" vs "Consultation Charge" screens).
				// Material: the doc's own worked example uses "ClickNido Material"
				// with the base price as-is (no separate material line in the
				// breakdown) — so the rating base price below already represents
				// the ClickNido-supplies-material price. "Customer Material"
				// (labour only) has no figure in the doc; customerMaterialFactor
				// is a PLACEHOLDER ratio (60% of base) until real numbers are given.
				// Final customer-facing structure: Install | Replacement | Consultation
				// (Not Sure). Consultation is a selectable work type, not an
				// always-on step — it skips item/type/rating/quantity/material
				// entirely and goes straight to problem + description + photo,
				// charged at a flat consultationFee instead of itemized pricing.
				workTypes: [
					{ key: "install", label: "Install", description: "Fit a new switch or socket." },
					{ key: "replace", label: "Replacement", description: "Replace an existing switch or socket." },
					{ key: "consultation", label: "Consultation", description: "Not sure what you need — ask an electrician to inspect and advise.", isConsultation: true },
				],
				consultationFee: 90,
				customerMaterialFactor: 0.6,
				// Only shown for the Consultation work type.
				problems: [
					{ key: "switch_problem", label: "Switch Problem" },
					{ key: "socket_problem", label: "Socket Problem" },
					{ key: "new_switch_requirement", label: "New Switch Requirement" },
					{ key: "new_socket_requirement", label: "New Socket Requirement" },
					{ key: "electrical_point_requirement", label: "Electrical Point Requirement" },
					{ key: "multiple_requirements", label: "Multiple Requirements" },
					{ key: "not_working", label: "Not Working" },
					{ key: "sparking", label: "Sparking" },
					{ key: "heating", label: "Heating" },
					{ key: "burning", label: "Burning" },
					{ key: "loose", label: "Loose" },
					{ key: "no_power", label: "No Power" },
					{ key: "other", label: "Other" },
					{ key: "i_dont_know", label: "I Don't Know" },
				],
				// Customer never picks an exact amp value — kept simple as just
				// Normal / Heavy / Not Sure; the electrician verifies the exact
				// rating on-site. "Not Sure" has no fixed base price — framed as
				// a starting-price-after-inspection job.
				ratings: [
					{ value: "normal", label: "Normal", basePrice: 63 },
					{ value: "heavy", label: "Heavy", basePrice: 81 },
					{ value: "notsure", label: "Not Sure", basePrice: null, requirement: true },
				],
				// Full switch/socket type catalogs per the supplied specification —
				// ClickNido can service every type listed there, including Fan
				// Regulator. Exact technical rating is verified by the electrician
				// on-site; this list stays customer-facing/simple.
				subCategories: [
					{
						key: "switch",
						label: "Switch",
						types: [
							{ value: "switch_1way", label: "1-Way Switch", image: "/img/services/electrical/switch-socket/1-way-switch.jpg" },
							{ value: "switch_2way", label: "2-Way Switch", image: "/img/services/electrical/switch-socket/2-way-switch.jpg" },
							{ value: "switch_intermediate", label: "Intermediate Switch", image: "/img/services/electrical/switch-socket/intermediate-switch.jpg" },
							{ value: "switch_single", label: "Single Switch", image: "/img/services/electrical/switch-socket/single-switch.jpg" },
							{ value: "switch_double", label: "Double Switch", image: "/img/services/electrical/switch-socket/double-switch.jpg" },
							{ value: "switch_multimodule", label: "Multi-Module Switch", image: "/img/services/electrical/switch-socket/multi-module-switch.jpg" },
							{ value: "switch_modular", label: "Modular Switch", image: "/img/services/electrical/switch-socket/modular-switch.jpg" },
							{ value: "switch_rocker", label: "Rocker Switch", image: "/img/services/electrical/switch-socket/rocker-switch.jpg" },
							{ value: "switch_push", label: "Push Switch", image: "/img/services/electrical/switch-socket/push-switch.jpg" },
							{ value: "switch_bellpush", label: "Bell-Push Switch", image: "/img/services/electrical/switch-socket/bell-push-switch.jpg" },
							{ value: "switch_light", label: "Light Switch", image: "/img/services/electrical/switch-socket/light-switch.jpg" },
							{ value: "switch_fan", label: "Fan Switch", image: "/img/services/electrical/switch-socket/fan-switch.jpg" },
							{ value: "switch_exhaustfan", label: "Exhaust Fan Switch", image: "/img/services/electrical/switch-socket/exhaust-fan-switch.jpg" },
							{ value: "switch_appliance", label: "Appliance Switch", image: "/img/services/electrical/switch-socket/appliance-switch.jpg" },
							{ value: "switch_geyser", label: "Geyser Switch", image: "/img/services/electrical/switch-socket/geyser-switch.jpg" },
							{ value: "switch_washingmachine", label: "Washing Machine Switch", image: "/img/services/electrical/switch-socket/washing-machine-switch.jpg" },
							{ value: "switch_kitchenappliance", label: "Kitchen Appliance Switch", image: "/img/services/electrical/switch-socket/kitchen-appliance-switch.jpg" },
							{ value: "switch_outdoor", label: "Outdoor Switch", image: "/img/services/electrical/switch-socket/outdoor-switch.jpg" },
							{ value: "switch_weatherresistant", label: "Weather-Resistant Switch", image: "/img/services/electrical/switch-socket/weather-resistant-switch.jpg" },
							{ value: "switch_heavyduty", label: "Heavy-Duty Switch", image: "/img/services/electrical/switch-socket/heavy-duty-switch.jpg" },
							{ value: "switch_main", label: "Main Switch", image: "/img/services/electrical/switch-socket/main-switch.jpg" },
							{ value: "switch_dimmer", label: "Dimmer Switch", image: "/img/services/electrical/switch-socket/dimmer-switch.jpg" },
							{ value: "switch_smart", label: "Smart Switch", image: "/img/services/electrical/switch-socket/smart-switch.jpg", scheduleOnly: true },
							{ value: "switch_wifi", label: "Wi-Fi Switch", image: "/img/services/electrical/switch-socket/wifi-switch.jpg", scheduleOnly: true },
							{ value: "switch_touch", label: "Touch Switch", image: "/img/services/electrical/switch-socket/touch-switch.jpg" },
							{ value: "switch_sensor", label: "Sensor Switch", image: "/img/services/electrical/switch-socket/sensor-switch.jpg" },
							{ value: "switch_fanregulator", label: "Fan Regulator", image: "/img/services/electrical/switch-socket/fan-regulator.jpg" },
							{ value: "switch_notsure", label: "Not Sure", image: "/img/services/electrical/switch-socket/not-sure.jpg", notSure: true },
						],
					},
					{
						key: "socket",
						label: "Socket",
						types: [
							{ value: "socket_normal", label: "Normal Socket", image: "/img/services/electrical/switch-socket/normal-socket.jpg" },
							{ value: "socket_2pin", label: "2-Pin Socket", image: "/img/services/electrical/switch-socket/2-pin-socket.jpg" },
							{ value: "socket_3pin", label: "3-Pin Socket", image: "/img/services/electrical/switch-socket/3-pin-socket.jpg" },
							{ value: "socket_universal", label: "Universal Socket", image: "/img/services/electrical/switch-socket/universal-socket.jpg" },
							{ value: "socket_modular", label: "Modular Socket", image: "/img/services/electrical/switch-socket/modular-socket.jpg" },
							{ value: "socket_heavyduty", label: "Heavy-Duty Socket", image: "/img/services/electrical/switch-socket/heavy-duty-socket.jpg" },
							{ value: "socket_usb", label: "USB Socket", image: "/img/services/electrical/switch-socket/usb-socket.jpg", scheduleOnly: true },
							{ value: "socket_usbc", label: "USB-C Socket", image: "/img/services/electrical/switch-socket/usb-c-socket.jpg", scheduleOnly: true },
							{ value: "socket_smart", label: "Smart Socket", image: "/img/services/electrical/switch-socket/smart-socket.jpg", scheduleOnly: true },
							{ value: "socket_outdoor", label: "Outdoor / Weather-Resistant Socket", image: "/img/services/electrical/switch-socket/outdoor-socket.jpg", scheduleOnly: true },
							{ value: "socket_notsure", label: "Not Sure", image: "/img/services/electrical/switch-socket/not-sure.jpg", notSure: true },
						],
					},
				],
			},
			{
				value: "appliance",
				label: "Appliance",
				price: 0,
				unit: "unit",
				limit: 10,
				image: applianceImg,
				// Has its own dedicated multi-step booking page — see ApplianceBookingPage.js.
				detailRoute: "/schedule-booking/technical/appliance",
				includes: [
					"Appliance connection repair, replacement, installation and removal",
					"Optional wiring / switch-box work for new installations",
					"Basic testing after work",
				],
				excludes: [
					"Fan and Light — booked separately as their own services",
					"Appliance unit cost itself unless separately purchased",
					"Major civil or false-ceiling work",
				],
				// PLACEHOLDER PRICING — every number here is a placeholder pending
				// real figures. "Service" work type (Step 2) is a soft default/
				// label only; the actual price comes from the specific
				// per-appliance sub-service picked in Step 4.
				workTypes: [
					{ key: "repair", label: "Repair" },
					{ key: "replace", label: "Replace" },
					{ key: "install", label: "Install" },
					{ key: "remove", label: "Remove" },
				],
				consultation: {
					value: "appliance_consultation",
					label: "Appliance Consultation",
					price: 99,
					unit: "visit",
					limit: 1,
					image: "/img/services/electrical/appliance/consultation.jpg",
				},
				// Shown only after picking an "install"-type sub-service — no
				// cable-size/MCB-rating questions; the electrician assesses
				// those on-site.
				installRequirements: [
					{ value: "install_only", label: "Installation Only", extra: 0 },
					{ value: "install_wiring", label: "Installation + Wiring", extra: 99 },
					{ value: "install_wiring_switchbox", label: "Installation + Wiring + Switch Box", extra: 199 },
				],
				appliances: [
					// Per the "Appliance Possible Service Options" spec: Install,
					// Uninstall, Repair, Service, Consultation — no separate
					// "Replace Connection" line for AC.
					{ key: "ac", label: "AC", image: applianceAcImg, subServices: [
						{ value: "appliance_ac_install", label: "New Installation", price: 349, workType: "install", isInstall: true },
						{ value: "appliance_ac_wiring", label: "Wiring & Switch Box", price: 249, workType: "install" },
						{ value: "appliance_ac_repair", label: "Connection Repair", price: 179, workType: "repair" },
						{ value: "appliance_ac_service", label: "AC Service (Gas Fill / Cleaning)", price: 299, workType: "service" },
						{ value: "appliance_ac_remove", label: "Uninstall", price: 99, workType: "remove" },
						{ value: "appliance_ac_consultation", label: "Consultation", price: 99, workType: "consultation", isConsultation: true },
					]},
					// Install, Replace, Repair, Service, Uninstall, Consultation.
					{ key: "geyser", label: "Geyser", image: applianceGeyserImg, subServices: [
						{ value: "appliance_geyser_install", label: "New Installation", price: 299, workType: "install", isInstall: true },
						{ value: "appliance_geyser_wiring", label: "Wiring & Switch Box", price: 219, workType: "install" },
						{ value: "appliance_geyser_replace", label: "Replace Connection", price: 179, workType: "replace" },
						{ value: "appliance_geyser_repair", label: "Connection Repair", price: 149, workType: "repair" },
						{ value: "appliance_geyser_service", label: "General Service", price: 169, workType: "service" },
						{ value: "appliance_geyser_remove", label: "Uninstall", price: 89, workType: "remove" },
						{ value: "appliance_geyser_consultation", label: "Consultation", price: 99, workType: "consultation", isConsultation: true },
					]},
					// Install, Replace, Repair, Service, Uninstall, Consultation —
					// renamed from "Chimney" to cover Hob/Stove the same way.
					{ key: "chimney", label: "Chimney / Hob / Stove", image: applianceChimneyImg, subServices: [
						{ value: "appliance_chimney_install", label: "New Installation", price: 299, workType: "install", isInstall: true },
						{ value: "appliance_chimney_wiring", label: "Wiring & Switch Box", price: 219, workType: "install" },
						{ value: "appliance_chimney_replace", label: "Replace Connection", price: 179, workType: "replace" },
						{ value: "appliance_chimney_repair", label: "Connection Repair", price: 149, workType: "repair" },
						{ value: "appliance_chimney_service", label: "General Service (Cleaning/Maintenance)", price: 179, workType: "service" },
						{ value: "appliance_chimney_remove", label: "Uninstall", price: 89, workType: "remove" },
						{ value: "appliance_chimney_consultation", label: "Consultation", price: 99, workType: "consultation", isConsultation: true },
					]},
					// Install, Replace, Repair, Service, Uninstall, Consultation.
					{ key: "washing-machine", label: "Washing Machine", image: applianceWashingMachineImg, subServices: [
						{ value: "appliance_wm_install", label: "New Installation", price: 249, workType: "install", isInstall: true },
						{ value: "appliance_wm_wiring", label: "Wiring & Switch Box", price: 179, workType: "install" },
						{ value: "appliance_wm_replace", label: "Replace Connection", price: 149, workType: "replace" },
						{ value: "appliance_wm_repair", label: "Connection Repair", price: 129, workType: "repair" },
						{ value: "appliance_wm_service", label: "General Service", price: 149, workType: "service" },
						{ value: "appliance_wm_remove", label: "Uninstall", price: 79, workType: "remove" },
						{ value: "appliance_wm_consultation", label: "Consultation", price: 99, workType: "consultation", isConsultation: true },
					]},
					// Install, Replace, Repair, Service, Uninstall, Consultation —
					// same shape as Geyser (no dedicated image yet).
					{ key: "water-purifier", label: "Water Purifier / RO", image: applianceWaterPurifierImg, subServices: [
						{ value: "appliance_ro_install", label: "New Installation", price: 279, workType: "install", isInstall: true },
						{ value: "appliance_ro_wiring", label: "Wiring & Switch Box", price: 199, workType: "install" },
						{ value: "appliance_ro_replace", label: "Replace Connection", price: 169, workType: "replace" },
						{ value: "appliance_ro_repair", label: "Connection Repair", price: 139, workType: "repair" },
						{ value: "appliance_ro_service", label: "Filter Change / General Service", price: 149, workType: "service" },
						{ value: "appliance_ro_remove", label: "Uninstall", price: 79, workType: "remove" },
						{ value: "appliance_ro_consultation", label: "Consultation", price: 99, workType: "consultation", isConsultation: true },
					]},
					{ key: "dishwasher", label: "Dishwasher", image: applianceDishwasherImg, subServices: [
						{ value: "appliance_dw_install", label: "New Installation", price: 249, workType: "install", isInstall: true },
						{ value: "appliance_dw_repair", label: "Connection Repair", price: 129, workType: "repair" },
						{ value: "appliance_dw_replace", label: "Replace Connection", price: 179, workType: "replace" },
						{ value: "appliance_dw_remove", label: "Remove", price: 79, workType: "remove" },
						{ value: "appliance_dw_wiring", label: "Wiring & Switch Box", price: 179, workType: "install" },
						{ value: "appliance_dw_consultation", label: "Consultation", price: 99, workType: "consultation", isConsultation: true },
					]},
					// Repair, Service, Installation-related work, Consultation — no
					// separate Install/Replace/Uninstall lines per the spec (kept
					// as one umbrella install_related item instead of the 2-line
					// New-Installation/Wiring split other appliances use).
					{ key: "oven-microwave", label: "Oven / Microwave", image: applianceOvenImg, subServices: [
						{ value: "appliance_oven_install_related", label: "Installation-related work", price: 149, workType: "install_related", isInstall: true },
						{ value: "appliance_oven_repair", label: "Connection Repair", price: 99, workType: "repair" },
						{ value: "appliance_oven_service", label: "General Service", price: 119, workType: "service" },
						{ value: "appliance_oven_consultation", label: "Consultation", price: 99, workType: "consultation", isConsultation: true },
					]},
					// Repair, Service, Installation-related work, Consultation —
					// same shape as Oven/Microwave, no Uninstall line.
					{ key: "refrigerator", label: "Refrigerator", image: applianceRefrigeratorImg, subServices: [
						{ value: "appliance_fridge_install_related", label: "Installation-related work", price: 149, workType: "install_related", isInstall: true },
						{ value: "appliance_fridge_repair", label: "Connection Repair", price: 99, workType: "repair" },
						{ value: "appliance_fridge_service", label: "General Service", price: 119, workType: "service" },
						{ value: "appliance_fridge_consultation", label: "Consultation", price: 99, workType: "consultation", isConsultation: true },
					]},
					// Installation, Mounting-related work, Repair, Consultation —
					// no Replace/Service/Uninstall lines per the spec.
					{ key: "tv", label: "TV", image: applianceTvImg, subServices: [
						{ value: "appliance_tv_install", label: "Installation", price: 199, workType: "install", isInstall: true },
						{ value: "appliance_tv_mounting", label: "Mounting-related work", price: 149, workType: "mounting" },
						{ value: "appliance_tv_repair", label: "Connection Repair", price: 99, workType: "repair" },
						{ value: "appliance_tv_consultation", label: "Consultation", price: 99, workType: "consultation", isConsultation: true },
					]},
					{ key: "soundbar", label: "Soundbar", image: applianceSoundbarImg, subServices: [
						{ value: "appliance_soundbar_install", label: "Install Soundbar", price: 199, workType: "install", isInstall: true },
						{ value: "appliance_soundbar_repair", label: "Repair Connection", price: 99, workType: "repair" },
						{ value: "appliance_soundbar_replace", label: "Replace Connection", price: 129, workType: "replace" },
						{ value: "appliance_soundbar_remove", label: "Remove", price: 69, workType: "remove" },
						{ value: "appliance_soundbar_wiring", label: "Wiring & Power Point", price: 149, workType: "install" },
						{ value: "appliance_soundbar_consultation", label: "Consultation", price: 99, workType: "consultation", isConsultation: true },
					]},
					{ key: "speaker", label: "Speaker", image: applianceSpeakerImg, subServices: [
						{ value: "appliance_speaker_install", label: "Install Speaker", price: 149, workType: "install", isInstall: true },
						{ value: "appliance_speaker_repair", label: "Repair Connection", price: 79, workType: "repair" },
						{ value: "appliance_speaker_replace", label: "Replace Connection", price: 99, workType: "replace" },
						{ value: "appliance_speaker_remove", label: "Remove", price: 59, workType: "remove" },
						{ value: "appliance_speaker_wiring", label: "Wiring & Power Point", price: 119, workType: "install" },
						{ value: "appliance_speaker_consultation", label: "Consultation", price: 99, workType: "consultation", isConsultation: true },
					]},
					{ key: "computer-other", label: "Computer / Other", image: applianceComputerImg, subServices: [
						{ value: "appliance_computer_install", label: "New Installation", price: 149, workType: "install", isInstall: true },
						{ value: "appliance_computer_repair", label: "Connection Repair", price: 79, workType: "repair" },
						{ value: "appliance_computer_wiring", label: "Wiring & Switch Box", price: 119, workType: "install" },
						{ value: "appliance_computer_remove", label: "Remove", price: 59, workType: "remove" },
						{ value: "appliance_computer_consultation", label: "Consultation", price: 99, workType: "consultation", isConsultation: true },
					]},
					// No structured sub-services — always routes straight to the
					// freeform "Tell us your requirement" consultation panel.
					{ key: "not-sure", label: "Not Sure", image: applianceNotSureImg, subServices: [] },
				],
			},
			{
				value: "cctv",
				label: "CCTV",
				price: 0,
				unit: "camera",
				limit: 20,
				image: cctvImg,
				// Has its own dedicated multi-step booking page — see CctvBookingPage.js.
				detailRoute: "/schedule-booking/technical/cctv",
				includes: [
					"CCTV camera repair, replacement, installation and removal",
					"Home, office, IP/Wi-Fi, DVR/NVR and security CCTV systems",
					"Basic testing and live-view setup after install",
				],
				excludes: [
					"Cost of the camera/DVR/NVR hardware itself unless separately purchased",
					"Internet/router setup beyond the CCTV's own network point",
					"Major civil or false-ceiling work",
				],
				// PLACEHOLDER PRICING — per-camera labour price × work-type
				// multiplier, same computation model as Switch & Socket.
				workTypes: [
					{ key: "repair", label: "Repair", multiplier: 1.0 },
					{ key: "replace", label: "Replace", multiplier: 1.2 },
					{ key: "install", label: "Install", multiplier: 1.4 },
					{ key: "remove", label: "Remove", multiplier: 0.5 },
				],
				consultation: {
					value: "cctv_consultation",
					label: "CCTV Consultation",
					price: 99,
					unit: "visit",
					limit: 1,
					image: "/img/services/electrical/cctv/consultation.jpg",
				},
				// Quantity buttons are 1/2/3/4 + a "5+" that reveals a plain qty
				// stepper (starting at 5) — see the ccModal popup.
				cameraCountOptions: [1, 2, 3, 4],
				// Place/Area/Setup are label-only context questions (no price
				// impact) — asked for every work type per the supplied "Work
				// Type / Place / Area / CCTV Type / Quantity / Setup / Photo"
				// spec, not just Install like the previous liveViewOptions-only
				// version of this flow.
				places: [
					{ value: "home", label: "Home" },
					{ value: "apartment", label: "Apartment" },
					{ value: "villa", label: "Villa" },
					{ value: "office", label: "Office" },
					{ value: "shop", label: "Shop" },
					{ value: "warehouse", label: "Warehouse" },
					{ value: "parking", label: "Parking" },
					{ value: "gate", label: "Gate" },
					{ value: "other", label: "Other" },
				],
				areas: [
					{ value: "entrance", label: "Entrance" },
					{ value: "room", label: "Room" },
					{ value: "staircase", label: "Staircase" },
					{ value: "balcony", label: "Balcony" },
					{ value: "terrace", label: "Terrace" },
					{ value: "parking", label: "Parking" },
					{ value: "gate", label: "Gate" },
					{ value: "office", label: "Office" },
					{ value: "outdoor", label: "Outdoor" },
					{ value: "other", label: "Other" },
				],
				setupOptions: [
					{ value: "new", label: "New Setup" },
					{ value: "existing", label: "Existing Setup" },
					{ value: "add_camera", label: "Add Camera to Existing Setup" },
					{ value: "notsure", label: "Not Sure" },
				],
				// Reuses the same {subCategories[].types[]} shape as Switch & Socket
				// (a single sub-category here, since CCTV has just one dimension —
				// camera type — instead of two) so the price-badge helper on
				// /schedule-booking/technical needs no extra code for this shape.
				// PLACEHOLDER PRICING — per supplied "CCTV Type" list (camera form
				// factor), replacing the old Home/Office/IP-Wi-Fi/DVR-NVR/Security
				// use-case list.
				subCategories: [
					{ key: "cctv-type", label: "CCTV Type", types: [
						{ value: "cctv_indoor", label: "Indoor", price: 199, unit: "camera", limit: 20, image: "/img/services/electrical/cctv/indoor.jpg" },
						{ value: "cctv_outdoor", label: "Outdoor", price: 249, unit: "camera", limit: 20, image: "/img/services/electrical/cctv/outdoor.jpg" },
						{ value: "cctv_wifi", label: "Wi-Fi", price: 279, unit: "camera", limit: 20, image: "/img/services/electrical/cctv/wifi.jpg" },
						{ value: "cctv_ip", label: "IP", price: 299, unit: "camera", limit: 20, image: "/img/services/electrical/cctv/ip.jpg" },
						{ value: "cctv_dome", label: "Dome", price: 229, unit: "camera", limit: 20, image: "/img/services/electrical/cctv/dome.jpg" },
						{ value: "cctv_bullet", label: "Bullet", price: 229, unit: "camera", limit: 20, image: "/img/services/electrical/cctv/bullet.jpg" },
						{ value: "cctv_ptz", label: "PTZ", price: 399, unit: "camera", limit: 20, image: "/img/services/electrical/cctv/ptz.jpg" },
						{ value: "cctv_turret", label: "Turret", price: 249, unit: "camera", limit: 20, image: "/img/services/electrical/cctv/turret.jpg" },
						{ value: "cctv_4g", label: "4G", price: 349, unit: "camera", limit: 20, image: "/img/services/electrical/cctv/4g.jpg" },
						{ value: "cctv_smart", label: "Smart", price: 349, unit: "camera", limit: 20, image: "/img/services/electrical/cctv/smart.jpg" },
						{ value: "cctv_notsure", label: "Not Sure", price: 249, unit: "camera", limit: 20, image: "/img/services/electrical/cctv/not-sure.jpg", notSure: true },
					]},
				],
			},
			{
				value: "doorbell-security",
				label: "Doorbell Security",
				price: 0,
				unit: "unit",
				limit: 10,
				image: doorbellSecurityImg,
				// Has its own dedicated multi-step booking page — see DoorbellSecurityBookingPage.js.
				detailRoute: "/schedule-booking/technical/doorbell-security",
				includes: [
					"Doorbell and security bell repair, replacement, installation and removal",
					"Wired, wireless, video and smart doorbell types",
					"Basic testing after work",
				],
				excludes: [
					"Cost of the doorbell/device unit itself unless separately purchased",
					"Home network/Wi-Fi setup beyond the device's own connection",
					"Major civil or false-ceiling work",
				],
				// PLACEHOLDER PRICING — per-device labour price × work-type
				// multiplier, same computation model as Switch & Socket / CCTV,
				// but with its OWN price points (never reusing Switch & Socket's
				// ₹63/₹81 rating prices) per the supplied Doorbell & Security
				// frontend spec's pricing rules.
				workTypes: [
					{ key: "repair", label: "Repair", multiplier: 1.0 },
					{ key: "replace", label: "Replace", multiplier: 1.2 },
					{ key: "install", label: "Install", multiplier: 1.4 },
					{ key: "remove", label: "Remove", multiplier: 0.5 },
				],
				consultation: {
					value: "doorbell_consultation",
					label: "Doorbell & Security Consultation",
					price: 99,
					unit: "visit",
					limit: 1,
					image: "/img/services/electrical/doorbell-security/consultation.jpg",
				},
				// Material only changes price the same way Switch & Socket's
				// customerMaterialFactor already does (reused, not invented) —
				// only asked for Install/Replace, never Repair/Remove.
				materialOptions: [
					{ value: "customer", label: "I Have the Device (Customer Material)" },
					{ value: "company", label: "ClickNido Material (Company Material)" },
					{ value: "notsure", label: "Not Sure" },
				],
				customerMaterialFactor: 0.6,
				// Label-only, no price impact — asked for every work type except
				// Consultation.
				connectionOptions: [
					{ value: "yes", label: "Yes – Existing Connection" },
					{ value: "no", label: "No – New Installation" },
					{ value: "notsure", label: "Not Sure" },
				],
				// Only shown (and optional) for Repair.
				issueOptions: [
					{ value: "not_ringing", label: "Not Ringing" },
					{ value: "bell_push_not_working", label: "Bell Push Not Working" },
					{ value: "chime_not_working", label: "Chime Not Working" },
					{ value: "loose_connection", label: "Loose Connection" },
					{ value: "wiring_issue", label: "Wiring Issue" },
					{ value: "device_not_working", label: "Device Not Working" },
					{ value: "other", label: "Other / Not Sure" },
				],
				// Six customer-friendly device sections per the supplied catalogue
				// — each section is its own subCategory, shown as its own card in
				// the center list (never all ~30 devices flattened into one page).
				// Every section's "Other / Not Sure" device routes straight to the
				// flat Consultation charge above instead of a ₹0 placeholder line.
				subCategories: [
					{ key: "regular", label: "Regular Doorbell", types: [
						{ value: "doorbell_wired", label: "Wired Doorbell", price: 129, unit: "unit", limit: 10, image: doorbellRegularImg },
						{ value: "doorbell_wireless", label: "Wireless Doorbell", price: 179, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/wireless-doorbell.jpg" },
						{ value: "doorbell_bellpush", label: "Bell Push", price: 99, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/bell-push.jpg" },
						{ value: "doorbell_chime", label: "Doorbell Chime", price: 119, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/doorbell-chime.jpg" },
						{ value: "doorbell_digital", label: "Digital Doorbell", price: 159, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/digital-doorbell.jpg" },
						{ value: "doorbell_traditional", label: "Traditional Doorbell", price: 89, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/traditional-doorbell.jpg" },
						{ value: "doorbell_regular_notsure", label: "Other / Not Sure", price: null, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/not-sure.jpg", notSure: true },
					]},
					{ key: "smart", label: "Smart Doorbell", types: [
						{ value: "doorbell_smart", label: "Smart Doorbell", price: 249, unit: "unit", limit: 10, image: doorbellSmartImg },
						{ value: "doorbell_wifi", label: "Wi-Fi Doorbell", price: 229, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/wifi-doorbell.jpg" },
						{ value: "doorbell_digitalsmart", label: "Digital Smart Doorbell", price: 259, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/digital-smart-doorbell.jpg" },
						{ value: "doorbell_smart_notsure", label: "Other / Not Sure", price: null, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/not-sure.jpg", notSure: true },
					]},
					{ key: "video", label: "Video Doorbell", types: [
						{ value: "doorbell_wiredvideo", label: "Wired Video Doorbell", price: 279, unit: "unit", limit: 10, image: doorbellVideoImg },
						{ value: "doorbell_wirelessvideo", label: "Wireless Video Doorbell", price: 319, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/wireless-video-doorbell.jpg" },
						{ value: "doorbell_wifivideo", label: "Wi-Fi Video Doorbell", price: 329, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/wifi-video-doorbell.jpg" },
						{ value: "doorbell_smartvideo", label: "Smart Video Doorbell", price: 379, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/smart-video-doorbell.jpg" },
						{ value: "doorbell_videochime", label: "Video Doorbell with Chime", price: 349, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/video-doorbell-chime.jpg" },
						{ value: "doorbell_video_notsure", label: "Other / Not Sure", price: null, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/not-sure.jpg", notSure: true },
					]},
					{ key: "doorphone", label: "Video Door Phone", types: [
						{ value: "doorphone_video", label: "Video Door Phone", price: 399, unit: "unit", limit: 10, image: doorbellDoorPhoneImg },
						{ value: "doorphone_indooroutdoor", label: "Indoor Display + Outdoor Unit", price: 499, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/indoor-outdoor-unit.jpg" },
						{ value: "doorphone_withdisplay", label: "Video Door Phone with Display", price: 459, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/door-phone-with-display.jpg" },
						{ value: "doorphone_withoutdisplay", label: "Video Door Phone without Display", price: 379, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/door-phone-without-display.jpg" },
						{ value: "doorphone_intercom", label: "Intercom Door Phone", price: 349, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/intercom-door-phone.jpg" },
						{ value: "doorphone_smartintercom", label: "Smart Video Intercom", price: 479, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/smart-video-intercom.jpg" },
						{ value: "doorphone_notsure", label: "Other / Not Sure", price: null, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/not-sure.jpg", notSure: true },
					]},
					{ key: "camera", label: "Security Camera", types: [
						{ value: "camera_wirelesscctv", label: "Wireless CCTV Camera", price: 249, unit: "unit", limit: 10, image: doorbellCameraImg },
						{ value: "camera_wifisecurity", label: "Wi-Fi Security Camera", price: 269, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/wifi-security-camera.jpg" },
						{ value: "camera_doorsecurity", label: "Door Security Camera", price: 229, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/door-security-camera.jpg" },
						{ value: "camera_notsure", label: "Other / Not Sure", price: null, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/not-sure.jpg", notSure: true },
					]},
					{ key: "sensors", label: "Security Sensors & Devices", types: [
						{ value: "sensor_door", label: "Door Sensor", price: 99, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/door-sensor.jpg" },
						{ value: "sensor_window", label: "Window Sensor", price: 99, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/window-sensor.jpg" },
						{ value: "sensor_motion", label: "Motion Sensor", price: 149, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/motion-sensor.jpg" },
						{ value: "sensor_smart", label: "Smart Security Device", price: 199, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/smart-security-device.jpg" },
						{ value: "sensor_notsure", label: "Other / Not Sure", price: null, unit: "unit", limit: 10, image: "/img/services/electrical/doorbell-security/not-sure.jpg", notSure: true },
					]},
				],
			},
			{
				value: "fan",
				label: "Fan",
				price: 0,
				unit: "unit",
				limit: 10,
				image: fanImg,
				// Has its own dedicated multi-step booking page instead of the
				// generic in-page work-type modal — see FanBookingPage.js.
				detailRoute: "/schedule-booking/technical/fan",
				includes: [
					"Fan repair, installation and removal",
					"Ceiling, wall, exhaust, BLDC/smart and heavy-duty fan types",
					"Basic testing after work",
				],
				excludes: [
					"New wiring or circuit work beyond the fan point",
					"False ceiling or civil work",
					"Cost of the fan unit itself unless separately purchased",
				],
				// PLACEHOLDER PRICING — tiered by fan-type complexity, pending real
				// per-type numbers. Install ≈ Repair × 1.5, Remove ≈ Repair × 0.5.
				// Consolidated to 5 categories (Ceiling Fan absorbs the old, mostly
				// duplicate "Designer / Luxury" category — only its one unique entry,
				// Premium Ceiling Fan, was folded in). Each type has its own `image`
				// (shared across Repair/Install/Remove — same physical fan).
				workTypes: [
					{
						key: "repair",
						label: "Repair",
						categories: [
							{ label: "Ceiling Fan", types: [
								{ value: "fan_repair_ceiling_normal", label: "Normal Ceiling Fan", price: 149, unit: "unit", limit: 5, image: fanCeilingImg },
								{ value: "fan_repair_ceiling_highspeed", label: "High-Speed Fan", price: 199, unit: "unit", limit: 5, image: "/img/services/electrical/fan/high-speed-ceiling-fan.jpg" },
								{ value: "fan_repair_ceiling_bldc", label: "BLDC Fan", price: 249, unit: "unit", limit: 5, image: "/img/services/electrical/fan/bldc-ceiling-fan.jpg" },
								{ value: "fan_repair_ceiling_smart", label: "Smart / Remote Fan", price: 249, unit: "unit", limit: 5, image: "/img/services/electrical/fan/smart-remote-ceiling-fan.jpg" },
								{ value: "fan_repair_ceiling_designer", label: "Designer Fan", price: 299, unit: "unit", limit: 5, image: "/img/services/electrical/fan/designer-ceiling-fan.jpg" },
								{ value: "fan_repair_ceiling_luxury", label: "Luxury Fan", price: 299, unit: "unit", limit: 5, image: "/img/services/electrical/fan/luxury-ceiling-fan.jpg" },
								{ value: "fan_repair_ceiling_decorative", label: "Decorative Fan", price: 299, unit: "unit", limit: 5, image: "/img/services/electrical/fan/decorative-ceiling-fan.jpg" },
								{ value: "fan_repair_ceiling_premium", label: "Premium Ceiling Fan", price: 299, unit: "unit", limit: 5, image: "/img/services/electrical/fan/premium-ceiling-fan.jpg" },
							]},
							{ label: "Wall Fan", types: [
								{ value: "fan_repair_wall_normal", label: "Normal Wall Fan", price: 149, unit: "unit", limit: 5, image: fanWallImg },
								{ value: "fan_repair_wall_highspeed", label: "High-Speed Wall Fan", price: 199, unit: "unit", limit: 5, image: "/img/services/electrical/fan/high-speed-wall-fan.jpg" },
								{ value: "fan_repair_wall_designer", label: "Designer Wall Fan", price: 299, unit: "unit", limit: 5, image: "/img/services/electrical/fan/designer-wall-fan.jpg" },
								{ value: "fan_repair_wall_other", label: "Other Wall Fan", price: 149, unit: "unit", limit: 5, image: "/img/services/electrical/fan/other-wall-fan.jpg" },
							]},
							{ label: "Exhaust Fan", types: [
								{ value: "fan_repair_exhaust_normal", label: "Normal Exhaust Fan", price: 149, unit: "unit", limit: 5, image: fanExhaustImg },
								{ value: "fan_repair_exhaust_bathroom", label: "Bathroom Exhaust Fan", price: 199, unit: "unit", limit: 5, image: "/img/services/electrical/fan/bathroom-exhaust-fan.jpg" },
								{ value: "fan_repair_exhaust_kitchen", label: "Kitchen Exhaust Fan", price: 199, unit: "unit", limit: 5, image: "/img/services/electrical/fan/kitchen-exhaust-fan.jpg" },
								{ value: "fan_repair_exhaust_window", label: "Window Exhaust Fan", price: 199, unit: "unit", limit: 5, image: "/img/services/electrical/fan/window-exhaust-fan.jpg" },
							]},
							{ label: "BLDC / Smart", types: [
								{ value: "fan_repair_bldcsmart_bldc", label: "BLDC Fan", price: 249, unit: "unit", limit: 5, image: fanBldcImg },
								{ value: "fan_repair_bldcsmart_remote", label: "Remote-Control Fan", price: 249, unit: "unit", limit: 5, image: "/img/services/electrical/fan/remote-control-fan.jpg" },
								{ value: "fan_repair_bldcsmart_smart", label: "Smart Fan", price: 249, unit: "unit", limit: 5, image: "/img/services/electrical/fan/smart-fan.jpg" },
								{ value: "fan_repair_bldcsmart_energy", label: "Energy-Saving Fan", price: 249, unit: "unit", limit: 5, image: "/img/services/electrical/fan/energy-saving-fan.jpg" },
							]},
							{ label: "Heavy-Duty / Other", types: [
								{ value: "fan_repair_heavyduty_heavyduty", label: "Heavy-Duty Fan", price: 399, unit: "unit", limit: 5, image: fanHeavyDutyImg },
								{ value: "fan_repair_heavyduty_industrial", label: "Industrial Fan", price: 399, unit: "unit", limit: 5, image: "/img/services/electrical/fan/industrial-fan.jpg" },
								{ value: "fan_repair_heavyduty_aircirculator", label: "Air Circulator", price: 199, unit: "unit", limit: 5, image: "/img/services/electrical/fan/air-circulator.jpg" },
								{ value: "fan_repair_heavyduty_tower", label: "Tower Fan", price: 199, unit: "unit", limit: 5, image: "/img/services/electrical/fan/tower-fan.jpg" },
								{ value: "fan_repair_heavyduty_pedestal", label: "Pedestal Fan", price: 199, unit: "unit", limit: 5, image: "/img/services/electrical/fan/pedestal-fan.jpg" },
								{ value: "fan_repair_heavyduty_other", label: "Other Fan", price: 149, unit: "unit", limit: 5, image: "/img/services/electrical/fan/other-fan.jpg" },
							]},
						],
					},
					{
						key: "install",
						label: "Install",
						categories: [
							{ label: "Ceiling Fan", types: [
								{ value: "fan_install_ceiling_normal", label: "Normal Ceiling Fan", price: 249, unit: "unit", limit: 5, image: fanCeilingImg },
								{ value: "fan_install_ceiling_highspeed", label: "High-Speed Fan", price: 299, unit: "unit", limit: 5, image: "/img/services/electrical/fan/high-speed-ceiling-fan.jpg" },
								{ value: "fan_install_ceiling_bldc", label: "BLDC Fan", price: 349, unit: "unit", limit: 5, image: "/img/services/electrical/fan/bldc-ceiling-fan.jpg" },
								{ value: "fan_install_ceiling_smart", label: "Smart / Remote Fan", price: 349, unit: "unit", limit: 5, image: "/img/services/electrical/fan/smart-remote-ceiling-fan.jpg" },
								{ value: "fan_install_ceiling_designer", label: "Designer Fan", price: 399, unit: "unit", limit: 5, image: "/img/services/electrical/fan/designer-ceiling-fan.jpg" },
								{ value: "fan_install_ceiling_luxury", label: "Luxury Fan", price: 399, unit: "unit", limit: 5, image: "/img/services/electrical/fan/luxury-ceiling-fan.jpg" },
								{ value: "fan_install_ceiling_decorative", label: "Decorative Fan", price: 399, unit: "unit", limit: 5, image: "/img/services/electrical/fan/decorative-ceiling-fan.jpg" },
								{ value: "fan_install_ceiling_premium", label: "Premium Ceiling Fan", price: 399, unit: "unit", limit: 5, image: "/img/services/electrical/fan/premium-ceiling-fan.jpg" },
							]},
							{ label: "Wall Fan", types: [
								{ value: "fan_install_wall_normal", label: "Normal Wall Fan", price: 249, unit: "unit", limit: 5, image: fanWallImg },
								{ value: "fan_install_wall_highspeed", label: "High-Speed Wall Fan", price: 299, unit: "unit", limit: 5, image: "/img/services/electrical/fan/high-speed-wall-fan.jpg" },
								{ value: "fan_install_wall_designer", label: "Designer Wall Fan", price: 399, unit: "unit", limit: 5, image: "/img/services/electrical/fan/designer-wall-fan.jpg" },
								{ value: "fan_install_wall_other", label: "Other Wall Fan", price: 249, unit: "unit", limit: 5, image: "/img/services/electrical/fan/other-wall-fan.jpg" },
							]},
							{ label: "Exhaust Fan", types: [
								{ value: "fan_install_exhaust_normal", label: "Normal Exhaust Fan", price: 249, unit: "unit", limit: 5, image: fanExhaustImg },
								{ value: "fan_install_exhaust_bathroom", label: "Bathroom Exhaust Fan", price: 299, unit: "unit", limit: 5, image: "/img/services/electrical/fan/bathroom-exhaust-fan.jpg" },
								{ value: "fan_install_exhaust_kitchen", label: "Kitchen Exhaust Fan", price: 299, unit: "unit", limit: 5, image: "/img/services/electrical/fan/kitchen-exhaust-fan.jpg" },
								{ value: "fan_install_exhaust_window", label: "Window Exhaust Fan", price: 299, unit: "unit", limit: 5, image: "/img/services/electrical/fan/window-exhaust-fan.jpg" },
							]},
							{ label: "BLDC / Smart", types: [
								{ value: "fan_install_bldcsmart_bldc", label: "BLDC Fan", price: 349, unit: "unit", limit: 5, image: fanBldcImg },
								{ value: "fan_install_bldcsmart_remote", label: "Remote-Control Fan", price: 349, unit: "unit", limit: 5, image: "/img/services/electrical/fan/remote-control-fan.jpg" },
								{ value: "fan_install_bldcsmart_smart", label: "Smart Fan", price: 349, unit: "unit", limit: 5, image: "/img/services/electrical/fan/smart-fan.jpg" },
								{ value: "fan_install_bldcsmart_energy", label: "Energy-Saving Fan", price: 349, unit: "unit", limit: 5, image: "/img/services/electrical/fan/energy-saving-fan.jpg" },
							]},
							{ label: "Heavy-Duty / Other", types: [
								{ value: "fan_install_heavyduty_heavyduty", label: "Heavy-Duty Fan", price: 549, unit: "unit", limit: 5, image: fanHeavyDutyImg },
								{ value: "fan_install_heavyduty_industrial", label: "Industrial Fan", price: 549, unit: "unit", limit: 5, image: "/img/services/electrical/fan/industrial-fan.jpg" },
								{ value: "fan_install_heavyduty_aircirculator", label: "Air Circulator", price: 299, unit: "unit", limit: 5, image: "/img/services/electrical/fan/air-circulator.jpg" },
								{ value: "fan_install_heavyduty_tower", label: "Tower Fan", price: 299, unit: "unit", limit: 5, image: "/img/services/electrical/fan/tower-fan.jpg" },
								{ value: "fan_install_heavyduty_pedestal", label: "Pedestal Fan", price: 299, unit: "unit", limit: 5, image: "/img/services/electrical/fan/pedestal-fan.jpg" },
								{ value: "fan_install_heavyduty_other", label: "Other Fan", price: 249, unit: "unit", limit: 5, image: "/img/services/electrical/fan/other-fan.jpg" },
							]},
						],
					},
					{
						key: "remove",
						label: "Remove",
						categories: [
							{ label: "Ceiling Fan", types: [
								{ value: "fan_remove_ceiling_normal", label: "Normal Ceiling Fan", price: 79, unit: "unit", limit: 5, image: fanCeilingImg },
								{ value: "fan_remove_ceiling_highspeed", label: "High-Speed Fan", price: 99, unit: "unit", limit: 5, image: "/img/services/electrical/fan/high-speed-ceiling-fan.jpg" },
								{ value: "fan_remove_ceiling_bldc", label: "BLDC Fan", price: 129, unit: "unit", limit: 5, image: "/img/services/electrical/fan/bldc-ceiling-fan.jpg" },
								{ value: "fan_remove_ceiling_smart", label: "Smart / Remote Fan", price: 129, unit: "unit", limit: 5, image: "/img/services/electrical/fan/smart-remote-ceiling-fan.jpg" },
								{ value: "fan_remove_ceiling_designer", label: "Designer Fan", price: 149, unit: "unit", limit: 5, image: "/img/services/electrical/fan/designer-ceiling-fan.jpg" },
								{ value: "fan_remove_ceiling_luxury", label: "Luxury Fan", price: 149, unit: "unit", limit: 5, image: "/img/services/electrical/fan/luxury-ceiling-fan.jpg" },
								{ value: "fan_remove_ceiling_decorative", label: "Decorative Fan", price: 149, unit: "unit", limit: 5, image: "/img/services/electrical/fan/decorative-ceiling-fan.jpg" },
								{ value: "fan_remove_ceiling_premium", label: "Premium Ceiling Fan", price: 149, unit: "unit", limit: 5, image: "/img/services/electrical/fan/premium-ceiling-fan.jpg" },
							]},
							{ label: "Wall Fan", types: [
								{ value: "fan_remove_wall_normal", label: "Normal Wall Fan", price: 79, unit: "unit", limit: 5, image: fanWallImg },
								{ value: "fan_remove_wall_highspeed", label: "High-Speed Wall Fan", price: 99, unit: "unit", limit: 5, image: "/img/services/electrical/fan/high-speed-wall-fan.jpg" },
								{ value: "fan_remove_wall_designer", label: "Designer Wall Fan", price: 149, unit: "unit", limit: 5, image: "/img/services/electrical/fan/designer-wall-fan.jpg" },
								{ value: "fan_remove_wall_other", label: "Other Wall Fan", price: 79, unit: "unit", limit: 5, image: "/img/services/electrical/fan/other-wall-fan.jpg" },
							]},
							{ label: "Exhaust Fan", types: [
								{ value: "fan_remove_exhaust_normal", label: "Normal Exhaust Fan", price: 79, unit: "unit", limit: 5, image: fanExhaustImg },
								{ value: "fan_remove_exhaust_bathroom", label: "Bathroom Exhaust Fan", price: 99, unit: "unit", limit: 5, image: "/img/services/electrical/fan/bathroom-exhaust-fan.jpg" },
								{ value: "fan_remove_exhaust_kitchen", label: "Kitchen Exhaust Fan", price: 99, unit: "unit", limit: 5, image: "/img/services/electrical/fan/kitchen-exhaust-fan.jpg" },
								{ value: "fan_remove_exhaust_window", label: "Window Exhaust Fan", price: 99, unit: "unit", limit: 5, image: "/img/services/electrical/fan/window-exhaust-fan.jpg" },
							]},
							{ label: "BLDC / Smart", types: [
								{ value: "fan_remove_bldcsmart_bldc", label: "BLDC Fan", price: 129, unit: "unit", limit: 5, image: fanBldcImg },
								{ value: "fan_remove_bldcsmart_remote", label: "Remote-Control Fan", price: 129, unit: "unit", limit: 5, image: "/img/services/electrical/fan/remote-control-fan.jpg" },
								{ value: "fan_remove_bldcsmart_smart", label: "Smart Fan", price: 129, unit: "unit", limit: 5, image: "/img/services/electrical/fan/smart-fan.jpg" },
								{ value: "fan_remove_bldcsmart_energy", label: "Energy-Saving Fan", price: 129, unit: "unit", limit: 5, image: "/img/services/electrical/fan/energy-saving-fan.jpg" },
							]},
							{ label: "Heavy-Duty / Other", types: [
								{ value: "fan_remove_heavyduty_heavyduty", label: "Heavy-Duty Fan", price: 199, unit: "unit", limit: 5, image: fanHeavyDutyImg },
								{ value: "fan_remove_heavyduty_industrial", label: "Industrial Fan", price: 199, unit: "unit", limit: 5, image: "/img/services/electrical/fan/industrial-fan.jpg" },
								{ value: "fan_remove_heavyduty_aircirculator", label: "Air Circulator", price: 99, unit: "unit", limit: 5, image: "/img/services/electrical/fan/air-circulator.jpg" },
								{ value: "fan_remove_heavyduty_tower", label: "Tower Fan", price: 99, unit: "unit", limit: 5, image: "/img/services/electrical/fan/tower-fan.jpg" },
								{ value: "fan_remove_heavyduty_pedestal", label: "Pedestal Fan", price: 99, unit: "unit", limit: 5, image: "/img/services/electrical/fan/pedestal-fan.jpg" },
								{ value: "fan_remove_heavyduty_other", label: "Other Fan", price: 79, unit: "unit", limit: 5, image: "/img/services/electrical/fan/other-fan.jpg" },
							]},
						],
					},
					{
						key: "consultation",
						label: "Consultation",
						flat: { value: "fan_consultation", label: "Fan Consultation", price: 99, unit: "visit", limit: 1, image: "/img/services/electrical/fan/consultation.jpg" },
					},
				],
			},
			{
				value: "inverter-ups",
				label: "Inverter UPS",
				price: 0,
				unit: "unit",
				limit: 10,
				image: inverterUpsImg,
				// Has its own dedicated multi-step booking page — see InverterUpsBookingPage.js.
				detailRoute: "/schedule-booking/technical/inverter-ups",
				includes: [
					"Inverter, UPS, battery and fuse repair, replacement, installation and removal",
					"Wiring & switch point for new installations",
					"Basic testing after work",
				],
				excludes: [
					"Cost of the inverter/UPS/battery unit itself unless separately purchased",
					"Major civil or false-ceiling work",
					"Long-distance wiring beyond the unit's own point",
				],
				workTypes: [
					{ key: "repair", label: "Repair" },
					{ key: "replace", label: "Replace" },
					{ key: "install", label: "Install" },
					{ key: "remove", label: "Remove" },
				],
				consultation: {
					value: "inverter_consultation",
					label: "Inverter/UPS Consultation",
					price: 99,
					unit: "visit",
					limit: 1,
					image: "/img/services/electrical/inverter-ups/consultation.jpg",
				},
				// Nested picker shown only when "New Installation" is picked for
				// Inverter / UPS / Inverter-UPS System — never asks VA/Ah/wiring
				// size, just which unit(s) to install. `material` is the
				// placeholder cost of the unit itself (Labour + Material shown
				// separately at checkout, same split as Switch & Socket).
				newInstallationOptions: [
					{ value: "install_inverter", label: "Inverter", price: 349, material: 249 },
					{ value: "install_ups", label: "UPS", price: 349, material: 249 },
					{ value: "install_inverter_battery", label: "Inverter + Battery", price: 549, material: 449 },
					{ value: "install_ups_battery", label: "UPS + Battery", price: 549, material: 449 },
					{ value: "install_notsure", label: "Not Sure", price: 349, material: 0 },
				],
				// PLACEHOLDER PRICING — {components[].exactWork[]}, same shape as
				// Appliance's {appliances[].subServices[]}. Consultation is now a
				// separate, always-optional Step 5 (not a list item here) — see
				// the booking page's "note" step. `isInstall` items open
				// newInstallationOptions instead of adding directly.
				components: [
					{ key: "inverter", label: "Inverter", image: inverterUpsInverterImg, exactWork: [
						{ value: "inverter_repair", label: "Repair", price: 179 },
						{ value: "inverter_replace", label: "Replacement", price: 199, material: 149 },
						{ value: "inverter_install", label: "New Installation", isInstall: true },
						{ value: "inverter_remove", label: "Removal", price: 99 },
						{ value: "inverter_checkup", label: "Check-up", price: 129 },
					]},
					{ key: "ups", label: "UPS", image: inverterUpsUpsImg, exactWork: [
						{ value: "ups_repair", label: "Repair", price: 179 },
						{ value: "ups_replace", label: "Replacement", price: 199, material: 149 },
						{ value: "ups_install", label: "New Installation", isInstall: true },
						{ value: "ups_remove", label: "Removal", price: 99 },
						{ value: "ups_checkup", label: "Check-up", price: 129 },
					]},
					{ key: "battery", label: "Battery", image: inverterUpsBatteryImg, exactWork: [
						{ value: "battery_replace", label: "Battery Replacement", price: 179, material: 249 },
						{ value: "battery_problem", label: "Battery Problem", price: 129 },
						{ value: "battery_check", label: "Battery Check", price: 99 },
						{ value: "battery_install", label: "New Battery Installation", price: 249, material: 299 },
						{ value: "battery_water_check", label: "Battery Water Check", price: 79 },
						{ value: "battery_water_topup", label: "Water Top-up", price: 99, material: 49 },
					]},
					{ key: "system", label: "Inverter / UPS System", image: inverterUpsSystemImg, exactWork: [
						{ value: "system_repair", label: "Repair", price: 249 },
						{ value: "system_replace", label: "Replacement", price: 299, material: 249 },
						{ value: "system_install", label: "New Installation", isInstall: true },
						{ value: "system_remove", label: "Removal", price: 149 },
						{ value: "system_checkup", label: "Check-up", price: 179 },
					]},
					{ key: "battery-water", label: "Battery Water", image: inverterUpsBatteryWaterImg, exactWork: [
						{ value: "waterservice_check", label: "Battery Water Check", price: 79 },
						{ value: "waterservice_topup", label: "Water Top-up", price: 99, material: 49 },
						{ value: "waterservice_batterycheck", label: "Battery Check", price: 99 },
					]},
					// No structured exact-work list — always routes straight to
					// the freeform "Tell us your requirement" consultation panel.
					{ key: "other", label: "Other", image: applianceNotSureImg, exactWork: [] },
				],
			},
			{
				value: "light",
				label: "Light",
				price: 0,
				unit: "unit",
				limit: 20,
				image: lightImg,
				// Has its own dedicated multi-step booking page — see LightBookingPage.js.
				detailRoute: "/schedule-booking/technical/light",
				includes: [
					"Light repair, replacement, installation and removal",
					"Normal, LED, ceiling, downlight, wall, decorative and luxury light types",
					"Basic testing after work",
				],
				excludes: [
					"Cost of the light fixture itself unless separately purchased",
					"New wiring or circuit modification beyond the light point",
					"False ceiling or civil work",
				],
				// PLACEHOLDER PRICING — per-light labour price × work-type
				// multiplier, same computation model as Switch & Socket / CCTV.
				// "Luxury" types are flagged startingPrice: true — checkout shows
				// "Starting Price" instead of a fixed total and consultation is
				// encouraged rather than skippable by default.
				workTypes: [
					{ key: "repair", label: "Repair", multiplier: 1.0 },
					{ key: "replace", label: "Replace", multiplier: 1.2 },
					{ key: "install", label: "Install", multiplier: 1.4 },
					{ key: "remove", label: "Remove", multiplier: 0.5 },
				],
				consultation: {
					value: "light_consultation",
					label: "Light Consultation",
					price: 99,
					unit: "visit",
					limit: 1,
					image: "/img/services/electrical/light/consultation.jpg",
				},
				subCategories: [
					{ key: "normal", label: "Normal", types: [
						{ value: "light_bulb", label: "Bulb", price: 79, unit: "unit", limit: 20, image: lightImg },
						{ value: "light_holder", label: "Holder", price: 79, unit: "unit", limit: 20, image: "/img/services/electrical/light/holder.jpg" },
						{ value: "light_tubelight", label: "Tube Light", price: 99, unit: "unit", limit: 20, image: "/img/services/electrical/light/tube-light.jpg" },
						{ value: "light_ledbatten", label: "LED Batten", price: 129, unit: "unit", limit: 20, image: "/img/services/electrical/light/led-batten.jpg" },
					]},
					{ key: "led", label: "LED", types: [
						{ value: "light_led", label: "LED Light", price: 99, unit: "unit", limit: 20, image: lightLedImg },
						{ value: "light_ledpanel", label: "LED Panel", price: 149, unit: "unit", limit: 20, image: "/img/services/electrical/light/led-panel.jpg" },
						{ value: "light_ledceiling", label: "LED Ceiling Light", price: 179, unit: "unit", limit: 20, image: "/img/services/electrical/light/led-ceiling.jpg" },
					]},
					{ key: "ceiling", label: "Ceiling", types: [
						{ value: "light_ceiling", label: "Ceiling Light", price: 149, unit: "unit", limit: 20, image: lightCeilingImg },
						{ value: "light_surface", label: "Surface Light", price: 129, unit: "unit", limit: 20, image: "/img/services/electrical/light/surface-light.jpg" },
						{ value: "light_flush", label: "Flush Light", price: 149, unit: "unit", limit: 20, image: "/img/services/electrical/light/flush-light.jpg" },
					]},
					{ key: "downlight", label: "Downlight", types: [
						{ value: "light_downlight", label: "Downlight", price: 129, unit: "unit", limit: 20, image: lightDownlightImg },
						{ value: "light_spotlight", label: "Spot Light", price: 129, unit: "unit", limit: 20, image: "/img/services/electrical/light/spot-light.jpg" },
						{ value: "light_cob", label: "COB Light", price: 149, unit: "unit", limit: 20, image: "/img/services/electrical/light/cob-light.jpg" },
						{ value: "light_track", label: "Track Light", price: 179, unit: "unit", limit: 20, image: "/img/services/electrical/light/track-light.jpg" },
					]},
					{ key: "wall", label: "Wall", types: [
						{ value: "light_walllight", label: "Wall Light", price: 129, unit: "unit", limit: 20, image: lightWallImg },
						{ value: "light_mirror", label: "Mirror Light", price: 149, unit: "unit", limit: 20, image: "/img/services/electrical/light/mirror-light.jpg" },
						{ value: "light_bedside", label: "Bedside Light", price: 99, unit: "unit", limit: 20, image: "/img/services/electrical/light/bedside-light.jpg" },
					]},
					{ key: "decorative", label: "Decorative", types: [
						{ value: "light_pendant", label: "Pendant", price: 249, unit: "unit", limit: 20, image: lightDecorativeImg },
						{ value: "light_hanging", label: "Hanging Light", price: 249, unit: "unit", limit: 20, image: "/img/services/electrical/light/hanging-light.jpg" },
						{ value: "light_designer", label: "Designer Light", price: 299, unit: "unit", limit: 20, image: "/img/services/electrical/light/designer-light.jpg" },
					]},
					// Chandeliers/large decorative/high-ceiling — startingPrice
					// flags Starting-Price checkout language + encourages
					// consultation, per the "Luxury Light Special Rule".
					{ key: "luxury", label: "Luxury", types: [
						{ value: "light_chandelier", label: "Chandelier", price: 499, unit: "unit", limit: 10, image: lightLuxuryImg, startingPrice: true },
						{ value: "light_largedecorative", label: "Large Decorative Light", price: 449, unit: "unit", limit: 10, image: "/img/services/electrical/light/large-decorative.jpg", startingPrice: true },
						{ value: "light_luxuryceiling", label: "Designer/Luxury Ceiling Light", price: 449, unit: "unit", limit: 10, image: "/img/services/electrical/light/luxury-ceiling.jpg", startingPrice: true },
					]},
					// No structured types — routes straight to the freeform
					// "Tell us your requirement" consultation panel.
					{ key: "other", label: "Other", types: [] },
				],
			},
			{
				value: "mcb-fuse",
				label: "MCB / Fuse",
				price: 0,
				unit: "unit",
				limit: 20,
				image: mcbFuseImg,
				// Has its own dedicated multi-step booking page — see MCBFuseBookingPage.js.
				detailRoute: "/schedule-booking/technical/mcb-fuse",
				includes: [
					"MCB/fuse repair, replacement, installation and removal",
					"New MCB box installation with pre-work inspection",
					"Basic testing after work",
				],
				excludes: [
					"Ampere rating, cable size, MCB curve or load calculation selection — handled by the technician",
					"New wiring or circuit modification beyond the MCB/fuse point",
					"Panel/board civil work",
				],
				// PLACEHOLDER PRICING — per-item labour price × work-type
				// multiplier, same computation model as Switch & Socket / CCTV / Light.
				// New/Replace MCB Box are flagged startingPrice: true — checkout shows
				// "Starting Price" since the electrician must inspect the existing
				// setup before finalizing the box, MCB requirements and price.
				workTypes: [
					{ key: "repair", label: "Repair", multiplier: 1.0, description: "MCB/fuse is not working or keeps tripping." },
					{ key: "replace", label: "Replace", multiplier: 1.15, description: "Replace an old or damaged MCB/fuse." },
					{ key: "install", label: "Install", multiplier: 1.3, description: "Install a new MCB, fuse or MCB box." },
					{ key: "remove", label: "Remove", multiplier: 0.6, description: "Remove an existing MCB/fuse/box." },
				],
				consultation: {
					value: "mcb_fuse_consultation",
					label: "MCB / Fuse Consultation",
					price: 99,
					unit: "visit",
					limit: 1,
					image: "/img/services/electrical/mcb-fuse/consultation.jpg",
				},
				// No ampere rating, cable size, MCB curve, fuse rating, number of
				// ways, box size, wiring or load-calculation questions are ever
				// asked — those stay under technician + ERP control per the spec.
				subCategories: [
					{ key: "mcb", label: "MCB", types: [
						{ value: "mcb_main", label: "Main MCB", price: 249, unit: "unit", limit: 5, image: mcbMainImg },
						{ value: "mcb_individual", label: "Individual MCB", price: 149, unit: "unit", limit: 20, image: "/img/services/electrical/mcb-fuse/individual-mcb.jpg" },
						{ value: "mcb_multiple", label: "Multiple MCB", price: 129, unit: "unit", limit: 20, image: "/img/services/electrical/mcb-fuse/multiple-mcb.jpg" },
						{ value: "mcb_notsure", label: "Not Sure", price: 149, unit: "unit", limit: 5, image: "/img/services/electrical/mcb-fuse/not-sure.jpg" },
					]},
					{ key: "fuse", label: "Fuse", types: [
						{ value: "fuse_problem", label: "Fuse Problem", price: 99, unit: "unit", limit: 20, image: mcbFuseImg2 },
						{ value: "fuse_replacement", label: "Fuse Replacement", price: 89, unit: "unit", limit: 20, image: "/img/services/electrical/mcb-fuse/fuse-replacement.jpg" },
						{ value: "fuse_installation", label: "Fuse Installation", price: 89, unit: "unit", limit: 20, image: "/img/services/electrical/mcb-fuse/fuse-installation.jpg" },
						{ value: "fuse_notsure", label: "Not Sure", price: 99, unit: "unit", limit: 20, image: "/img/services/electrical/mcb-fuse/not-sure.jpg" },
					]},
					// New MCB box installation is called out as its own important
					// service in the spec — New/Replace Box carry startingPrice.
					{ key: "mcbbox", label: "MCB Box", types: [
						{ value: "mcbbox_new", label: "New Box", price: 349, unit: "unit", limit: 3, image: mcbBoxImg, startingPrice: true },
						{ value: "mcbbox_replace", label: "Replace Box", price: 329, unit: "unit", limit: 3, image: "/img/services/electrical/mcb-fuse/replace-box.jpg", startingPrice: true },
						{ value: "mcbbox_repair", label: "Repair Box", price: 249, unit: "unit", limit: 3, image: "/img/services/electrical/mcb-fuse/repair-box.jpg" },
						{ value: "mcbbox_remove", label: "Remove Box", price: 149, unit: "unit", limit: 3, image: "/img/services/electrical/mcb-fuse/remove-box.jpg" },
					]},
					// No structured types — routes straight to the freeform
					// "Tell us your requirement" consultation panel.
					{ key: "other", label: "Other", types: [] },
				],
			},
			{
				value: "stabilizer",
				label: "Stabilizer",
				price: 0,
				unit: "unit",
				limit: 10,
				image: stabilizerImg,
				// Has its own dedicated multi-step booking page — see StabilizerBookingPage.js.
				detailRoute: "/schedule-booking/technical/stabilizer",
				includes: [
					"Stabiliser repair, replacement, installation and removal",
					"Home, AC, TV, Fridge, general appliance and commercial stabilisers",
					"Basic testing after work",
				],
				excludes: [
					"kVA, voltage range, load calculation, cable size or MCB rating selection — handled by the electrician",
					"The stabiliser unit itself unless separately purchased",
					"New wiring or major circuit modification",
				],
				// PLACEHOLDER PRICING — per-appliance labour price × work-type
				// multiplier, same computation model as Doorbell & Security.
				// New installations (workType "install") and Commercial always
				// carry startingPrice — final price confirmed after the
				// electrician checks the appliance and electrical requirements.
				workTypes: [
					{ key: "repair", label: "Repair", multiplier: 1.0, description: "Existing stabiliser is not working properly." },
					{ key: "replace", label: "Replace", multiplier: 1.15, description: "Replace an old or damaged stabiliser." },
					{ key: "install", label: "Install", multiplier: 1.4, description: "Install a new stabiliser." },
					{ key: "remove", label: "Remove", multiplier: 0.6, description: "Remove an existing stabiliser." },
				],
				consultation: {
					value: "stabilizer_consultation",
					label: "Stabiliser Consultation",
					price: 99,
					unit: "visit",
					limit: 1,
					image: "/img/services/electrical/stabilizer/consultation.jpg",
				},
				subCategories: [
					{ key: "appliance", label: "Appliance", types: [
						{ value: "stabilizer_home", label: "Home", price: 349, unit: "unit", limit: 10, image: "/img/services/electrical/stabilizer/home.jpg" },
						{ value: "stabilizer_ac", label: "AC", price: 449, unit: "unit", limit: 10, image: "/img/services/electrical/stabilizer/ac.jpg" },
						{ value: "stabilizer_tv", label: "TV", price: 249, unit: "unit", limit: 10, image: "/img/services/electrical/stabilizer/tv.jpg" },
						{ value: "stabilizer_fridge", label: "Fridge", price: 349, unit: "unit", limit: 10, image: "/img/services/electrical/stabilizer/fridge.jpg" },
						{ value: "stabilizer_appliance", label: "Appliance", price: 299, unit: "unit", limit: 10, image: "/img/services/electrical/stabilizer/appliance.jpg" },
						{ value: "stabilizer_commercial", label: "Commercial", price: 899, unit: "unit", limit: 10, image: "/img/services/electrical/stabilizer/commercial.jpg", startingPrice: true },
						{ value: "stabilizer_notsure", label: "Not Sure", price: 249, unit: "unit", limit: 1, image: "/img/services/electrical/stabilizer/not-sure.jpg", notSure: true },
					]},
				],
			},
			{
				value: "submeter-water-sensor",
				label: "Submeter & Water Sensor",
				price: 0,
				unit: "unit",
				limit: 10,
				image: submeterImg,
				// Has its own dedicated multi-step booking page — see SubmeterWaterSensorBookingPage.js.
				detailRoute: "/schedule-booking/technical/submeter-water-sensor",
				includes: [
					"Electric submeter, water load sensor and meter/sensor box repair, replacement, installation and removal",
					"Basic testing after work",
				],
				excludes: [
					"Meter rating, voltage, current, sensor specifications, pipe size, wiring/cable/box size or connection details — handled by the technician",
					"The meter/sensor unit itself unless separately purchased",
					"New wiring or major plumbing modification",
				],
				// PLACEHOLDER PRICING — per-type labour price × work-type
				// multiplier, same computation model as Stabiliser. New
				// installations (workType "install") carry startingPrice —
				// final requirement and price confirmed after technician
				// inspection, same "Requirement/Inspection" job handling.
				workTypes: [
					{ key: "repair", label: "Repair", multiplier: 1.0, description: "Existing submeter or water sensor has a problem." },
					{ key: "replace", label: "Replace", multiplier: 1.15, description: "Replace an old or damaged unit." },
					{ key: "install", label: "Install", multiplier: 1.4, description: "Install a new submeter, water sensor or box." },
					{ key: "remove", label: "Remove", multiplier: 0.6, description: "Remove an existing unit." },
				],
				consultation: {
					value: "submeter_water_sensor_consultation",
					label: "Submeter & Water Sensor Consultation",
					price: 99,
					unit: "visit",
					limit: 1,
					image: "/img/services/electrical/submeter-water-sensor/consultation.jpg",
				},
				// Exact-service label per (work, type) combo — auto-generated,
				// never asked as a separate customer selection (avoids making
				// the customer pick duplicate information manually). Box
				// repair has no common real-world meaning, so it maps to
				// "Not Sure" and forces a mandatory consultation.
				exactServiceLabels: {
					install:  { submeter: "New Submeter Installation", watersensor: "New Water Sensor Installation", box: "New Meter / Sensor Box" },
					repair:   { submeter: "Submeter Repair", watersensor: "Water Sensor Repair", box: "Not Sure" },
					replace:  { submeter: "Submeter Replacement", watersensor: "Water Sensor Replacement", box: "Box Replacement" },
					remove:   { submeter: "Submeter Removal", watersensor: "Water Sensor Removal", box: "Box Removal" },
				},
				subCategories: [
					{ key: "type", label: "Type", types: [
						{ value: "submeter", label: "Electric Submeter", price: 449, unit: "unit", limit: 10, image: submeterElectricImg },
						{ value: "watersensor", label: "Water Load Sensor", price: 399, unit: "unit", limit: 10, image: submeterWaterSensorImg },
						{ value: "box", label: "Meter / Sensor Box", price: 349, unit: "unit", limit: 10, image: submeterBoxImg },
					]},
				],
			},
			{
				value: "switchboard",
				label: "Switchboard",
				price: 0,
				unit: "unit",
				limit: 1,
				image: switchboardMainImg,
				// Has its own dedicated multi-step booking page — see SwitchboardBookingPage.js.
				detailRoute: "/schedule-booking/technical/switchboard",
				includes: [
					"Switchboard, box and selected plate",
					"Basic electrical connection and up to 2.5m wiring",
					"Installation labour and basic testing",
				],
				excludes: [
					"More than 2.5m wiring — charged separately after approval",
					"Complete house wiring or major rewiring",
					"Major wall breaking, plastering or painting",
					"Main electrical panel work",
					"Appliance repair",
				],
				// PLACEHOLDER PRICING — per-points-tier labour price × work-type
				// multiplier. New/Old switchboard is never a customer-facing
				// question — it's auto-preselected (Install → New, everything
				// else → Old) per the spec's "avoid unnecessary questions" rule.
				workTypes: [
					{ key: "repair", label: "Repair", multiplier: 1.0 },
					{ key: "replace", label: "Replace", multiplier: 1.15 },
					{ key: "install", label: "Install", multiplier: 1.4 },
					{ key: "remove", label: "Remove", multiplier: 0.6 },
					{ key: "notsure", label: "Not Sure", multiplier: 1.0 },
				],
				subCategories: [
					{ key: "points", label: "Points", types: [
						{ value: "switchboard_2", label: "2", price: 349, unit: "unit", limit: 1, image: switchboard2Img },
						{ value: "switchboard_4", label: "4", price: 409, unit: "unit", limit: 1, image: switchboard4Img },
						{ value: "switchboard_6", label: "6", price: 469, unit: "unit", limit: 1, image: switchboard6Img },
						{ value: "switchboard_8", label: "8", price: 529, unit: "unit", limit: 1, image: switchboard8Img },
						{ value: "switchboard_12", label: "12", price: 649, unit: "unit", limit: 1, image: switchboard12Img },
						{ value: "switchboard_16", label: "16", price: 769, unit: "unit", limit: 1, image: switchboard16Img },
						// Vestigial price, never actually charged — Not Sure
						// always routes straight to Photo + Schedule (inspection
						// required), same convention as CCTV/Doorbell/Stabiliser.
						{ value: "switchboard_notsure", label: "Not Sure", price: 469, unit: "unit", limit: 1, image: applianceNotSureImg, notSure: true },
					]},
				],
			},
			{
				value: "wiring",
				label: "Wiring",
				price: 0,
				unit: "unit",
				limit: 1,
				image: wiringMainImg,
				// Has its own dedicated multi-step booking page — see WiringBookingPage.js.
				detailRoute: "/schedule-booking/technical/wiring",
				includes: [
					"New wiring or old/faulty wiring repair, internal or external",
					"Multiple electrical points in one visit (light, fan, socket, switchboard, AC, geyser, inverter, MCB, water pump, other)",
					"Minimum 6m wiring, labour and basic testing",
				],
				excludes: [
					"Complete house rewiring, major concealed wiring or large-scale electrical projects",
					"Major wall breaking or civil work",
					"Painting / plastering",
					"Main electrical panel work or underground cable work",
				],
				// Step 1 of the supplied "Customer Booking Process" — broad
				// intent, label-only (no price impact; the real price comes
				// from the Wiring Type chosen in Step 2 below). Selecting
				// Consultation short-circuits straight to the flat consultation
				// charge, same as every other category.
				workTypes: [
					{ key: "repair", label: "Repair / Faulty Wiring", description: "Wiring is damaged, loose, exposed or not working correctly." },
					{ key: "new", label: "New Wiring", description: "Need wiring for a new point, appliance, light, fan or other electrical requirement." },
					{ key: "replace", label: "Replace Wiring", description: "Existing wiring needs replacement." },
					{ key: "extend", label: "Extend Wiring", description: "Need to extend an existing electrical connection to another suitable location." },
				],
				consultation: {
					value: "wiring_consultation",
					label: "Wiring Consultation",
					price: 99,
					unit: "visit",
					limit: 1,
					image: "/img/services/electrical/wiring/consultation.jpg",
				},
				// Step 3 — "What is the wiring for?" — label-only, helps ERP
				// understand the intended load/use without asking the customer
				// for technical electrical details.
				purposes: [
					{ value: "light", label: "Light" },
					{ value: "fan", label: "Fan" },
					{ value: "switch_socket", label: "Switch / Socket" },
					{ value: "doorbell_security", label: "Doorbell / Security" },
					{ value: "appliance", label: "Appliance" },
					{ value: "new_point", label: "New Electrical Point" },
					{ value: "other_notsure", label: "Other / Not Sure" },
				],
				// Step 4 — approximate length only; the doc is explicit that the
				// final measurable length is verified by the electrician
				// on-site, so this is label-only, never priced directly.
				lengthOptions: [
					{ value: "upto5m", label: "Up to 5 m" },
					{ value: "5to10m", label: "5–10 m" },
					{ value: "10to20m", label: "10–20 m" },
					{ value: "more20m", label: "More than 20 m" },
					{ value: "notsure", label: "Not Sure" },
				],
				// Step 5 — label-only, no price impact.
				connectionOptions: [
					{ value: "yes", label: "Existing Connection Available" },
					{ value: "no", label: "No Existing Connection" },
					{ value: "notsure", label: "Not Sure" },
				],
				// Step 2 — Wiring Type, the only dimension that carries price.
				// Matches the catalogue in the supplied spec's section 12
				// (External Clips/Casing, Internal, New Point, Extension,
				// Repair/Faulty, Consultation) one-for-one with its own
				// numbered process-flow sections 5–11.
				subCategories: [
					{ key: "wiring-type", label: "Wiring Type", types: [
						{ value: "wiring_external_clips", label: "External Wiring with Clips", price: 299, unit: "job", limit: 10 },
						{ value: "wiring_external_casing", label: "External Wiring with Casing / Conduit", price: 399, unit: "job", limit: 10 },
						{ value: "wiring_internal_concealed", label: "Internal / Concealed Wiring", price: 499, unit: "job", limit: 10 },
						{ value: "wiring_new_point", label: "New Electrical Point Wiring", price: 249, unit: "job", limit: 10 },
						{ value: "wiring_extension", label: "Extension Wiring", price: 199, unit: "job", limit: 10 },
						{ value: "wiring_repair", label: "Wiring Repair / Faulty Wiring", price: 179, unit: "job", limit: 10 },
						// Vestigial price, never actually charged — Consultation/
						// Not Sure always routes to the flat consultation line.
						{ value: "wiring_consultation_notsure", label: "Consultation / Not Sure", price: 99, unit: "visit", limit: 1, notSure: true },
					]},
				],
				// Points are informational metadata (shown in the summary/
				// checkout, not priced individually) — a small flat add-on
				// per point reflects the extra complexity of wiring multiple
				// points in one visit. Never asked: wire type, cable size,
				// exact length if unknown, load calculation, MCB requirement,
				// route calculation, safety requirements, material spec.
				points: [
					{ key: "light", label: "Light", image: "/img/services/electrical/wiring/light.jpg" },
					{ key: "fan", label: "Fan", image: "/img/services/electrical/wiring/fan.jpg" },
					{ key: "socket", label: "Socket", image: "/img/services/electrical/wiring/socket.jpg" },
					{ key: "switchboard", label: "Switchboard", image: "/img/services/electrical/wiring/switchboard.jpg" },
					{ key: "ac", label: "AC", image: "/img/services/electrical/wiring/ac.jpg" },
					{ key: "geyser", label: "Geyser", image: "/img/services/electrical/wiring/geyser.jpg" },
					{ key: "inverter", label: "Inverter", image: "/img/services/electrical/wiring/inverter.jpg" },
					{ key: "mcb", label: "MCB", image: "/img/services/electrical/wiring/mcb.jpg" },
					{ key: "waterpump", label: "Water Pump", image: "/img/services/electrical/wiring/water-pump.jpg" },
					{ key: "other", label: "Other Appliance", image: "/img/services/electrical/wiring/other.jpg" },
				],
				perPointPrice: 39,
			},
		  ],
		},

		"plumber-services": {
		  label: "Plumber Worker",
		  types: [
			{
			  value: "tap-repair",
			  label: "Tap Repair",
			  price: 199,
			  unit: "tap",
			  limit: 5,
			  image: "/img/services/plumber/tap_repair.jpg",
			  includes: [
				"Tap leakage inspection",
				"Basic tap repair",
				"Water flow check",
			  ],
			  excludes: [
				"New tap purchase",
				"Pipeline replacement",
				"Wall breaking",
			  ],
			},
			{
			  value: "pipe-leakage-fix",
			  label: "Pipe Leakage Fix",
			  price: 349,
			  unit: "point",
			  limit: 5,
			  image: "/img/services/plumber/pipe_leakage.jpg",
			  includes: [
				"Visible leakage inspection",
				"Minor leak fixing support",
				"Joint tightening",
			  ],
			  excludes: [
				"Full pipe replacement",
				"Underground pipe work",
				"Wall reconstruction",
			  ],
			},
			{
			  value: "wash-basin-installation",
			  label: "Wash Basin Installation",
			  price: 599,
			  unit: "job",
			  limit: 3,
			  image: "/img/services/plumber/wash_basin_installation.jpg",
			  includes: [
				"Basic wash basin fitting",
				"Alignment support",
				"Functional check",
			  ],
			  excludes: [
				"New basin supply",
				"Tile cutting",
				"Drainage redesign",
			  ],
			},
			{
			  value: "toilet-repair",
			  label: "Toilet Repair",
			  price: 499,
			  unit: "job",
			  limit: 5,
			  image: "/img/services/plumber/toilet_repair.jpg",
			  includes: [
				"Flush issue inspection",
				"Basic repair support",
				"Water flow check",
			  ],
			  excludes: [
				"Full commode replacement",
				"Drain line replacement",
				"Civil work",
			  ],
			},
			{
			  value: "water-tank-cleaning",
			  label: "Water Tank Cleaning",
			  price: 899,
			  unit: "tank",
			  limit: 2,
			  image: "/img/services/plumber/water_tank_cleaning.jpg",
			  includes: [
				"Tank cleaning support",
				"Sludge removal cleaning",
				"Basic wash service",
			  ],
			  excludes: [
				"Tank crack repair",
				"New tank installation",
				"Pipeline chemical treatment",
			  ],
			},
			{
			  value: "drainage-block-fix",
			  label: "Drainage Block Fix",
			  price: 399,
			  unit: "point",
			  limit: 5,
			  image: "/img/services/plumber/drainage_block.jpg",
			  includes: [
				"Drain blockage inspection",
				"Basic unclogging support",
				"Flow check after service",
			  ],
			  excludes: [
				"Full drainage line replacement",
				"Sewage reconstruction",
				"Motor machine replacement",
			  ],
			},
		  ],
		},
	  },
	},

	"outdoor-services": {
	  label: "Outdoor Services",
	  services: {
		"gardening-service": {
		  label: "Gardening Service",
		  description:
			"Post your gardening requirements for home, terrace, backyard, or commercial garden maintenance.",
		  requirementFields: {
			gardenTypes: [
			  { value: "home-garden", label: "Home Garden" },
			  { value: "terrace-garden", label: "Terrace Garden" },
			  { value: "backyard-garden", label: "Backyard Garden" },
			  { value: "office-garden", label: "Office / Commercial Garden" },
			],
			propertySizes: [
			  { value: "small", label: "Small Area" },
			  { value: "medium", label: "Medium Area" },
			  { value: "large", label: "Large Area" },
			],
			serviceNeeds: [
			  {
				value: "planting",
				label: "Planting",
				price: 150,
				unit: "task",
				limit: 10,
				image: "/img/services/gardening/planting.jpg",
				includes: ["Basic planting support", "Pot or soil placement", "Plant handling help"],
				excludes: ["Plant supply", "Landscape design", "Large tree planting"],
			  },
			  {
				value: "watering",
				label: "Watering",
				price: 100,
				unit: "task",
				limit: 10,
				image: "/img/services/gardening/watering.jpg",
				includes: ["Routine watering", "Basic plant care visit", "Light maintenance support"],
				excludes: ["Irrigation setup", "Pipe installation", "Water storage supply"],
			  },
			  {
				value: "grass-cutting",
				label: "Grass Cutting",
				price: 200,
				unit: "task",
				limit: 5,
				image: "/img/services/gardening/grass_cutting.jpg",
				includes: ["Lawn trimming", "Visible overgrowth cleaning", "Basic finishing"],
				excludes: ["Landscape redesign", "Heavy root removal", "Machine repair"],
			  },
			  {
				value: "weed-removal",
				label: "Weed Removal",
				price: 180,
				unit: "task",
				limit: 5,
				image: "/img/services/gardening/weed_removal.jpg",
				includes: ["Visible weed removal", "Basic garden cleanup", "Surface cleaning support"],
				excludes: ["Chemical treatment", "Soil replacement", "Pest control"],
			  },
			],
		  },
		},

		"packers-movers": {
			label: "Packers & Movers",
			types: [
				{
				value: "pickup-8ft",
				label: "Pickup 8ft",
				price: 300,
				unit: "trip",
				limit: 10,
				capacity: "1250 kg",
				dimensions: {
					length: "8 ft",
					height: "5.5 ft"
				},
				image: "/img/services/packers/pickup_8ft.jpg",
				includes: [
					"Pickup vehicle",
					"Driver charges",
					"Loading assistance",
					"Basic transportation"
				],
				excludes: [
					"Packing materials",
					"Extra labour charges",
					"Multiple trips",
					"Intercity toll charges"
				]
				},

				{
				value: "truck-1-7-ton",
				label: "1.7 Ton Truck",
				price: 380,
				unit: "trip",
				limit: 10,
				capacity: "1700 kg",
				dimensions: {
					length: "9 ft",
					height: "6.1 ft"
				},
				image: "/img/services/packers/1_7_ton.jpg",
				includes: [
					"Vehicle with driver",
					"Loading support",
					"Transportation"
				],
				excludes: [
					"Packing materials",
					"Heavy machinery movement",
					"Toll and parking charges",
					"Additional unloading labour"
				]
				},

				{
				value: "mini-truck",
				label: "Mini Truck",
				price: 550,
				unit: "trip",
				limit: 10,
				capacity: "2500 kg",
				dimensions: {
					length: "12 ft",
					height: "7 ft"
				},
				image: "/img/services/packers/mini_truck.jpg",
				includes: [
					"Vehicle",
					"Driver",
					"Basic loading support"
				],
				excludes: [
					"Packing boxes",
					"Furniture dismantling",
					"Long-distance permit charges"
				]
				},

				{
				value: "large-truck",
				label: "Large Truck",
				price: 900,
				unit: "trip",
				limit: 10,
				capacity: "5000 kg",
				dimensions: {
					length: "16 ft",
					height: "8 ft"
				},
				image: "/img/services/packers/large_truck.jpg",
				includes: [
					"Large transport vehicle",
					"Driver",
					"Loading assistance"
				],
				excludes: [
					"Premium packing materials",
					"Insurance",
					"Interstate permits"
				]
				},

				{
				value: "full-home-shifting",
				label: "Full Home Shifting",
				price: 3500,
				unit: "service",
				limit: 1,
				image: "/img/services/packers/full_home_shift.jpg",
				includes: [
					"Packing materials",
					"Loading and unloading",
					"Transportation",
					"Furniture handling"
				],
				excludes: [
					"Storage charges",
					"Special fragile item insurance"
				]
				}
			]
			},

		"house-keeping": {
		  label: "House Keeping",
		  types: [
			{
			  value: "sweeping",
			  label: "Sweeping",
			  price: 1500,
			  unit: "room",
			  limit: 3,
			  image: "/img/services/housekeeping/sweeping.jpg",
			  includes: ["Floor sweeping", "Dust collection", "Basic corner cleaning"],
			  excludes: ["Deep stain removal", "Furniture shifting", "Waste disposal outside premises"],
			},
			{
			  value: "mopping",
			  label: "Mopping",
			  price: 1500,
			  unit: "room",
			  limit: 3,
			  image: "/img/services/housekeeping/mopping.jpg",
			  includes: ["Wet floor cleaning", "Surface wipe", "Basic hygiene finish"],
			  excludes: ["Chemical polishing", "Marble restoration", "Water damage treatment"],
			},
			{
			  value: "dusting",
			  label: "Dusting",
			  price: 1500,
			  unit: "room",
			  limit: 3,
			  image: "/img/services/housekeeping/dusting.jpg",
			  includes: ["Furniture dusting", "Shelf cleaning", "Visible cobweb removal"],
			  excludes: ["High-rise glass cleaning", "Electronics dismantling", "Wall repainting"],
			},
			{
			  value: "bathroom-cleaning-support",
			  label: "Bathroom Cleaning Support",
			  price: 1500,
			  unit: "bathroom",
			  limit: 3,
			  image: "/img/services/bathroom/mirror_cleaning.jpg",
			  includes: ["Basic bathroom wash", "Floor and wall wipe", "Fittings cleaning"],
			  excludes: ["Plumbing work", "Tile replacement", "Permanent stain treatment"],
			},
			{
			  value: "kitchen-cleaning-support",
			  label: "Kitchen Cleaning Support",
			  price: 1500,
			  unit: "kitchen",
			  limit: 3,
			  image: "/img/services/kitchen/kitchen_cleaning.jpg",
			  includes: ["Counter cleaning", "Visible grease cleaning", "Basic surface wipe"],
			  excludes: ["Appliance repair", "Cabinet carpentry", "Pest control"],
			},
		  ],
		},

		"painter": {
			label: "Painter",
			types: [
				{
				value: "interior-painting",
				label: "Interior Painting",
				price: 18,
				unit: "sqft",
				limit: 10000,
				image: "/img/services/painter/interior_painting.jpg",
				includes: [
					"Wall surface preparation",
					"Putty touch-up",
					"Primer coating",
					"Standard paint application",
					"Basic cleanup after work"
				],
				excludes: [
					"Major wall crack repairs",
					"False ceiling installation",
					"Waterproofing treatment",
					"Premium designer textures"
				]
				},

				{
				value: "exterior-painting",
				label: "Exterior Painting",
				price: 25,
				unit: "sqft",
				limit: 15000,
				image: "/img/services/painter/exterior_painting.jpg",
				includes: [
					"Exterior wall cleaning",
					"Surface preparation",
					"Primer coating",
					"Weather-resistant paint application",
					"Basic finishing"
				],
				excludes: [
					"Scaffolding charges",
					"Structural repairs",
					"Water leakage treatment",
					"Exterior lighting work"
				]
				},

				{
				value: "texture-painting",
				label: "Texture Painting",
				price: 40,
				unit: "sqft",
				limit: 10000,
				image: "/img/services/painter/texture_painting.jpg",
				includes: [
					"Designer texture application",
					"Surface preparation",
					"Premium finish"
				],
				excludes: [
					"Wall repairs",
					"Custom artwork",
					"Structural modifications"
				]
				},

				{
				value: "wall-putty",
				label: "Wall Putty Application",
				price: 8,
				unit: "sqft",
				limit: 15000,
				image: "/img/services/painter/wall_putty.jpg",
				includes: [
					"Wall leveling",
					"Surface smoothing",
					"Putty application"
				],
				excludes: [
					"Painting work",
					"Crack filling beyond minor repairs"
				]
				},

				{
				value: "primer-coating",
				label: "Primer Coating",
				price: 5,
				unit: "sqft",
				limit: 15000,
				image: "/img/services/painter/primer.jpg",
				includes: [
					"Surface preparation",
					"Primer application"
				],
				excludes: [
					"Final paint coating",
					"Wall repairs"
				]
				}
			]
			},

		"drinking-water-supply": {
		  label: "Drinking Water Supply",
		  description:
			"Book packaged drinking water supply by bottle size and quantity.",
		  supplyTypes: [
			{
			  value: "300ml",
			  label: "300ml Water Supply",
			  price: 1000,
			  unit: "bottles",
			  min: 500,
			  limit: 10000,
			  image: "/img/services/water/300ml.jpg",
			  includes: ["Packaged drinking water supply", "Bulk delivery support", "Quantity-based supply"],
			  excludes: ["Cooling service", "Storage rack setup", "Event staff support"],
			},
			{
			  value: "500ml",
			  label: "500ml Water Supply",
			  price: 1000,
			  unit: "bottles",
			  min: 500,
			  limit: 10000,
			  image: "/img/services/water/500ml.jpg",
			  includes: ["Packaged drinking water supply", "Bulk delivery support", "Quantity-based supply"],
			  excludes: ["Cooling service", "Storage rack setup", "Event staff support"],
			},
			{
			  value: "1ltr",
			  label: "1 Ltr Water Supply",
			  price: 1000,
			  unit: "bottles",
			  min: 500,
			  limit: 10000,
			  image: "/img/services/water/1ltr.jpg",
			  includes: ["Packaged drinking water supply", "Bulk delivery support", "Quantity-based supply"],
			  excludes: ["Cooling service", "Storage rack setup", "Event staff support"],
			},
			{
			  value: "2ltr",
			  label: "2 Ltr Water Supply",
			  price: 1000,
			  unit: "bottles",
			  min: 500,
			  limit: 10000,
			  image: "/img/services/water/2ltr.jpg",
			  includes: ["Packaged drinking water supply", "Bulk delivery support", "Quantity-based supply"],
			  excludes: ["Cooling service", "Storage rack setup", "Event staff support"],
			},
			{
			  value: "5ltr",
			  label: "5 Ltr Water Supply",
			  price: 1000,
			  unit: "cans",
			  min: 500,
			  limit: 10000,
			  image: "/img/services/water/5ltr.jpg",
			  includes: ["Packaged drinking water supply", "Bulk can delivery", "Quantity-based supply"],
			  excludes: ["Cooling service", "Storage rack setup", "Event staff support"],
			},
			{
			  value: "20ltr",
			  label: "20 Ltr Water Supply",
			  price: 1000,
			  unit: "cans",
			  min: 500,
			  limit: 10000,
			  image: "/img/services/water/20ltr.jpg",
			  includes: ["Packaged drinking water can supply", "Bulk delivery", "Commercial quantity support"],
			  excludes: ["Dispenser rental", "Storage stand supply", "Event service staff"],
			},
		  ],
		},
	  },
	},


	"cleaning-services": {
	  label: "Cleaning Services",
	  services: {
		"sump-and-tank-cleaner": {
		  label: "Sump and Tank Cleaner",
		  description:
			"Book sump and tank cleaning services for residential or commercial properties.",
		  cleaningTypes: [
			{
			  value: "underground-sump-cleaning",
			  label: "Underground Sump Cleaning",
			  price: 1500,
			  unit: "job",
			  limit: 5,
			  image: "/img/services/tank/underground_sump.jpg",
			  includes: ["Sump cleaning", "Sludge removal", "Basic wash support"],
			  excludes: ["Structural repair", "Motor repair", "Pipeline replacement"],
			},
			{
			  value: "overhead-tank-cleaning",
			  label: "Overhead Tank Cleaning",
			  price: 1200,
			  unit: "job",
			  limit: 5,
			  image: "/img/services/tank/overhead_tank.jpg",
			  includes: ["Tank wash cleaning", "Sediment removal", "Basic hygiene cleaning"],
			  excludes: ["Crack repair", "Tank replacement", "Pipe modification"],
			},
			{
			  value: "plastic-tank-cleaning",
			  label: "Plastic Tank Cleaning",
			  price: 1000,
			  unit: "job",
			  limit: 5,
			  image: "/img/services/tank/plastic_tank.jpg",
			  includes: ["Plastic tank interior cleaning", "Basic sediment removal", "Wash support"],
			  excludes: ["Tank repair", "Pipe replacement", "New fitting installation"],
			},
			{
			  value: "cement-tank-cleaning",
			  label: "Cement Tank Cleaning",
			  price: 1800,
			  unit: "job",
			  limit: 5,
			  image: "/img/services/tank/cement_tank.jpg",
			  includes: ["Cement tank cleaning", "Inner wash support", "Basic sludge removal"],
			  excludes: ["Civil repair", "Waterproofing", "Reconstruction work"],
			},
			{
			  value: "water-pipeline-cleaning",
			  label: "Water Pipeline Cleaning",
			  price: 2000,
			  unit: "job",
			  limit: 3,
			  image: "/img/services/tank/pipeline_cleaning.jpg",
			  includes: ["Basic pipeline cleaning support", "Flow cleaning process", "Service inspection"],
			  excludes: ["Pipeline replacement", "Wall breaking", "Pump repair"],
			},
			{
			  value: "full-sump-tank-cleaning",
			  label: "Full Sump + Tank Cleaning",
			  price: 2500,
			  unit: "job",
			  limit: 3,
			  image: "/img/services/tank/full_cleaning.jpg",
			  includes: ["Combined sump and tank cleaning", "Wash support", "Sediment removal"],
			  excludes: ["Repair work", "New fittings", "Civil modifications"],
			},
		  ],
		},
	  },
	},

	"transport-services": {
	  label: "Transport Services",
	  services: {
		cardriver: {
		  label: "Car Driver",
		  seating_models: [
			{
			  value: "4-seater",
			  label: "4 Seater",
			  models: [
				{ value: "dzire", label: "Swift Dzire" },
				{ value: "toyota-etios", label: "Toyota Etios" },
			  ],
			},
			{
			  value: "7-seater",
			  label: "7 Seater",
			  models: [
				{ value: "scorpio", label: "Mahindra Scorpio" },
				{ value: "innova", label: "Toyota Innova" },
				{ value: "innova-crysta", label: "Toyota Innova Crysta" },
			  ],
			},
			{
			  value: "11-seater",
			  label: "11 Seater",
			  models: [
				{ value: "tt", label: "TT" },
				{ value: "urbania", label: "Force Urbania" },
			  ],
			},
		  ],
		  types: [
			{
			  value: "only_driver",
			  label: "Only Driver",
			  price: 499,
			  unit: "trip",
			  limit: 1,
			  image: "/img/services/driver/only_driver.jpg",
			  includes: ["Driver service only", "Trip-based support", "Basic pickup service"],
			  excludes: ["Vehicle supply", "Fuel charges", "Night allowance unless mentioned"],
			},
			{
			  value: "driver_with_car",
			  label: "Driver With Vehicle",
			  price: 1499,
			  unit: "trip",
			  limit: 1,
			  image: "/img/services/driver/driver_with_car.jpg",
			  includes: ["Driver with vehicle", "Trip-based transport support", "Pickup and drop service"],
			  excludes: ["Toll charges unless mentioned", "Outstation stay allowance", "Extra waiting charges"],
			},
		  ],
		},
		   "packers-and-movers": {
      label: "Packers and Movers",
      types: [
        {
          value: "house-shifting",
          label: "House Shifting",
          price: 2499,
          unit: "job",
          limit: 10,
          image: "/img/services/packers/house-shifting.jpg",
          includes: [
            "Packing support",
            "Loading and unloading",
            "Basic item shifting"
          ],
          excludes: [
            "No dismantling unless mentioned",
            "No electrical fitting"
          ]
        },
        {
          value: "office-shifting",
          label: "Office Shifting",
          price: 3999,
          unit: "job",
          limit: 10,
          image: "/img/services/packers/office-shifting.jpg",
          includes: [
            "Office equipment shifting",
            "Packing and moving support",
            "Loading and unloading"
          ],
          excludes: [
            "No server installation",
            "No furniture repair"
          ]
        }
      ]
    }
	  },
	},
};
